<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<!-- <n-link :to="{name: 'bangkok-hub'}">
									รวมโครงการ{{ location }}
								</n-link> -->
								<v-btn
									color="red"
									class="px-0"
									height="auto"
									exact
									x-large
									text
									:to="{name: 'bangkok-hub'}"
								>
									รวมโครงการ{{ location }}
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span v-if="params.category === 'singlehome'">
									บ้านเดี่ยว
								</span>
								<span v-else-if="params.category === 'townhome'">
									ทาวน์โฮม
								</span>
								<span v-else-if="params.category === 'condo'">
									คอนโด
								</span>
								<span v-else-if="params.category === 'shophouse'">
									อาคารพาณิชย์
								</span>
							</div>
							<div class="search-filter">
								<h1>
									รวมโครงการ{{ location }}
								</h1>

								<div class="pl-3 pr-5">
									<h2 v-if="params.category === 'singlehome'">
										บ้านเดี่ยว
									</h2>
									<h2 v-else-if="params.category === 'townhome'">
										ทาวน์โฮม
									</h2>
									<h2 v-else-if="params.category === 'condo'">
										คอนโด
									</h2>
									<h2 v-else-if="params.category === 'shophouse'">
										อาคารพาณิชย์
									</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container>
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="d-flex">
							<div class="px-4">
								<img
									:src="`/images/2.0/icon/${params.category}_i.png`"
									width="64"
								>
							</div>
							<div class="py-4">
								<template v-if="content === 'singlehome'">
									<h1 class="red--text">
										รวมโครงการ บ้านเดี่ยวกรุงเทพ บ้านเดี่ยวมือสอง บ้านจัดสรร ซื้อ ขาย ราคาถูก
									</h1>
									<p class="mt-4">
										ซื้อ-ขายบ้านเดี่ยวกรุงเทพ บ้านเดี่ยวมือสองกรุงเทพ หลากหลายทำเล หลากหลายราคา ทั้งบ้านในกรุงเทพชั้นใน ย่านธุรกิจ บ้านจัดสรรในกรุงเทพชั้นนอก มีทั้งแบบพร้อมอยู่ ตกแต่งบางส่วน ห้องเปล่า ในราคาถูก คนที่หาซื้อบ้านในกรุงเทพฯ ไม่อยากพลาดบ้านที่ถูกใจ ลองมาเลือกซื้อโครงการบ้านในกรุงเทพกับเรา พร้อมคำนวณสินเชื่อด้วยโปรแกรมที่ใช้งานง่าย หรือจบปัญหาขายบ้านไม่ได้ ด้วยทีมขายที่จะคอยแนะนำคุณที่นี่ที่เดียว
									</p>
								</template>

								<template v-else-if="content === 'townhome'">
									<h1 class="red--text">
										รวมประกาศซื้อ-ขาย ทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										สนใจทาวน์โฮมกรุงเทพ หรือทาวน์เฮ้าส์กรุงเทพ ไม่ว่าจะเป็นโซนไหน สามารถเลือกราคาที่คุณต้องการได้ พร้อมเลือกทาวน์โฮมกรุงเทพ ราคาถูกที่ถูกใจ ทั้งใกล้สิ่งอำนวยความสะดวก เดินทางง่าย สภาพดี หรืออยากลองคำนวณสินเชื่อ ก็มีโปรแกรมฟรีให้ทดลองใช้ เพื่อให้คุณวางแผนซื้อทาวน์โฮมกรุงเทพได้ตามต้องการ หรือถ้าต้องการฝากขาย ก็มีทีมงานฝ่ายขายมืออาชีพช่วยดูแลและให้คำแนะนำจนปิดการขายได้เลย
									</p>
								</template>

								<template v-else-if="content === 'condo'">
									<h1 class="red--text">
										รวมประกาศ ซื้อ ขาย โครงการ คอนโดกรุงเทพ คอนโดมิเนียม  มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										คอนโดกรุงเทพ ถือเป็นอสังหาฯ ประเภทหนึ่งที่น่าจับจอง เพราะนอกจากจะเป็นที่อยู่อาศัยที่มักจะก่อสร้างในย่านที่เดินทางสะดวก ในแนวรถไฟฟ้าแล้ว ยังเป็นอสังหาฯ ที่มีราคาจับต้องได้ ใครที่หาคอนโด ปี 2565 โดยเฉพาะคอนโดมือสองสภาพดี ในราคาที่ถูกใจ ต้องอย่าลืมค้นหาที่ The Best Property เพราะเรารวบรวมคอนโดทำเลดีไว้ในเว็บไซต์เดียว พร้อมมีโปรแกรมคำนวณสินเชื่อให้ใช้ฟรี หรืออยากลงประกาศขายคอนโดและให้ทีมขายมืออาชีพช่วยขายก็ได้เช่นกัน
									</p>
								</template>

								<template v-else-if="content === 'shophouse'">
									<h1 class="red--text">
										ประกาศ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์กรุงเทพ ตึกแถว มือสอง ทำเลค้าขาย
									</h1>
									<p class="mt-4">
										รวมประกาศขายอาคารพาณิชย์กรุงเทพ ตึกแถวให้เช่ากรุงเทพ ทั้งตึกแถว 2 ชั้น ตึกพาณิชย์ 3 ชั้น หรืออาคารพาณิชย์ 4 ชั้น ทุกทำเลของกรุงเทพมหานคร ให้คุณค้นหาอาคารพาณิชย์สวยๆ ในเมืองที่ถูกใจได้ง่ายๆ ค้นหาตัวแทนช่วยหาตึกแถวได้ พร้อมโปรแกรมคำนวณสินเชื่อใช้งานได้ฟรี หรือถ้าต้องการขาย-เซ้งตึกแถว THE BEST PROPERTY มีบริการนายหน้ามืออาชีพแบบครบวงจร เพียงแค่ฝากขาย เรื่องหาลูกค้าให้เป็นหน้าที่เรา
									</p>
								</template>

								<template v-else-if="content === 'ratchaphruek'">
									<h1 class="red--text">
										บ้านราชพฤกษ์ โครงการใหม่ ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม
									</h1>
									<p class="mt-4">
										หากพูดถึงเขตที่อยู่อาศัยหมู่บ้านราชพฤกษ์ บ้านเดี่ยว ทาวน์โฮม และบ้านมือสองแถวโซนพระราม5 บ้านราชพฤกษ์เป็นหนึ่งในทำเลทองที่หลายคนให้ความสนใจ เพราะเป็นทำเลที่เดินทางสะดวก ไม่ว่าจะเป็นการเข้าเมือง หรือ ออกต่างจังหวัด พร้อมทั้งมีการพัฒนาเพิ่มการเดินรถไฟฟ้าในเขตราชพฤกษ์ ทำให้บ้านราชพฤกษ์สามารถตอบโจทย์ทุกความต้องการไลฟ์สไตล์ของคนยุคใหม่ ส่งผลให้บ้านราชพฤกษ์กลายเป็นโซนที่มีอัตราการเติบโตอย่างก้าวกระโดด
									</p>
								</template>

								<template v-else-if="content === 'rama-2'">
									<h1 class="red--text">
										บ้านพระราม2 รวมโครงการ ซื้อ ขาย ทาวน์โฮม บ้านเดี่ยว บ้านมือสอง
									</h1>
									<p class="mt-4">
										บ้านพระราม 2 จัดเป็นพื้นที่ที่ผู้คนเดินทางเข้า-ออกตัวเมืองยอดนิยมอีกหนึ่งเส้นทาง มีศูนย์การค้า สถาบันการศึกษา และแหล่งขนส่งทั่วทิศ ทำให้มีโครงการบ้านพระราม 2 ใหม่ๆ ในราคาไม่ถึง 2 ล้านเปิดให้ลูกค้าจับจองเป็นเจ้าของมากมาย ซึ่งย่านพระราม 2 มีความโดดเด่นด้านไหน? เพราะเขตบางขุนเทียนเป็นทำเลที่กำลังพัฒนาให้มีความเจริญใกล้เคียงกับตัวเมืองหลวงมากขึ้น จะมีย่านช้อปปิ้ง กับขนส่งสาธารณะสำคัญในอนาคตชื่อสถานีอะไรบ้าง? สามารถรับชมคอนเทนต์บ้านพระราม 2 ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'ladprao'">
									<h1 class="red--text">
										บ้านลาดพร้าว โครงการใหม่ ขาย บ้านเดี่ยว ทาวน์โฮม บ้านมือสอง ย่านลาดพร้าว
									</h1>
									<p class="mt-4 mb-0">
										ปัจจุบันย่านลาดพร้าวเป็นที่มีความคึกคักและเป็นเขตเศรษฐกิจหนึ่งที่นักลงทุนและคนทั่วไปให้ความสนใจในกรุงเทพฯ ซึ่งเป็นทั้งเขตที่อยู่อาศัย ที่มีทั้งบ้านลาดพร้าว โครงการใหม่ บ้านมือสอง และคอนโด แหล่งช้อปปิ้งที่มีศูนย์การค้าขนาดใหญ่ ออฟฟิศทำงานของบริษัทเล็กไปจนถึงบริษัทใหญ่ และขนส่งมวลชนที่พร้อมให้บริการ
									</p>
									<p class="mt-2">
										ซึ่งในปัจจุบันโครงการรถไฟฟ้า BTS สายสีเขียวอ่อนส่วนต่อขยายมาถึงย่านลาดพร้าวเป็นที่เรียบร้อย ทำให้หลายคนตัดสินใจซื้อหมู่บ้านลาดพร้าว เพราะการเดินทางที่สะดวกสบายมากขึ้น และเป็นย่านที่ใกล้เมืองมากที่สุด เหมาะสำหรับคนทำงานในตัวเมือง ครอบครัวที่มีลูกที่ต้องไปโรงเรียนในกลางเมืองทุก ๆ เช้า  หรือ ผู้ที่มีไลฟ์สไตล์การใช้ชีวิตแบบคนเมือง
									</p>
								</template>

								<template v-else-if="content === 'phaholyothin'">
									<h1 class="red--text">
										บ้านพหลโยธิน บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม โครงการใหม่ ใกล้รถไฟฟ้า
									</h1>
									<p class="mt-2">
										ถ้าเลือกซื้อบ้านสักหลังในกรุงเทพ แน่นอนว่าใคร ๆ ก็อยากอยู่เส้นรถไฟฟ้า เนื่องจากเดินทางได้ง่ายและสะดวกมาก โดยย่านพหลโยธินเต็มไปด้วยเส้นทางรถไฟฟ้าหลายสาย อีกทั้งในอนาคตย่านบ้านพหลโยธินจะมีการเพิ่มสายรถไฟฟ้าด้วยเช่นกัน นอกจากนี้ยังมีศูนย์การค้าอีกเป็นจำนวนมากรายล้อมอยู่ในหลายพื้นที่ รวมไปถึงมีสถานศึกษา โรงพยาบาลและสิ่งอำนวยความสะดวกอื่น ๆ ที่ไม่ต้องเดินทางไกลออกนอกพื้นที่เพื่อไปหาสิ่งเหล่านั้น โดยย่านนี้มีโครงการบ้านพหลโยธินให้เลือกหลากหลายรูปแบบอีกด้วย ดังนั้นเราอยากให้คุณได้ลองเลือกชมบ้านในย่านพหลโยธินก่อนจะตัดสินใจเลือกซื้อบ้านที่อยู่ย่านอื่น ๆ
									</p>
								</template>

								<template v-else-if="content === 'ramintra'">
									<h1 class="red--text">
										บ้านรามอินทรา โครงการใหม่ บ้านเดี่ยว บ้านมือสอง ทำเลคุณภาพ
									</h1>
									<p class="mt-2">
										สำหรับใครที่มีแพลนจะย้ายที่อยู่อาศัยและต้องการซื้อบ้านเดี่ยว บ้านแฝด ทาวน์เฮ้าส์ หรือคอนโด ที่ถูกรายล้อมไปด้วยสิ่งอำนวยความสะดวกไม่ว่าจะเป็นห้างสรรพสินค้าชั้นนำ โรงเรียน โรงพยาบาล รถไฟฟ้าสายสีชมพู แถมยังไม่ไกลจากใจกลางเมืองกรุงเทพ เดินทางเข้าเมืองสะดวก เราขอแนะนำบ้านรามอินทรา ซึ่งหมู่บ้านรามอินทราเหมาะสำหรับคนที่มีไลฟ์สไตล์ชิล ๆ ไม่เร่งรีบ และไม่ชอบความแออัด ใช้ชีวิตง่าย เดินทางสะดวก แต่ก็ยังไม่ทิ้งความเจริญ
									</p>
								</template>

								<template v-else-if="content === 'lat-krabang'">
									<h1 class="red--text">
										บ้านลาดกระบัง รวมโครงการบ้านเดี่ยว ทาวน์โฮม ใกล้สนามบิน
									</h1>
									<p class="mt-2 mb-0">
										บ้านลาดกระบังเป็นอีกหนึ่งย่านที่กำลังได้รับความสนใจจากผู้พักอาศัยในกรุงเทพ ด้วยสภาพความแออัดภายในตัวเมืองกรุงเทพ รวมถึงการขยายตัวของสิ่งอำนวยความสะดวกต่าง ๆ มาสู่บ้านแถวลาดกระบัง และหมู่บ้านแถวร่มเกล้าทั้งรถไฟฟ้าแอร์พอร์ต เรล ลิงก์ โรงเรียน มหาวิทยาลัย ห้างสรรพสินค้า ร้านอาหารชื่อดังต่าง ๆ รวมถึงย่านแถวลาดกระบังก็ยังใกล้กับสนามบินสุวรรณภูมิ ทำให้โครงการบ้านลาดกระบังเป็นย่านที่เหมาะกับผู้อยู่อาศัยที่ชอบเดินทางท่องเที่ยวนั่นเอง
									</p>
									<p class="mt-2">
										ไม่เพียงแค่บ้านเดี่ยว ทาวน์โฮม ทาวน์เฮ้าส์ เท่านั้น ที่มีโครงการใหม่ ๆ สร้างขึ้นในย่านลาดกระบัง แต่รวมถึงที่พักอาศัยประเภทคอนโดก็มีจำนวนไม่น้อยเลยที่เข้ามาตัดสินใจลงทุนในย่านนี้ และที่สำคัญในย่านลาดกระบังยังมีแนวโน้มที่จะมีการขยายตัวของสิ่งอำนวยความสะดวก และเส้นทางคมนาคมมากยิ่งขึ้น จึงนับได้ว่าการซื้อ - ขาย บ้านลาดกระบัง คอนโดลาดกระบัง เป็นอีกหนึ่งทางเลือกที่น่าสนใจได้การลงทุน
									</p>
								</template>

								<template v-else-if="content === 'saimai'">
									<h1 class="red--text">
										บ้านสายไหม รวมโครงการ หมู่บ้านย่านสายไหม ตอบโจทย์ทุกการใช้ชีวิต
									</h1>
									<p class="mt-2 mb-0">
										บ้านสายไหม หนึ่งในพื้นที่ที่ชื่อคุ้นหูชาวกรุงเทพ แต่หลายคนอาจจะยังไม่รู้จักพื้นที่นี้ดี เพราะแต่เดิมแล้วหมู่บ้านสายไหมอาจจะไม่ได้เป็นบริเวณที่นิยมเท่ากับโซนกรุงเทพชั้นในอย่าง สยาม สีลม สาทร
									</p>
									<p class="mt-2">
										แต่ในปัจจุบันความเจริญภายในกรุงเทพไม่ได้กระจุกตัวอยู่แค่บริเวณเหล่านั้น เริ่มมีการขยายของตัวเมือง การพัฒนาของเส้นทางคมนาคม สิ่งอำนวยความสะดวกต่าง ๆ กระจายตัวออกมาเพิ่มมากขึ้น ทำให้บ้านแถวสายไหมเป็นอีกหนึ่งตัวเลือก สำหรับผู้อยู่อาศัยที่อยากหลีกหนีความวุ่นวาย แออัดจากในตัวเมือง มาใช้ชีวิตที่เงียบสงบ แต่มีสิ่งอำนวยความสะดวกรอบด้านครบครันไม่ต่างจากใจกลางเมืองเลย
									</p>
								</template>

								<template v-else-if="content === 'onnut'">
									<h1 class="red--text">
										บ้านอ่อนนุช ซื้อ ขาย บ้านเดี่ยว ทาวน์โฮม ครบครันทุกความต้องการ
									</h1>
									<p class="mt-2 mb-0">
										บ้านอ่อนนุชกับอีกหนึ่งย่านที่ตอบโจทย์ไลฟ์สไตล์ชีวิตคนเมืองได้อย่างครบครัน ไม่ว่าจะที่อยู่อาศัยแบบบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม คอนโด หรือบ้านมือสอง บ้านแถวอ่อนนุชก็มีให้คุณเลือกสรรซื้อ - ขายทุกรูปแบบ
									</p>
									<p class="mt-2">
										หนึ่งในเหตุผลที่ทำให้เกิดโครงการบ้านอ่อนนุชขึ้นมาเป็นดอกเห็ด นั่นก็คงหนีไม่พ้นที่ว่าทำเลที่ตั้งของย่านอ่อนนุช หรือสุขุมวิท 77 เป็นส่วนหนึ่งของโซนสุขุมวิทตอนกลาง - ปลาย ซึ่งอยู่ติดกับใจกลางเมืองอย่างย่านสุขุมวิทตอนต้นไม่เท่าไหร่ ทำให้ใครหลาย ๆ คนเลือกที่จะมาจับจองลงทุนในบ้านอ่อนนุชกัน เพราะเมื่อลองพิจารณาดูแล้วจะเห็นได้ว่าหมู่บ้านแถวอ่อนนุชมีศักยภาพในการพัฒนาราคาของที่ดินให้สูงขึ้นได้เรื่อย ๆ ในอนาคต ตามความเจริญเติบโตของสิ่งอำนวยความสะดวกที่ค่อย ๆ เพิ่มขึ้นมาในพื้นที่
									</p>
								</template>

								<template v-else-if="content === 'ramkhamhaeng'">
									<h1 class="red--text">
										รวมโครงการบ้านรามคำแหง บ้านเดี่ยว บ้านมือสอง ครบครันทุกเรื่องของชีวิตคนเมือง
									</h1>
									<p class="mt-2 mb-0">
										บ้านรามคำแหง ทำเลทองสุดฮอตในย่านกรุงเทพฝั่งตะวันออก สำหรับใครที่กำลังมองหาที่อยู่อาศัย ไม่ว่าจะเป็นบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม หรือคอนโด ทั้งมือหนึ่ง และมือสอง บอกได้คำเดียวเลยว่าคุณจะไม่ผิดหวัง
									</p>
									<p class="mt-2">
										เพราะโครงการแถวรามคำแหง บางกะปิเปรียบได้ดั่งขุมสมบัติของชาวกรุงเทพ มีสิ่งอำนวยความสะดวกครบครัน ตอบสนองทุกความต้องการของชาวกรุงเทพ ตั้งแต่ห้างสรรพสินค้าเอาใจสายช้อปปิ้ง หรือจะเป็นสเตเดียมฮอลล์ ถูกใจสายคอนเสิร์ต ไม่ว่าไลฟ์สไตล์แบบไหน บ้านรามคำแหงจะช่วยเติมเต็มชีวิตของคุณให้สะดวกสบายมากยิ่งขึ้น
									</p>
								</template>

								<template v-else-if="content === 'phra-ram-nine'">
									<h1 class="red--text">
										บ้านพระราม 9 ย่านคนติดเมือง เที่ยว ช้อป ทำงาน ตอบโจทย์พักอาศัย
									</h1>
									<p class="mt-2">
										ใครกำลังตามหาบ้านกรุงเทพที่อยู่อาศัยใหม่ในเมือง ที่มีศูนย์ให้บริการรักษา คมนาคม แหล่งช้อปปิ้งในยามกลางวันและยามกลางคืนตลอด 24 ชม. ต้องมาที่ บ้านพระราม 9 แหล่ง NEW CBD (New Central Business District) วิถีคนเมืองชอบนอนดึก สายปาร์ตี้ จะมีแหล่งอำนวยความสะดวกแก่การดำเนินชีวิตอะไรบ้าง ดูเนื้อหาเพิ่มเติมได้ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'min-buri'">
									<h1 class="red--text">
										บ้านมีนบุรี เขตชานเมืองฝั่งตะวันออก น่าอยู่ ศักยภาพการพัฒนาสูง
									</h1>
									<p class="mt-2">
										ใครกำลังตามหาบ้านในกรุงเทพฯ ที่ไม่ห่างไกลจากตัวเมืองมาก ลองดูเขตบ้านมีนบุรี ย่านทำเลพื้นที่อยู่อาศัยที่ล้อมรอบด้วยพื้นที่เกษตรกรรม เป็นหนึ่งในชุมชนที่มีศักยภาพในการพัฒนาในอนาคต จะมีแหล่งอำนวยความสะดวกแก่การดำเนินชีวิตอะไรบ้าง ดูเนื้อหาเพิ่มเติมได้ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'suanluang'">
									<h1 class="red--text">
										บ้านสวนหลวง ชานเมืองตะวันออก น่าอยู่ไม่แพ้ตัวเมือง
									</h1>
									<p class="mt-2">
										ใครตามหาบ้านในกรุงเทพฯ ที่ไม่ห่างไกลจากตัวเมืองมาก ลองดูเขตบ้านสวนหลวง ชานเมืองตะวันออก ย่านทำเลพื้นที่อยู่อาศัยที่ล้อมรอบด้วยถนนเชื่อมเข้า-ออกตัวเมืองและต่างจังหวัดได้หลากหลายเส้นทาง แล้วจะเป็นมีแนวรถไฟฟ้าสีเหลืองที่จะเปิดภายในปีนี้ จะมีแหล่งอำนวยความสะดวกแก่การดำเนินชีวิตอะไรบ้าง ดูเนื้อหาเพิ่มเติมได้ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'prakanong'">
									<h1 class="red--text">
										บ้านพระโขนง ทำเลศักยภาพ ใกล้เมือง เดินทางสะดวก
									</h1>
									<p class="mt-2 mb-0">
										บ้านพระโขนง ในปัจจุบัน มีศูนย์การค้า สถาบันการศึกษา และแหล่งขนส่งสาธารณะให้ผู้อาศัยสามารถใช้บริการเข้า-ออกตัวเมืองได้รวดเร็ว ด้วยศักยภาพที่นี่ไม่แพ้การอยู่อาศัยในเมืองเลย จึงมีโครงการขายบ้านพระโขนง ใหม่ๆ อาทิ ทาวน์โฮมพระโขนง ทาวน์เฮ้าส์พระโขนง คอนโดพระโขนง หรือแม้กระทั่งบ้านมือสองพระโขนง ให้ลูกค้าจับจองเป็นเจ้าของมากมาย
									</p>
									<p class="mt-2">
										ซึ่งย่านบ้านพระโขนง มีความโดดเด่นด้านไหน? เพราะเขตพระโขนงเป็นทำเลที่กำลังพัฒนาให้มีความเจริญใกล้เคียงกับตัวเมืองหลวงมากขึ้น จะมีย่านช้อปปิ้งอะไรบ้าง? สามารถรับชมคอนเทนต์บ้านพระโขนง ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'ra-ma-three'">
									<h1 class="red--text">
										บ้านพระราม 3 ซื้อ ขาย บ้านทำเลใกล้เมือง เดินทางสะดวก
									</h1>
									<p class="mt-2 mb-0">
										บ้านพระราม 3 ในปัจจุบัน มีศักยภาพการในอยู่อาศัยที่ไม่แพ้การอยู่อาศัยในใจกลางเมืองเลย ด้วยที่ตั้งที่ติดกับตัวเมืองชั้นใน มีขนส่งสาธารณะอย่างรถด่วน BRT ที่เชื่อมต่อกับเส้นรถไฟฟ้าสายสีลม ให้ผู้อยู่อาศัยเข้าสู่ตัวเมืองได้สบายๆ นอกจากนี้ทางบ้านพระราม 3 ยังมีโครงการรถไฟฟ้าสายสีเทาเส้นใหม่ที่จะเปิดให้บริการในอนาคตตรงเส้นถนนพระราม 3 อีกด้วย
									</p>
									<p class="mt-2">
										ซึ่งย่านบ้านพระราม 3 มีความโดดเด่นด้านไหนบ้าน? เขตพระราม 3 มีย่านช้อปปิ้งอยู่ถนนเส้นไหน? ส่วนย่านที่อยู่อาศัย อาทิ คอนโด ทาวน์โฮม อยู่ในโครงการของเครือข่ายอะไรบ้าง? สามารถดูรายละเอียดเกี่ยวกับบ้านพระราม 3 ได้ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'pinklao'">
									<h1 class="red--text">
										รวมโครงการบ้านปิ่นเกล้า บ้านเดี่ยว ทำเลดีมีรถไฟเปิดถึง 3 สาย
									</h1>
									<p class="mt-2 mb-0">
										บ้านปิ่นเกล้า ในอดีต เป็นชุมชนอีกพื้นที่ที่มีคนอยู่อาศัยกันอย่างหนาแน่น เพราะมีศูนย์สรรพสินค้าขนาดใหญ่ถึง 4 ห้าง เป็นจุดศูนย์กลาง เป็นเขตพื้นที่ที่เดินทางง่ายเพราะมีขนส่งอย่างรถเมล์ แท็กซี่ มาถึงเขตนี้ง่ายๆ โดยสามารถเดินทางลงจาก BTS สถานีอนุสาวรีย์ได้เลย และในอนาคตไม่ไกล ที่นี่จะมีรถไฟฟ้าเปิดใช้บริการถึง 3 สายทำให้คุณเดินทางจากรถไฟโดยตรงได้เลย
									</p>
									<p class="mt-2">
										ซึ่งย่านบ้านปิ่นเกล้า มีความโดดเด่นด้านไหน? เขตบ้านปิ่นเกล้า เป็นทำเลที่กำลังพัฒนาให้มีความเจริญใกล้เคียงกับตัวเมืองหลวงมากขึ้น จะมีย่านช้อปปิ้งอยู่ถนนเส้นไหน ส่วนย่านที่อยู่อาศัย อาทิ คอนโด ทาวน์โฮม อยู่ในโครงการของเครือข่ายอะไรบ้าง? สามารถหาข้อมูลเกี่ยวกับบ้านปิ่นเกล้าได้ ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'ratchadapisek'">
									<h1 class="red--text">
										บ้านรัชดา รวมโครงการบ้านเดี่ยว ทาวน์โฮม บ้านมือสอง ราคาดี
									</h1>
									<p class="mt-2 mb-0">
										บ้านรัชดา หนึ่งในย่านทำเลทองที่ไม่แพ้เขตพื้นที่อื่นในกรุงเทพมหานคร ด้วยโซนนี้เป็นย่านธุรกิจ คอมมูนิตี้มอลล์ รวมไปถึงมีขนส่งสาธารณะอย่าง MRT ให้ผู้อาศัยเดินทางเข้าสู่ใจกลางเมืองและพื้นที่เขตอื่นๆ ได้อย่างง่ายดาย
									</p>
									<p class="mt-2">
										ซึ่งย่านบ้านรัชดา มีความโดดเด่นด้านไหน? เพราะเขตบ้านรัชดาเป็นทำเลที่กำลังพัฒนาให้มีความเจริญใกล้เคียงกับตัวเมืองหลวงมากขึ้น จะมีย่านช้อปปิ้งอะไรบ้าง? สามารถหาข้อมูลเพิ่มเติมก่อนตัดสินใจซื้อบ้านในย่านบ้านรัชดาได้ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'don-mueang'">
									<h1 class="red--text">
										บ้านดอนเมือง รวมบ้านเดี่ยว บ้านมือสอง ขนส่งสะดวก ถึงเขตกทม.
									</h1>
									<p class="mt-2 mb-0">
										บ้านดอนเมือง เป็นในย่านทำเลดีที่ไม่แพ้เขตพื้นที่ในเมืองของกรุงเทพมหานคร ด้วยโซนนี้มีจุดยุทธ์ศาสตร์คือ สนามบินดอนเมือง พร้อมกับรถไฟฟ้าสายสีแดงที่สามารถเชื่อมต่อเข้าสู่พื้นที่ในเมือง อีกทั้งถนนดอนเมืองยังสามารถขับรถส่วนตัวเข้ามาถนนชั้นในกรุงเทพมหานครง่ายๆ ด้วย
									</p>
									<p class="mt-2">
										ย่านบ้านดอนเมือง มีความโดดเด่นด้านไหน? เขตดอนเมืองเป็นพื้นที่ที่มีศักยภาพในการอยู่อาศัยอย่างไรบ้าง? สามารถรับชมคอนเทนต์บ้านดอนเมือง ในบทความนี้
									</p>
								</template>

								<template v-else-if="content === 'prawet'">
									<h1 class="red--text">
										โครงการบ้านประเวศ ย่านน่าอยู่ ทำเลดี เดินทางสะดวก
									</h1>
									<p class="mt-2">
										ใครที่กำลังมองหาบ้านใหม่ทำเลดีราคาไม่สูงมาก เราขอแนะนำบ้านประเวศ ย่านน่าอยู่แถบตะวันออกกรุงเทพที่มีความสะดวกครบครัน ไม่ว่าจะแหล่งชอป ชิม เที่ยวมากมาย ห้างสรรพสินค้าชื่อดังหลากหลาย แถมยังเดินทางเข้า-ออกเมืองจากเขตประเวศได้สะดวกหลายช่องทางอีกด้วย เหมาะสำหรับผู้ที่ชอบการใช้ชีวิตในเมืองแต่อยากได้บ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮมราคาไม่แพง เขตประเวศเป็นอีกคำตอบที่ไม่ควรพลาด
									</p>
								</template>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="category-menu mx-auto px-4 py-8 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'singlehome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'bangkok', params: {category: 'singlehome'}}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'townhome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'bangkok', params: {category: 'townhome'}}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'condo'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'bangkok', params: {category: 'condo'}}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'shophouse'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'bangkok', params: {category: 'shophouse'}}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="px-6 py-0">
				<v-row no-gutters>
					<v-col
						ref="top"
						xl="8"
						class="mx-auto"
					>
						<div
							v-if="area"
							class="text-center red--text mt-n8 pb-4"
							style="position: relative;"
						>
							<b>เลือกทำเล</b>
						</div>
						<v-slide-group
							v-model="areaSelected"
							center-active
							show-arrows
						>
							<template #next>
								<v-icon color="rgb(237,28,36)">
									$next
								</v-icon>
							</template>
							<template #prev>
								<v-icon color="rgb(237,28,36)">
									$prev
								</v-icon>
							</template>

							<v-slide-item
								v-for="(a, i) in area"
								:key="`bangkok-${i}`"
								:value="a.value"
							>
								<v-btn
									class="area mr-2 pa-2"
									elevation="0"
									text
									tile
									:to="a.path"
								>
									{{ a.text }}
								</v-btn>
							</v-slide-item>
						</v-slide-group>

						<v-row class="mt-3">
							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-end pl-md-0 pr-md-6"
							>
								<div class="d-flex justify-center align-center">
									<img
										src="/images/2.0/icon/bed-red.png"
										width="40"
									>
									<b class="mx-3">จำนวนห้องนอน</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 1 } }"
									>
										1
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 2 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 3 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 4 } }"
									>
										4
									</v-btn>
								</div>
							</v-col>

							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-start pl-md-6 pr-md-0"
							>
								<div class="d-flex justify-center  align-center">
									<img
										src="/images/2.0/icon/money-red.png"
										width="40"
									>
									<b class="mx-3">ราคาไม่เกิน(ล้านบาท)</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 2000000 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 3000000 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 4000000 } }"
									>
										4
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 5000000 } }"
									>
										5
									</v-btn>
								</div>
							</v-col>
						</v-row>

						<div
							v-if="empty"
							class="text-center display-3"
						>
							<br><br>
							ไม่พบข้อมูล
							<br><br><br>
						</div>
						<v-row v-else>
							<v-col
								cols="12"
								class="pt-6 pb-4 text-center"
							>
								<h2>
									<span>อสังหา</span>
									<span
										v-if="params.category === 'singlehome'"
										class="red--text"
									>
										บ้านเดี่ยว{{ location }}
									</span>
									<span
										v-else-if="params.category === 'townhome'"
										class="red--text"
									>
										ทาวน์โฮม{{ location }}
									</span>
									<span
										v-else-if="params.category === 'condo'"
										class="red--text"
									>
										คอนโด{{ location }}
									</span>
									<span
										v-else-if="params.category === 'shophouse'"
										class="red--text"
									>
										อาคารพาณิชย์{{ location }}
									</span>
								</h2>
							</v-col>
							<v-col
								v-for="(prop, i) in loading ? parseInt(perPage) : propertyList"
								:key="prop.id || i"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<propertyListItemSkeleton v-if="loading" />
								<propertyListItem
									v-else
									:id="prop.id"
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<template v-if="content === 'singlehome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านเดี่ยวกรุงเทพ บ้านพร้อมอยู่
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									รวมบ้านเดี่ยวกรุงเทพ บ้านเดี่ยวมือสองกรุงเทพ ทั้งบ้านในเมือง บ้านหรู บ้านเดี่ยวกลางเมือง มีทั้งโครงการบ้านกรุงเทพชั้นเดียว 2 ชั้น 3 ชั้น หลากหลายเรตราคาให้คุณได้เลือกสรร เริ่มต้นที่ราคาไม่เกิน 1.5 ล้านบาท ไปจนถึงราคา 40 ล้านบาทขึ้นไป ในย่านยอดฮิต เช่น ย่าน CBD กรุงเทพฯ ชั้นใน ย่านธนบุรี ฯลฯ ให้คุณซื้อ-ขาย ประกาศขายบ้านด่วน หรือเลือกดูบ้านเดี่ยวโครงการใหม่ปี 2565 ในกรุงเทพที่ต้องการได้ในที่เดียว เพื่อให้คุณได้บ้านเดี่ยวราคาถูกในกรุงเทพฯ ที่ดีที่สุด ใกล้แหล่งอำนวยความสะดวก เดินทางง่าย พร้อมสนับสนุนทุกมิติของการใช้ชีวิตอย่างแท้จริง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาโครงการบ้านเดี่ยวกรุงเทพ โซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> เป็นโซนที่มีศักยภาพสูงเพราะอยู่ในเขตธุรกิจ ประกอบด้วย เขตสาทร เขตบางรัก เขตปทุมวัน เขตยานนาวา เขตบางคลองแหลม เขตพระนคร เขตป้อมปราบศัตรูพ่าย และเขตสัมพันธวงศ์ โครงการบ้านใหม่ 2565 ของกรุงเทพในโซนนี้จึงเป็นที่ต้องการและมีราคาสูง อาจจะพุ่งสูงไปถึง 15 ล้าน -50 ล้านบาทได้เลยทีเดียว แต่ถึงแม้จะมีราคาสูงแต่ก็ยังเป็นที่ต้องการอยู่เสมอทั้งสำหรับชายไทยและชาวต่างชาติ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> เป็นโซนที่ราคาที่อยู่อาศัยขยับต่ำลงมากว่าโซน CBD แต่ด้วยการมาถึงของรถไฟฟ้าทำให้ราคาอสังหาฯ ในย่านนี้พุ่งสูงขึ้นเรื่อยๆ ซึ่งโซนนี้จะกินอาณาบริเวณหลายเขตด้วยกัน ได้แก่ เขตบางซื่อ เขตจตุจักร เขตดุสิต เขตพญาไท เขตราชเทวี เขตห้วยขวาง เขตดินแดง เขตลาดพร้าว เขตวังทองหลาง เขตบางกะปิ เขตบึงกุ่มและเขตคันนายาว ทำให้มีรูปแบบบ้านหลากหลายทั้งบ้านเดี่ยวกรุงเทพ บ้านจัดสรร บ้านมือสอง มีราคาเริ่มต้นที่ 2 ล้านไปจนถึงราคา 10 กว่าล้านขึ้นอยู่กับขนาดบ้าน แบรนด์ของผู้พัฒนา และการตกแต่ง
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> จะประกอบไปด้วยเขตธนบุรี เขตบางกอกใหญ่ เขตคลองสาน เขตตลิ่งชัน เขตบางกอกน้อย เขตบางขุนเทียน เขตภาษีเจริญ เขตหนองแขม และเขตราษฎร์บูรณะ ซึ่งเป็นเขตชุมชนเก่า ทำให้ราคาที่อยู่อาศัยในย่านนี้จับต้องได้มากขึ้น โดยราคาบ้านก็จะมีทั้งเรตราคาบ้านเดี่ยวราคาล้านต้นๆ กรุงเทพ ไปจนถึง 10 ล้านบาทขึ้นไป ส่วนราคาบ้านจัดสรรจะเริ่มต้นที่ 3-4 ล้านบาทไปจนถึง 10 ล้านบาทขึ้นไป และทาวน์โฮมจะเริ่มต้นที่ 3-4 ล้านบาท
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> ประกอบไปด้วย เขตหลักสี่ เขตดอนเมือง เขตสายไหม เขตบางเขน เขตคลองสามวาและเขตหนองจอก ถ้าเป็นเขตบางเขน สายไหม ตอนนี้จะมีราคาประเมินที่ดินสูงสุดอยู่ที่ 130,000-250,000 บาท/ตารางวา แต่ส่วนที่มีราคาถูกก็จะอยู่ที่ ตารางวาละ 50,000 บาท ซึ่งก็มีให้เลือกทั้งบ้านเดี่ยว บ้านแฝด บ้านสองชั้น ทาวน์โฮมและทาวน์เฮ้าส์ แถมยังมีให้เลือกหลากหลายขนาดทั้งแบบติดถนน และอยู่ในซอยที่ต้องการความเป็นส่วนตัว
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> ประกอบด้วยเขตมีนบุรี เขตลาดกระบัง เขตสะพานสูง เขตประเวศ เขตสวนหลวง เขตบางนาและเขตพระโขนง โซนนี้ราคาบ้านเดี่ยวกรุงเทพมือสองค่อนข้างหลากหลาย ถ้าอยู่ในโซนที่ใกล้ตัวเมืองก็จะราคาสูงขึ้นมาหน่อย โดยอาจจะยังเห็นบ้านราคาไม่เกิน 4 ล้าน หรือบ้านราคาไม่เกิน 5 ล้านได้ แต่ถ้าขยับออกมาทางฝั่งสมุทรปราการมากขึ้น ก็อาจจะเจอบ้านเดี่ยวราคาไม่เกิน 2 ล้านของกรุงเทพฝั่งตะวันออกได้อยู่เช่นกัน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกโครงการบ้านเดี่ยวกรุงเทพ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยการเลือกซื้อโครงการบ้านเดี่ยวกรุงเทพ
								</h3>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> หมู่บ้านในกรุงเทพที่อยู่ในย่าน CBD จะเป็นที่อยู่อาศัยแนวเน้นความสะดวกสบาย อยู่ใกล้กับแหล่งไลฟ์สไตล์เป็นหลัก อีกทั้งยังเป็นทำเลที่เหมาะสำหรับนักลงทุน เพราะราคาบ้านเดี่ยวไม่ว่าจะเป็น 1 ห้องนอน 2 ห้องนอน 3 ห้องนอน 4 ห้องนอน หรือ 5 ห้องนอนในย่านนี้ล้วนซื้อ-ขายได้ในราคาดี สามารถเก็งกำไรได้ในอนาคต และเป็นที่ต้องการอยู่เสมอ จึงเป็นย่านที่เหมาะสำหรับคนที่ต้องการบ้านเพื่ออยู่อาศัยในเมือง และนำมาเป็นมรดกหรือขายได้ในราคาดีด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> บ้านมือสองกรุงเทพชั้นในจะเป็นโซนที่ได้รับความเจริญที่ขยายตัวออกมาจากย่าน CBD อีกที ทำให้เป็นโซนที่คึกคัก ส่วนใหญ่จะเป็นพื้นที่อยู่อาศัยของพนักงานออฟฟิศ นักศึกษา และคนในชุมชนเดิม จึงทำให้เป็นย่านที่มีความผสมผสานทั้งแหล่งไลฟ์สไตล์ และที่อยู่อาศัยมากกว่าย่าน CBD ที่อาจจะเน้นความเป็นเมืองมากกว่า
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> ใครที่ต้องบ้านเดี่ยวมือสองกรุงเทพในย่านที่มีความเป็นที่อยู่อาศัยสูง เน้นความเงียบสงบของบ้านหลังใหญ่ การเลือกอยู่ฝั่งธนบุรีเป็นทางเลือกที่ตอบโจทย์ไม่น้อย เพราะเป็นทำเลของชุมชนเก่า จึงยังเป็นทำเลที่เงียบ ไม่แออัดมากเท่าเขตเมือง และมีบ้านมือสองกรุงเทพในเขตฝั่งธนบุรีคุณภาพดีให้เลือกจับจองอยู่ค่อนข้างมาก
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> เป็นอีกหนึ่งโซนที่ได้รับความเจริญจากเขตกรุงเทพฯ ชั้นใน ทำให้มีทั้งความเจริญและส่วนที่เป็นที่อยู่อาศัย และเป็นโซนทำเลใหม่ที่รถไฟฟ้าเริ่มเข้าถึงมากขึ้น ทำให้ยังเป็นย่านที่มีศักยภาพพัฒนาไปได้อีกมาก จึงเหมาะสำหรับใครที่ตามหาบ้านเดี่ยวกรุงเทพ ต้องการบ้านที่ประกาศขายบ้านกรุงเทพโดยเจ้าของขายเองในราคาย่อมเยาลงมา ทำให้บ้านในโซนนี้จับต้องได้ง่ายมากยิ่งขึ้น
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> เป็นโซนกรุงเทพฯ ที่มีขนาดบ้านให้เลือกหลากหลาย ทั้งบ้าน 100 ตารางวา บ้าน 200 ตารางวา บ้าน 300 ตารางวา บ้าน 400 ตารางวา เนื่องจากเป็นโซนกรุงเทพฯ ชั้นนอกที่ยังมีพื้นที่ให้พัฒนาโครงการอสังหาฯ ได้อีก และยิ่งในปัจจุบันที่มีรถไฟฟ้าตัดผ่านเข้ามาในทำเล ซึ่งในปัจจุบันเชื่อมต่อไปจนถึงจังหวัดสมุทรปราการแล้ว ทำให้สามารถเข้าถึงความเจริญได้มากขึ้น แต่ก็ยังเลือกซื้อบ้านเดี่ยวกรุงเทพในราคาเอื้อมถึงได้อยู่ด้วย
											</p>

											<h3 class="mt-2">
												การเดินทางโครงการบ้านเดี่ยวกรุงเทพโซนต่างๆ
											</h3>
											<p class="mt-2 mb-0">
												<b>ย่าน CBD</b> สำหรับคนที่อยู่บ้านเดี่ยวในกรุงเทพ การเดินทางในย่านนี้เรียกได้ว่า สะดวกสบายที่สุด ทั้งการเดินทางด้วยรถยนต์ส่วนตัวที่ถ้าไม่ใช่ชั่วโมงเร่งด่วน การเข้า-ออกเมืองถือว่าสะดวกสบายมาก เพราะมีถนนหลักเชื่อมต่อถึงกันหลากหลายสาย เช่น ถนนสุขุมวิท ถนนสาทร ถนนพระรามที่ 4 ถนนวิทยุ เป็นต้น และมีทางด่วนเชื่อมไปยังทั่วทั้งกรุงเทพฯ และจังหวัดใกล้เคียง
											</p>
											<p class="mt-2 mb-0">
												ส่วนการเดินทางด้วยรถไฟฟ้าก็มีรถไฟฟ้าหลากหลายสายวิ่งผ่าน ไม่ว่าจะเป็น รถไฟฟ้า BTS สายสีเขียวสถานีสนามกีฬาแห่งชาติ สยาม ราชดำริ ศาลาแดง ช่องนนทรี เซนต์หลุยส์ สุรศักดิ์ และสะพานตากสิน BTS สายสีเขียวอ่อน ได้แก่ ชิดลม เพลินจิตและบางนา และรถไฟฟ้าใต้ดินหรือ MRT ได้แก่ สถานีคลองเตย ลุมพินี สีลม สามย่าน หัวลำโพง วัดมังกร สามยอดและสนามไชย
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> การอยู่บ้านจัดสรรในกรุงเทพในโซนนี้เดินทางสะดวกด้วยเส้นทางที่เชื่อมต่อมาจากย่าน CBD ไปยังย่านอื่นๆ ใกล้เคียง เช่น ถนนพระราม 9 ถนนพญาไท ถนนลาดพร้าว ฯลฯ เพื่อเข้า-ออกเมือง รวมถึงการใช้รถไฟฟ้าที่ก็มีหลากหลายสายให้เลือกใช้งาน ได้แก่
											</p>
											<ul class="ml-10">
												<li>รถไฟฟ้าใต้ดิน MRT ประกอบด้วยสถานีกำแพงเพชร จตุจักร พหลโยธิน รัชดาภิเษก สุทธิสาร ห้วยขวาง ศูนย์วัฒนธรรมฯ พระราม 9 เพชรบุรี สุขุมวิท ศูนย์ฯสิริกิติ์  และคลองเตย</li>
												<li>รถไฟฟ้า BTS สายสีเขียวอ่อน ได้แก่ สถานีราชเทวี พญาไท อนุสาวรีย์ชัยฯ สนามเป้า อารีย์ สะพานควาย หมอชิต พหลโยธิน ห้าแยกลาดพร้าว พหลโยธิน 24 รัชโยธิน เสนานิคม และม.เกษตรศาสตร์ </li>
												<li>รถไฟฟ้าสายสีเหลือง ได้แก่ สถานี ลาดพร้าว ภาวนา โชคชัย 4 ลาดพร้าว 71 ลาดพร้าว 83 มหาดไทย ลาดพร้าว 101 และบางกะปิ</li>
											</ul>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> การเดินทางฝั่งธนบุรีจะเชื่อมต่อกับฝั่งกรุงเทพฯ ชั้นในและ CBD จากฝั่งสาทรได้ และมีถนนเส้นสำคัญหลายสาย เช่น ถนนบางพลัด ถนนจรัญสนิทวงศ์ ถนนบรมราชชนนี ถนนเพชรเกษม ซึ่งเชื่อมต่อไปยังนครปฐม นนทบุรี สมุทรสาครได้อย่างง่ายดาย
											</p>
											<p class="mt-2 mb-0">
												และด้านการเดินทางด้วยรถไฟฟ้าจะใช้รถไฟฟ้าสายสีน้ำเงินเริ่มจากสถานีหลักสอง บางแค ภาษีเจริญ เพชรเกษม 48 บางหว้า บางไผ่ อิสรภาพ ท่าพระ ไฟฉาย บางขุนนนท์ บางยี่ขัน สิรินธร บางพลัด และบางอ้อ ซึ่งเชื่อมต่อกับรถไฟฟ้าสายสีเขียวเพื่อเข้าเมืองได้ นอกจากนี้ก็จะมีรถไฟฟ้าชานเมือง สายสีแดงอ่อนช่วงสถานีบางซ่อน, สถานีบางบำหรุ และสถานีตลิ่งชันตัดผ่าน ซึ่งในอนาคตจะวิ่งไปจนถึงจังหวัดนครปฐมอีกด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> หากเลือกบ้านในกรุงเทพฯ ตอนบนสามารถเดินทางได้ทั้งรถยนต์ส่วนตัว โดยมีถนนเส้นสำคัญทั้งถนนสายหลัก ถนนสายรอง ถนนโครงข่าย และซอยต่างๆ มากมาย ทำให้เดินทางสะดวก ส่วนการเดินทางด้วยรถไฟฟ้าก็จะมีรถไฟฟ้า BTS สายสีเขียวจากสถานีกรมป่าไม้ บางบัว กรมทหารราบที่ 11 วัดพระศรีมหาธาตุ พหลโยธิน 59 สายหยุด สะพานใหม่ โรงพยาบาลภูมิพลอดุลยเดช พิพิธภัณฑ์กองทัพอากาศ แยก คปอ.และสถานีสุดท้าย คูคต
											</p>
											<p class="mt-2 mb-0">
												ส่วนรถไฟฟ้าสายอื่นๆ ที่ตัดผ่านในโซนนี้เพื่อเชื่อมต่อไปโซนอื่นๆ เช่น รถไฟฟ้าสายสีแดง รถไฟฟ้าสายสีม่วง รถไฟฟ้าสายสีน้ำเงิน และรถไฟฟ้าสายสีชมพู ตัดผ่านในบางสถานีด้วยเช่นกัน
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> หากต้องการบ้านพร้อมที่ดินราคาถูกกรุงเทพที่เดินทางสะดวก การอยู่ในโซนกรุงเทพฯ ตะวันออกที่เชื่อมต่อกับโซนในเมืองด้วยทางด่วนต่างๆ เช่น ทางพิเศษฉลองรัช (รามอินทรา-อาจณรงค์), ทางหลวงพิเศษ (มอร์เตอร์เวย์) หมายเลข 9 ส่วนการเดินทางด้วยรถไฟฟ้าจะเริ่มจากสถานีรถไฟฟ้า BTS สถานีบางจาก ปุณณวิถี อุดมสุข บางนา และแบริ่ง ไปจนถึงจังหวัดสมุทรปราการที่อยู่ใกล้เคียงด้วย
											</p>

											<h3 class="mt-3">
												สถานที่ท่องเที่ยวโครงการบ้านเดี่ยวกรุงเทพโซนต่างๆ
											</h3>
											<p class="mt-2 mb-0">
												<b>ย่าน CBD</b> ใครที่มีกำลังทรัพย์แล้วซื้อหมู่บ้านในกรุงเทพย่าน CBD จะได้อยู่ในแหล่งไลฟ์สไตล์ของย่านธุรกิจที่มีสิ่งอำนวยความสะดวกครบครัน ทั้งห้างสรรพสินค้าชั้นนำ คาเฟ่ ร้านอาหาร แหล่งแฮงค์เอาท์ที่มีกลิ่นอายของความเป็นต่างชาติปะปนอยู่ค่อนข้างมาก ทำให้มีหลายโซนกลายเป็นย่านที่อยู่อาศัยของชาวต่างชาติไปเลย เช่น ย่านนานา ย่านสุขุมวิท เป็นต้น จึงเรียกได้ว่า เหมาะสำหรับการอยู่อาศัยในสไตล์คนเมืองในย่าน Prime Area ที่มีความหลากหลายแบบเต็มที่
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> เป็นโซนของโครงการบ้านจัดสรรกรุงเทพฯ ที่ได้รับอิทธิพลความเจริญจากย่าน CBD มาแบบเต็มๆ ทำให้ไลฟ์สไตล์ค่อนข้างใกล้เคียงกับย่านธุรกิจ แต่ก็จะคงความเป็นแหล่งที่อยู่อาศัยขึ้นมาหน่อย เพราะเป็นย่านที่มีสถานศึกษา และอาคารสำนักงานขนาดเล็กและขนาดปานกลางปะปนอยู่จำนวนมาก ทำให้อาหารการกินในย่านนี้มีหลากหลาย ส่วนสถานที่ท่องเที่ยวก็เน้นเติมเต็มการใช้ชีวิตหลากหลายรูปแบบ เช่น สวนสาธารณะอย่างสวนรถไฟ สวนสมเด็จพระนางเจ้าสิริกิติ์ฯ ห้างสรรพสินค้าใหญ่ เช่น เซ็นทรัลพระราม 9 นอกจากนี้ก็มีคาเฟ่และแหล่งแฮงค์เอาท์สไตล์วัยรุ่นอยู่มากมายด้วยเช่นกัน
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> เพราะความเป็นโซนเก่าแก่ทำให้แหล่งท่องเที่ยวยังคงกลิ่นอายความเป็นชุมชนดั้งเดิม อาหารการกินยังคงความเรียบง่าย มีตลาดน้ำ ตลาดสดให้เห็นอยู่มาก เช่น ตลาดบางแค ตลาดพลู ตลาดน้ำตลิ่งชัน ฯลฯ ส่วนห้างสรรพสินค้าจะมีกระจายตัวอยู่หลากหลายโซนด้วยกัน เช่น โซนปิ่นเกล้า บางแค บางหว้า บางพลัด ฯลฯ  นอกจากนี้ยังเป็นพื้นที่ของวัดวาอารามสวยงามและมีประวัติอันยาวนานด้วย เช่น วัดอรุณราชวราราม วัดสุวรรณาราม วัดชีปะขาว เป็นต้น
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> ใครที่เลือกซื้อโครงการบ้านเดี่ยวกรุงเทพฯ ตอนบน จะอยู่ไม่ไกลจากฝั่งจังหวัดนนทบุรีและปทุมธานี ทำให้สามารถเดินทางไปท่องเที่ยวในจังหวัดใกล้เคียงได้ นอกจากนี้ยังเป็นแหล่งที่อยู่อาศัยใหม่ที่เริ่มมองเห็นความเจริญหลั่งไหลเข้ามาจากการมีรถไฟฟ้า แต่ก็ยังคงความสงบแบบชุมชนดั้งเดิมอยู่ การท่องเที่ยวจึงเป็นไปในรูปแบบผสมผสาน มีทั้งตลาด วัด คาเฟ่ และห้างสรรพสินค้า ไปจนถึงงานแฟร์ต่างๆ เช่น เกษตรแฟร์ อยู่ร่วมกันในทำเลเดียว
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> เป็นย่านที่อยู่ติดกับจังหวัดสมุทรปราการจึงมีแหล่งท่องเที่ยวแนวธรรมชาติให้เดินทางไปเยี่ยมชมเป็นจำนวนมาก เช่น บางกระเจ้า บางปู สวนสาธารณะและสวนพฤกษชาติ ศรีนครเขื่อนขันธ์ ตลาดน้ำบางน้ำผึ้ง พิพิธภัณฑ์ช้างเอราวัณหรือสวนน้ำโพโรโระ อควาพาร์ค เป็นต้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'townhome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้าน ทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ บ้านพร้อมอยู่
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									แนะนำโครงการทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ หลากหลายราคาตั้งแต่ราคาไม่เกิน 8 แสน ไปจนถึงราคาไม่เกิน 4 ล้านบาท รวมให้หมดทั่วทั้งกรุงเทพมหานคร มีให้เลือกหลากหลายรูปแบบทั้งทาวน์โฮมกรุงเทพชั้นเดียว ทาวน์โฮมกรุงเทพสองชั้น มีตั้งแต่ 2 ห้องนอน 3 ห้องนอน 4 ห้องนอน หรือ 5 ห้องนอน สามารถค้นหาด้วยระบบที่ใช้งานง่ายของเรา แค่คลิกเดียวก็เข้าถึงข้อมูลแล้ว ให้คุณสามารถเข้าถึงบ้านมือสองสภาพนางฟ้าในฝันได้โดยไม่ต้องค้นหาตามย่านต่างๆ ด้วยตัวเอง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาโครงการทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ โซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> ประกอบด้วย เขตสาทร เขตบางรัก เขตปทุมวัน เขตยานนาวา เขตบางคลองแหลม เขตพระนคร เขตป้อมปราบศัตรูพ่าย และเขตสัมพันธวงศ์ เป็นย่านที่มองหาทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพได้ค่อนข้างยาก เนื่องจากเป็นทำเลย่านธุรกิจ การซื้อขายทาวน์เฮ้าส์หรือทาวน์โฮมกรุงเทพ จึงมีราคาสูง ขึ้นอยู่กับราคาที่ดินในแต่ละเขต แต่ส่วนใหญ่มีราคาสูงระดับหลายล้าน ไปจนถึงระดับ 10-15 ล้านบาทเลยก็มี (ทั้งนี้ขึ้นอยู่กับสภาพบ้าน การตกแต่ง และทำเลด้วย)
								</p>
								<p class="mt-2 mb-0">
									<b>กรุงเทพฯ ชั้นใน</b> ประกอบด้วยเขตบางซื่อ เขตจตุจักร เขตดุสิต เขตพญาไท เขตราชเทวี เขตห้วยขวาง เขตดินแดง เขตลาดพร้าว เขตวังทองหลาง เขตบางกะปิ เขตบึงกุ่มและเขตคันนายาว เป็นย่านที่มีโซนที่อยู่อาศัยดั้งเดิมอยู่บ้าง แต่ก็รายล้อมด้วยตึกสูง และมีสิ่งอำนวยความสะดวกค่อนข้างครบ ทำให้ทาวน์โฮมกรุงเทพมือสองในย่านนี้มีราคาสูงเช่นกัน โดยมีราคาเริ่มต้นที่ 2 ล้านไปจนถึงราคา 10 กว่าล้านบาทเลยทีเดียว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> ประกอบด้วย เขตธนบุรี เขตบางกอกใหญ่ เขตคลองสาน เขตตลิ่งชัน เขตบางกอกน้อย เขตบางขุนเทียน เขตภาษีเจริญ เขตหนองแขม และเขตราษฎร์บูรณะ ด้วยความเป็นย่านกำลังพัฒนาก็จะทำให้ทาวน์เฮ้าส์และทาวน์โฮมกรุงเทพมีหลากหลายเรตราคาทั้งราคาไม่เกินล้าน ราคาไม่เกิน 1.5 ล้าน ราคาไม่เกิน 2 ล้าน ราคาไม่เกิน 3 ล้าน ก็ขึ้นอยู่กับพื้นที่ ความใกล้ไกลสิ่งอำนวยความสะดวกสบาย และการตกแต่งภายในด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> ประกอบด้วยเขตหลักสี่ เขตดอนเมือง เขตสายไหม เขตบางเขน เขตคลองสามวาและเขตหนองจอก ทาวน์โฮมกรุงเทพบริเวณที่ห่างจากสถานีรถไฟฟ้าไม่เกิน 2 กิโลเมตร เฉลี่ยอยู่ที่ 4 ล้านกว่าบาท ซึ่งมีไม่มากนัก เพราะส่วนใหญ่มักจะอยู่ห่างจากรถไฟฟ้าไปในซอยต่างๆ ซึ่งเหมาะกับคนที่ใช้รถใช้ถนนเป็นหลัก
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> ประกอบด้วยเขตมีนบุรี เขตลาดกระบัง เขตสะพานสูง เขตประเวศ เขตสวนหลวง เขตบางนาและเขตพระโขนง เป็นโซนที่คนอยู่อาศัยเยอะ ทำให้มีปริมาณทาวน์เฮ้าส์และทาวน์โฮมกรุงเทพให้เลือกหลายรูปแบบ ซึ่งราคาก็จะลดหลั่นกันไปตามเขตพื้นที่ใกล้รถไฟฟ้า ใกล้สิ่งอำนวยความสะดวก ซึ่งราคาทาวน์โฮมกรุงเทพราคาไม่เกิน 1-2 ล้านบาทยังพอมีให้เห็นอยู่บ้างเช่นกัน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกโครงการทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ทำเลที่อยู่อาศัย การเลือกซื้อโครงการทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ
								</h3>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> ทาวน์เฮ้าส์หรือทาวน์โฮมกรุงเทพนั้นมีความคึกคัก เต็มไปด้วยห้างสรรพสินค้าใหญ่ คาเฟ่ ร้านอาหารมากมายหลายสัญชาติ รวมไปถึงอยู่ใกล้กับแหล่งงาน จึงเหมาะมากสำหรับคนที่ต้องการอยู่ใกล้สิ่งอำนวยความสะดวกสบาย มีทุนทรัพย์ในการลงทุนซื้อบ้านที่ค่อนข้างมีราคา เนื่องจากมีดีมานด์สูง และราคาที่ดินพุ่งสูงขึ้นต่อเนื่อง และต้องการนำไปต่อยอดลงทุนได้อีกด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> การซื้อบ้านทาวน์โฮมกรุงเทพชั้นใน จะเหมาะสำหรับคนที่ต้องการอยู่ใกล้โซนธุรกิจอย่าง CBD แต่ก็มีทำเลที่โดดเด่นและพูดกันมานานว่าจะเป็น CBD แห่งใหม่หลายแห่งด้วยกัน เช่น มักกะสัน พระราม 9 รัชดาภิเษก จึงเหมาะสำหรับการซื้อบ้านทาวน์โฮมกรุงเทพไว้รอความเจริญที่เข้ามาใหม่ ซึ่งจะทำให้เกิดการพัฒนาในเชิงพาณิชย์และอาคารสูงมากขึ้น และมีแหล่งไลฟ์สไตล์ เช่น ห้าง คอมมูนิตี้มอลล์ ฯลฯ มากขึ้นด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> เป็นย่านชุมชนดั้งเดิม จึงเหมาะสำหรับคนที่ชื่นชอบความเงียบสงบ เน้นการอยู่อาศัยเป็นหลัก แต่ถ้าต้องการจะเดินทางท่องเที่ยวก็สะดวก เพราะอยู่ใกล้กับจังหวัดปริมณฑลต่างๆ เช่น นครปฐม สมุทรสาคร ฯลฯ นอกจากนี้บริเวณถนนปิ่นเกล้า ราชพฤกษ์ เพชรเกษมเองก็เต็มไปด้วยแหล่งไลฟ์สไตล์ทั้งร้านอาหาร ห้าง และคาเฟ่ ซึ่งก็เลือกชอป ชิม ชิลล์กันได้ไม่ต่างจากกรุงเทพฯ ชั้นในเลย
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> เป็นทำเลผสมผสานของความเป็นชุมชนเก่าของคนในพื้นที่และแหล่งไลฟ์สไตล์สมัยใหม่ ทำให้ยังมีความสงบและเป็นส่วนตัวสูง จึงเหมาะกับคนทำงานที่ต้องการทาวน์โฮมกรุงเทพเพื่อพักผ่อนเป็นหลัก แต่ก็ต้องการซื้อบ้านทาวน์โฮมกรุงเทพที่เดินทางเข้าเมืองสะดวกด้วยเช่นกัน
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> เป็นทำเลที่ได้รับความเจริญจากย่าน CBD ไล่ออกมาเรื่อยๆ ทำให้มีโอกาสพัฒนาสูง และในปัจจุบันก็มีสิ่งอำนวยความสะดวกครบครันทั้งแหล่งชอปปิง อาหารการกิน สถานที่ออกกำลังกาย ไปจนถึงแหล่งท่องเที่ยวเชิงอนุรักษ์ ซึ่งก็อยู่ไม่ไกลแค่เดินทางไปจังหวัดสมุทรปราการก็เหมือนได้พักผ่อนแล้ว จึงเหมาะกับคนที่อยาก Work Life Balance เดินทางท่องเที่ยวง่าย แต่ก็ไปทำงานสะดวกด้วยเหมือนกัน
											</p>

											<h3 class="mt-3">
												การเดินทาง โครงการทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ ในโซนต่างๆ
											</h3>
											<p class="mt-2 mb-0">
												<b>ย่าน CBD</b> ใครที่ซื้อบ้านทาวน์โฮมกรุงเทพ ในย่าน CBD ที่เป็นย่านธุรกิจและแหล่งรวมไลฟ์สไตล์เช่นนี้ แน่นอนว่า ต้องให้ความสำคัญเรื่องการเดินทางและความสะดวกสบายเป็นหลัก โดยในย่านนี้จะประกอบไปด้วยถนนใหญ่หลายสาย ทำให้เดินทางได้สะดวก เช่น ถนนอโศกมนตรี ถนนสุขุมวิท ถนนสีลม ถนนเพลินจิต เป็นต้น แต่ถ้าในชั่วโมงเร่งด่วนส่วนใหญ่จะเน้นการใช้รถไฟฟ้าเป็นหลัก โดยในย่านธุรกิจจะมีรถไฟฟ้าเปิดให้บริการอยู่ 3 สายหลักด้วยกัน ได้แก่
											</p>
											<ul class="ml-10">
												<li>BTS สายสีเขียว ซึ่งจะตัดผ่านในย่านนี้ที่สถานีสนามกีฬาแห่งชาติ สยาม ราชดำริ ศาลาแดง ช่องนนทรี เซนต์หลุยส์ สุรศักดิ์ และสะพานตากสิน</li>
												<li>BTS สายสีเขียวอ่อนจะตัดผ่านย่านธุรกิจทั้งหมด 3 สถานี ได้แก่ ชิดลม เพลินจิตและบางนา</li>
												<li>รถไฟฟ้าใต้ดินหรือ MRTจะมีสถานีที่อยู่ในโซน CBD หลายสถานีด้วยกัน ได้แก่ สถานีคลองเตย ลุมพินี สีลม สามย่าน หัวลำโพง วัดมังกร สามยอดและสนามไชย</li>
											</ul>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> เป็นอีกโซนที่เดินทางง่าย เพราะมีรถไฟฟ้าตัดผ่านหลายสถานี ไม่ว่าจะเป็น…
											</p>
											<ul class="ml-10">
												<li>BTS สายสีเขียวอ่อน ได้แก่ สถานีราชเทวี พญาไท อนุสาวรีย์ชัยฯ สนามเป้า อารีย์ สะพานควาย หมอชิต พหลโยธิน ห้าแยกลาดพร้าว พหลโยธิน 24 รัชโยธิน เสนานิคม และมหาวิทยาลัยเกษตรศาสตร์</li>
												<li>BTS สายสีเหลืองที่กำลังจะเปิดให้บริการ ได้แก่ สถานี ลาดพร้าว ภาวนา โชคชัย 4 ลาดพร้าว 71 ลาดพร้าว 83 มหาดไทย ลาดพร้าว 101 และบางกะปิ</li>
												<li>MRT สายสีน้ำเงิน ได้แก่ สถานีกำแพงเพชร จตุจักร พหลโยธิน รัชดาภิเษก สุทธิสาร ห้วยขวาง ศูนย์วัฒนธรรมฯ พระราม 9 เพชรบุรี สุขุมวิท ศูนย์ฯสิริกิติ์ และคลองเตย</li>
											</ul>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> การซื้อ-ขายบ้านทาวน์เฮ้าส์ ทาวน์โฮมกรุงเทพ สามารถใช้รถไฟฟ้าได้หลายสาย ทั้งรถไฟฟ้าสายสีน้ำเงินเริ่มจากสถานีหลักสอง บางแค ภาษีเจริญ เพชรเกษม 48 บางหว้า บางไผ่ อิสรภาพ ท่าพระ ไฟฉาย บางขุนนนท์ บางยี่ขัน สิรินธร บางพลัด และบางอ้อ นอกจากนี้ยังมีรถไฟฟ้าชานเมือง สายสีแดงอ่อนช่วงสถานีบางซ่อน, สถานีบางบำหรุ และสถานีตลิ่งชันตัดผ่าน ซึ่งในอนาคตจะวิ่งไปจนถึงจังหวัดนครปฐมได้ด้วย
											</p>
											<p class="mt-2 mb-0">
												ส่วนถนนหนทางก็เป็นโซนที่เชื่อมต่อกับโซนปริมณฑล เช่น จังหวัดนครปฐม จังหวัดสมุทรสาคร จังหวัดนนทบุรี ได้อย่างรวดเร็วด้วยทางด่วนและถนนตัดใหม่ที่ปัจจุบันทำให้การเดินทางเร็วมากขึ้นอีกหลายเท่าตัว
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> สำหรับในปัจจุบันในทำเลนี้มีรถไฟฟ้าตัดผ่านหลายสายแล้ว ทั้งรถไฟฟ้า BTS สายสีเขียวจากสถานีกรมป่าไม้ บางบัว กรมทหารราบที่ 11 วัดพระศรีมหาธาตุ พหลโยธิน 59 สายหยุด สะพานใหม่ โรงพยาบาลภูมิพลอดุลยเดช พิพิธภัณฑ์กองทัพอากาศ แยก คปอ.และสถานีสุดท้าย คูคต ส่วนรถไฟฟ้าสายอื่นๆ ที่ตัดผ่านในโซนนี้เพื่อเชื่อมต่อไปโซนอื่นๆ เช่น
											</p>
											<ul class="ml-10">
												<li>รถไฟฟ้าสายสีแดง จะเชื่อมต่อสถานีบางซื่อไปยังจตุจักร วัดเสมียนนารี บางเขน ทุ่งสองห้อง หลักสี่ การเคหะฯ ดอนเมือง หลักหก (ม.รังสิต) และรังสิต</li>
												<li>รถไฟฟ้าสายสีม่วง จะตัดผ่านโซนนี้ที่สถานีบางซ่อนและวงศ์สว่าง</li>
												<li>รถไฟฟ้าสายสีน้ำเงิน จะตัดผ่านโซนนี้ที่สถานีบางโพ</li>
												<li>รถไฟฟ้าสายสีชมพู (สายอนาคต)</li>
											</ul>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตะวันออก</b> เป็นโซนที่เชื่อมต่อไปยังฝั่ง EEC ง่ายจากการที่มีทางด่วนวิ่งตรงไปยังจังหวัดแถบชายฝั่งตะวันออกของประเทศไทย และในอนาคตมีโครงการก่อสร้างรถไฟฟ้าที่วิ่งผ่านสนามบินดอนเมือง-สุวรรณภูมิ-อู่ตะเภาอีกด้วย
											</p>
											<p class="mt-2">
												ส่วนการเดินทางเข้า-ออกเมืองจากกรุงเทพฯ สู่จังหวัดปริมณฑลอย่างจังหวัดสมุทรปราการก็จะมีรถไฟฟ้า BTS สายสีเขียวส่วนต่อขยายตัดผ่านในโซนที่สถานีบางจาก ปุณณวิถี อุดมสุข บางนา และแบริ่ง ผ่านไปยังจังหวัดสมุทรปราการไปจนสิ้นสุดที่สถานตากอากาศบางปูเลยทีเดียว
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'condo'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการ คอนโดกรุงเทพ คอนโดมิเนียม (Condo) พร้อมอยู่
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									รวมคอนโดมิเนียมกรุงเทพ ทั้งคอนโดมือสองกรุงเทพ คอนโดมือ2 ราคาถูก มีให้เลือกหลากหลายทั้งคอนโดใกล้รถไฟฟ้า BTS MRT ที่เดินทางสะดวกทั้งระบบขนส่งสาธารณะและการใช้รถส่วนตัว, คอนโดแต่งครบพร้อมอยู่ ไม่ว่าจะเป็น 1 ห้องนอน 2 ห้องนอน 3 ห้องนอน มีให้เลือกตามวัตถุประสงค์, คอนโดน่าอยู่ ในย่านที่คุณคุ้นเคย เช่น คอนโดแถวสุขุมวิท คอนโดกรุงเทพฯ ชั้นใน คอนโดฝั่งธนบุรี เป็นต้น ใครที่ต้องการซื้อขายคอนโดกรุงเทพ อยากประกาศขายคอนโดห้ามพลาด เพราะนี่คือ พื้นที่หาลูกค้าและหาคอนโดที่ตรงใจสำหรับคุณที่สุด ด้วยทีมงานคุณภาพและเชี่ยวชาญด้านอสังหาริมทรัพย์อย่างแท้จริง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาโครงการคอนโดกรุงเทพ ในโซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> คอนโดกรุงเทพ (Condo) ในย่าน CBD ส่วนใหญ่จะอยู่ในระดับ High Class ไปจนถึงระดับ Super Luxury ที่มีราคาสูงอาจจะเริ่มต้นช่วงราคาไม่เกิน 5 ล้าน ราคาไม่เกิน 10 ล้าน ราคาไม่เกิน 20 ล้าน หรืออาจจะมากกว่านั้นไปจนถึง 200 ล้านบาทขึ้นไป สำหรับห้องแบบ Penthouse เนื่องจากเป็นย่านธุรกิจที่ราคาที่ดินสูง และมีดีมานด์อยู่เสมอ ทำให้ราคาคอนโดมิเนียมในย่านนี้อยู่ในเกณฑ์ที่สูงตามไปด้วย
								</p>
								<p class="mt-2 mb-0">
									โดยทำเลย่านนี้จะประกอบไปด้วยเขตสาทร เขตบางรัก เขตปทุมวัน เขตยานนาวา เขตบางคลองแหลม เขตพระนคร เขตป้อมปราบศัตรูพ่าย และเขตสัมพันธวงศ์ ซึ่งเป็นเขตธุรกิจทั้งสิ้น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> สำหรับคอนโดกรุงเทพฯ ชั้นในนั้นจะมีหลากหลายเรตราคาเช่นกัน เพราะเป็นโซนที่กินพื้นที่กว้าง ประกอบด้วย เขตบางซื่อ เขตจตุจักร เขตดุสิต เขตพญาไท เขตราชเทวี เขตห้วยขวาง เขตดินแดง เขตลาดพร้าว เขตวังทองหลาง เขตบางกะปิ เขตบึงกุ่มและเขตคันนายาว แต่ในส่วนที่เป็นคอนโดมือสองราคาเริ่มอาจจะยังไม่สูงเท่าย่าน CBD โดยคอนโดเริ่มต้นราคาไม่เกิน 4 ล้านบาทยังเป็นเรตราคาที่มีให้เห็นอยู่ หรือถ้าเป็นคอนโดใน Segment ที่นักศึกษา หรือคนเริ่มต้นทำงานยังสามารถจับต้องได้ก็อาจจะเป็นคอนโดที่มีราคาไม่เกิน 3  ล้านบาท
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> โครงการคอนโดในกรุงเทพฝั่งธนบุรีนั้นจะมีตั้งแต่ราคาล้านต้นๆ ไปถึง 10 ล้านบาทขึ้นอยู่กับตำแหน่ง สภาพทำเล และความใกล้-ไกลรถไฟฟ้า โดยคอนโดที่มีราคาสูงมักจะเป็นคอนโดวิวแม่น้ำเจ้าพระยา หรือเป็นคอนโดที่สร้างอยู่ในทำเลที่เก่าแก่ เช่น เจริญกรุง ทำให้มีราคาค่อนข้างสูง แต่ส่วนพื้นที่อื่นยังเป็นคอนโดที่สามารถจับต้องได้อยู่ เหมาะสำหรับจะซื้อเป็นที่อยู่อาศัยหลังแรกสำหรับคนเริ่มทำงานเช่นเดียวกัน เพราะอยู่ไม่ไกลจากตัวเมืองมากนัก ประกอบไปด้วยเขตธนบุรี เขตบางกอกใหญ่ เขตคลองสาน เขตตลิ่งชัน เขตบางกอกน้อย เขตบางขุนเทียน เขตภาษีเจริญ เขตหนองแขม และเขตราษฎร์บูรณะ
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> ในบางพื้นที่ของกทม. ตอนบนอาจมีคอนโดมือสองกรุงเทพฯ ให้เห็นอยู่บ้าง ซึ่งราคามักไม่สูงมากนัก ประกอบไปด้วยเขตหลักสี่ เขตดอนเมือง เขตสายไหม เขตบางเขน เขตคลองสามวาและเขตหนองจอก โดยเขตหลักๆ ที่มีคอนโดล้านต้นๆ หรืออาจจะมีราคาไม่เกิน 1 ล้านบาท ส่วนใหญ่จะเป็นในเขตดอนเมือง หลักสี่ บางเขน ซึ่งเป็นเขตทำงานและมหาวิทยาลัย
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> ประกอบด้วยเขตมีนบุรี เขตลาดกระบัง เขตสะพานสูง เขตประเวศ เขตสวนหลวง เขตบางนาและเขตพระโขนง ซึ่งตัวคอนโดมิเนียมกรุงเทพจะมีให้เห็นอยู่บ้างโดยเฉพาะในบริเวณใกล้รถไฟฟ้าหรือใกล้สถานีขนส่งสาธารณะ นอกจากนี้ยังมีให้เลือกหลายประเภททั้งตกแต่งพร้อมอยู่ ตกแต่งบางส่วน หรือห้องเปล่าก็มีในราคาที่ยังจับต้องได้ ส่วนใหญ่คอนโดกรุงเทพในย่านนี้จะเป็นราคาไม่เกิน 2-3 ล้านบาทขึ้นไปจะเป็นที่นิยมสูง
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกโครงการคอนโดกรุงเทพ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ทำเลที่อยู่อาศัยการเลือกซื้อโครงการคอนโดกรุงเทพ
								</h3>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> คอนโดกรุงเทพ (Condo) ในย่าน CBD ส่วนใหญ่จะอยู่ในระดับ High Class ไปจนถึงระดับ Super Luxury ที่มีราคาสูงอาจจะเริ่มต้นช่วงราคาไม่เกิน 5 ล้าน ราคาไม่เกิน 10 ล้าน ราคาไม่เกิน 20 ล้าน หรืออาจจะมากกว่านั้นไปจนถึง 200 ล้านบาทขึ้นไป สำหรับห้องแบบ Penthouse เนื่องจากเป็นย่านธุรกิจที่ราคาที่ดินสูง และมีดีมานด์อยู่เสมอ ทำให้ราคาคอนโดมิเนียมในย่านนี้อยู่ในเกณฑ์ที่สูงตามไปด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> ส่วนใหญ่คอนโดมิเนียมจะเป็นคอนโดแนวรถไฟฟ้า เพื่ออำนวยความสะดวกให้กับเหล่าพนักงาน หรือผู้ประกอบการต่างๆ ทำให้เป็นย่านที่อยู่คอนโดแล้วเดินทางสะดวก หาของกินง่าย ไปไหนมาไหนไม่ลำบาก ไม่เปลี่ยว จึงเหมาะกับคนที่ต้องการอยู่คอนโดมิเนียมใกล้รถไฟฟ้า เน้นโครงการใหญ่ที่มี Facilities ครบครันเป็นหลัก
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> ใครที่สนใจคอนโดมิเนียมหรูกรุงเทพติดริมแม่น้ำ หรือคอนโดติดริมคลอง ฝั่งธนบุรีถือเป็นอีกหนึ่งย่านน่าสนใจ เพราะมีคอนโดให้เลือกหลากหลายระดับ หลากหลายราคา หลากหลายรูปแบบ ทั้งใกล้รถไฟฟ้า ติดแม่น้ำเจ้าพระยา ติดแหล่งชุมชนดั้งเดิมที่ราคาจับต้องได้ แต่ส่วนใหญ่ก็ยังนับว่าเป็นพื้นที่สงบ จึงเหมาะกับคนที่มองหาคอนโดมิเนียมกรุงเทพเพื่ออยู่อาศัยเป็นหลักอย่างแท้จริง
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> เป็นโซนคอนโดกรุงเทพฯ ที่มีสิ่งอำนวยความสะดวกครบครันจากการที่ได้รับอิทธิพลจากตัวเมืองกรุงเทพฯ ชั้นในมา แต่ก็ยังคงความเป็นชุมชนดั้งเดิมที่เงียบสงบไว้ได้อย่างน่าประทับใจ จึงเหมาะกับคนที่ต้องการความเป็นส่วนตัว แต่ก็อยู่ไม่ไกลจากแสงสีและความเจริญ ซึ่งเดินทางออกไปหาได้ไม่ยาก
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> เป็นโซนของคอนโดกรุงเทพราคาย่อมเยา แต่ก็ยังเป็นพื้นที่ศักยภาพเพราะได้รับการพัฒนาตามอิทธิพลของพื้นที่ CBD และกรุงเทพชั้นใน ทำให้ในอนาคตมีแนวโน้มจะราคาสูงขึ้นอีก แต่ในปัจจุบันยังนับเป็นย่านที่อยู่อาศัยที่ยังไม่พลุกพล่านมากนักเมื่อเทียบกับกรุงเทพฯ ชั้นใน ซึ่งอยู่ใกล้เคียง จึงเหมาะกับคนที่อยากอยู่ไม่ห่างจากเมืองมากนัก อยากเดินทางไปทำงานสะดวก แต่ในช่วงเวลาพักผ่อนก็อยากใข้เวลากับตัวเองให้เต็มที่ด้วย
											</p>

											<h3 class="mt-3">
												การเดินทางโครงการคอนโดกรุงเทพ
											</h3>
											<p class="mt-2 mb-0">
												<b>ย่าน CBD</b> การเดินทางที่สะดวกที่สุด ต้องยกให้การเดินทางด้วยรถไฟฟ้า เพราะรถไฟฟ้าที่ตัดผ่านย่านนี้คือรถไฟฟ้าสายหลัก ได้แก่
											</p>
											<ul class="ml-10">
												<li>รถไฟฟ้า BTS สายสีเขียว ประกอบด้วย สถานีสนามกีฬาแห่งชาติ สยาม ราชดำริ ศาลาแดง ช่องนนทรี เซนต์หลุยส์ สุรศักดิ์ และสะพานตากสิน</li>
												<li>รถไฟฟ้า BTS สายสีเขียวอ่อน ได้แก่ ชิดลม เพลินจิตและบางนา</li>
												<li>รถไฟฟ้าใต้ดินหรือ MRT ได้แก่ สถานีคลองเตย ลุมพินี สีลม สามย่าน หัวลำโพง วัดมังกร สามยอดและสนามไชย</li>
											</ul>
											<p class="mt-2 mb-0">
												ส่วนการเดินทางโดยรถส่วนตัวสำหรับคนอยู่อาศัยในคอนโดกรุงเทพในโซนนี้ จะสะดวกในช่วงเวลาที่ไม่ใช่ชั่วโมงเร่งด่วน เนื่องจากถนนส่วนใหญ่เชื่อมต่อถึงกันเป็นโครงข่าย เช่น ถนนสีลม สาทร ถนนพระราม 4 ถนนเพลินจิต ถนนวิทยุถนนอโศกมนตรี มีทางด่วนพิเศษให้ใช้เข้า-ออกเมืองได้สะดวก และยังมีซอยน้อยใหญ่ที่เชื่อมถึงกัน ทำให้ขับรถทะลุไปยังโซนต่างๆ ได้ง่ายดายอีกด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> ในปัจจุบันการเดินทางหลักจะใช้รถไฟฟ้าทั้งหมด 2 สาย ได้แก่ BTS สายสีเขียวอ่อน ที่จะตัดผ่านโซนนี้ในสถานีราชเทวี พญาไท อนุสาวรีย์ชัยฯ สนามเป้า อารีย์ สะพานควาย หมอชิต พหลโยธิน ห้าแยกลาดพร้าว พหลโยธิน 24 รัชโยธิน เสนานิคม และม.เกษตรศาสตร์ และMRT หรือรถไฟฟ้าใต้ดินจะเชื่อมตั้งแต่สถานีกำแพงเพชร จตุจักร พหลโยธิน รัชดาภิเษก สุทธิสาร ห้วยขวาง ศูนย์วัฒนธรรมฯ พระราม 9 เพชรบุรี สุขุมวิท ศูนย์ฯสิริกิติ์และคลองเตย
											</p>
											<p class="mt-2 mb-0">
												ส่วนในอนาคตอันใกล้จะมีรถไฟฟ้าสายสีเหลืองเปิดให้บริการ โดยสถานที่ตัดผ่านในย่านนี้จะเป็นสถานีลาดพร้าว ภาวนา โชคชัย 4 ลาดพร้าว 71 ลาดพร้าว 83 มหาดไทย ลาดพร้าว 101 และบางกะปิ
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> ผู้คนจะใช้ทั้งรถส่วนตัว รถโดยสารประจำทาง และรถไฟฟ้าเป็นหลัก เนื่องจากมีถนนหลักหลายสาย เช่น ถนนบรมราชชนนี ถนนเพชรเกษม ถนนกัลปพฤกษ์ ถนนราชพฤกษ์ ซึ่งเชื่อมถึงกันทำให้การเข้า-ออกเมืองทำได้ง่ายมาก ส่วนรถไฟฟ้าในย่านนี้จะมีรถไฟฟ้า MRT วิ่งเป็นหลักโดยจะตัดผ่านที่สถานีหลักสอง บางแค ภาษีเจริญ เพชรเกษม48 บางหว้า บางไผ่ อิสรภาพ ท่าพระ ไฟฉาย บางขุนนนท์ บางยี่ขัน สิรินธร บางพลัด บางอ้อ และมี BTS สถานีกรุงธนบุรี วงเวียนใหญ่ โพธิ์นิมิตร ตลาดพลู วุฒากาศและบางหว้า ซึ่งเป็นสถานีที่มีอยู่ก่อนแล้วช่วยทำให้การเดินทางทำได้ง่ายขึ้น และนอกจากนี้ ก็มีรถไฟสายสีแดงอ่อนที่เชื่อมมาจากบางซื่อคือสถานีบางบำหรุและตลิ่งชันมาช่วยให้การจราจรในย่านนี้เดินทางได้รวดเร็วมากขึ้นอีกด้วย
											</p>
											<p class="mt-2 mb-0">
												ส่วนถนนหนทางก็เป็นโซนที่เชื่อมต่อกับโซนปริมณฑล เช่น จังหวัดนครปฐม จังหวัดสมุทรสาคร จังหวัดนนทบุรี ได้อย่างรวดเร็วด้วยทางด่วนและถนนตัดใหม่ที่ปัจจุบันทำให้การเดินทางเร็วมากขึ้นอีกหลายเท่าตัว
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> ในปัจจุบันคนยังนิยมใช้รถส่วนตัวในการเดินทาง แต่ในอนาคตย่านนี้นับเป็น HUB ที่มีสายรถไฟฟ้าตัดผ่านเป็นจำนวนมาก ไม่ว่าจะเป็น…
											</p>
											<ul class="ml-10">
												<li>รถไฟฟ้า BTS สายสีเขียวตัดผ่านจากสถานีกรมป่าไม้ บางบัว กรมทหารราบที่ 11 วัดพระศรีมหาธาตุ พหลโยธิน 59 สายหยุด สะพานใหม่ โรงพยาบาลภูมิพลอดุลยเดช พิพิธภัณฑ์กองทัพอากาศ แยก คปอ.และสถานีคูคต</li>
												<li>รถไฟฟ้าสายสีแดงจะเชื่อมต่อสถานีบางซื่อไปยังจตุจักร วัดเสมียนนารี บางเขน ทุ่งสองห้อง หลักสี่ การเคหะ ดอนเมือง หลักหก (ม.รังสิต) และรังสิต</li>
												<li>รถไฟฟ้าสายสีม่วง ตัดผ่านโซนนี้อีก 2 สถานีจากเตาปูน ได้แก่ บางซ่อนและวงศ์สว่าง</li>
												<li>รถไฟฟ้าสายสีน้ำเงินตัดผ่านโซนนี้ที่สถานีบางโพ</li>
												<li>รถไฟฟ้าสายสีชมพู (รถไฟฟ้าสายอนาคต)</li>
											</ul>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> ได้พัฒนาเส้นทางเชื่อมโยงด้วยถนนเส้นสำคัญๆ เพื่อให้เหมาะสำหรับการเดินทางขนส่งเข้า-ออกเมืองไปยังจังหวัดในแถบฉะเชิงเทรา-ชลบุรีได้ง่าย เช่น ถนนพระราม 9 ถนนกรุงเทพกรีฑา (ตัดใหม่) ถนนศรีนครินทร์ ฯลฯ มีทางด่วนหลายเส้นทางให้เลือกใช้ เช่น มอเตอร์เวย์กรุงเทพฯ-ชลบุรี (ทางหลวงพิเศษหมายเลข 7) ฯลฯ รวมถึงรถไฟฟ้าก็มีตัดผ่านด้วยเช่นกัน ได้แก่ รถไฟฟ้า BTS สายสีเขียวส่วนต่อขยาย ที่ตัดผ่านโซนนี้แถวสถานีบางจาก ปุณณวิถี อุดมสุข บางนา และแบริ่ง
											</p>

											<h3 class="mt-3">
												สถานที่ท่องเที่ยวโครงคอนโดกรุงเทพ
											</h3>
											<p class="mt-2 mb-0">
												<b>ย่าน CBD</b> เป็นย่านที่รวบรวมสถานที่ท่องเที่ยวหลากหลายสไตล์เข้าไว้ด้วยกัน เช่น สวนสาธารณะใหญ่อย่างอุทยานเบญจสิริ สวนเบญจกิติ ฯลฯ ห้างสรรพสินค้าชั้นนำที่ตั้งอยู่ในโซนสุขุมวิท ย่านสยาม ราชเทวี หรือชิดลม นอกจากนี้ยังมีพื้นที่จับจ่ายใช้สอย ร้านอาหาร คาเฟ่ และศูนย์การค้าเพื่อการพาณิชย์มากมาย ซึ่งเปิดให้บริการอยู่ทั่วไปแทบจะ 24 ชั่วโมง
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> เป็นโซนที่อยู่ใกล้กับย่าน CBD จึงได้รับอิทธิพลความเจริญมาเต็มๆ โซนกรุงเทพฯ ชั้นในจึงมีสิ่งอำนวยความสะดวกมากมายทั้งอาคารออฟฟิศ ศูนย์ประชุม อาคาร Mixed Used และ Mega Project ส่วนสวนสาธารณะก็มีให้เลือกพักผ่อนหย่อนใจหลายแห่ง นอกจากนี้ก็ยังมีพื้นที่ชอปปิงก็มี ห้างสรรพสินค้า คาเฟ่ ตลาดนัดคนเดิน ร้านแฮงค์เอาท์ ไปจนถึงร้านอาหารที่มีให้เลือกหลากหลายระดับ เรียกได้ว่า ตอบโจทย์สำหรับคนที่ซื้อคอนโดกรุงเทพได้ทุกเพศและทุกวัยเลยทีเดียว
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> เป็นโซนของเมืองเก่า ชุมชนดั้งเดิม การท่องเที่ยวจึงเป็นไปในแบบ Slow Life เน้นบรรยากาศเงียบสงบ เช่น ตลาดน้ำ วัด ร้านอาหารของคนในชุมชน ฯลฯ แต่ก็ยังมีห้างสรรพสินค้าใหญ่ตั้งอยู่ในโซนต่างๆ เช่น เดอะมอลล์บางแค เซ็นทรัลปิ่นเกล้า หรืออย่างเส้นราชพฤกษ์เองก็เรียกได้ว่า เป็นเส้นที่รวมแหล่ง Community Mall ใหญ่ๆ สำหรับคนยุคใหม่เลยทีเดียว เช่น The Walk, The Circle, Food Villa เป็นต้น
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> เป็นโซนของแหล่งไลฟ์สไตล์ชิคๆ ผสมผสานกับการอยู่อาศัยแบบดั้งเดิมของคนในชุมชน ทำให้เป็นการท่องเที่ยวที่ไม่ได้หวือหวาหรือมีสีสันเท่าในตัวเมืองชั้นใน หรือ CBD เน้นการกิน เที่ยว ดื่ม แบบชิลล์ๆ โดยมีแหล่งศูนย์รวมอยู่แถวย่านลาดพร้าว หลักสี่ บางเขน ซึ่งเป็นที่ตั้งของห้างสรรพสินค้าขนาดใหญ่ และคาเฟ่ต่างๆ มากมาย นอกจากนี้ก็ยังมีโซนจตุจักรที่เป็นแหล่งของสวนสาธารณะใหญ่ และสายไหม ดอนเมืองที่เป็นย่านใหม่ ซึ่งก็เริ่มจะเจริญมาติดๆ
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> เป็นโซนสำหรับคนชอบเดินห้างสรรพสินค้า สลับกันไปชมธรรมชาติ เพราะโซนนี้สามารถเดินทางไปยังจังหวัดสมุทรปราการ เพื่อชมธรรมชาติได้ง่าย เช่น ไปสถานีตากอากาศบางปู ไปบางกระเจ้า ฯลฯ หรือโซนห้างก็จะมีทั้งเมกาบางนา อีเกียบางนา ซึ่งในอนาคตก็จะมีพวก Mega Project เกิดขึ้นอีกหลายโครงการในแถบนี้ด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'shophouse'">
							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคา ซื้อ-ขายอาคารพาณิชย์กรุงเทพ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> การซื้อ-ขายตึกแถวกรุงเทพฯ มักมีราคาสูง ซึ่งในบางทำเลอาจจะแตะถึงราคา 10 ล้านบาทขึ้นไป (ขึ้นอยู่กับขนาดพื้นที่และสภาพของอาคารและตึกแถว) เนื่องจากเป็นทำเล Prime Area ที่มีศักยภาพและมีดีมานด์อยู่ต่อเนื่อง ประกอบด้วยเขตสาทร เขตบางรัก เขตปทุมวัน เขตยานนาวา เขตบางคลองแหลม เขตพระนคร เขตป้อมปราบศัตรูพ่าย และเขตสัมพันธวงศ์ แต่ถ้าสนใจซื้ออาคารพาณิชย์ค้าขายได้ ในราคาไม่แพงมาก แต่อาจจะไม่ได้อยู่ในโซนรถไฟฟ้า หรือต้องทำการรีโนเวทเพิ่มเติมก็ยังพอจะหาได้ในเรตไม่เกิน 5 ล้านบาท
								</p>
								<p class="mt-2 mb-0">
									<b>กรุงเทพฯ ชั้นใน</b> อยากจะซื้อ-ขายอาคารพาณิชย์กรุงเทพ หรือเช่าอาคารพาณิชย์ในย่านกรุงเทพฯ ชั้นใน ประกอบด้วยเขตบางซื่อ เขตจตุจักร เขตดุสิต เขตพญาไท เขตราชเทวี เขตห้วยขวาง เขตดินแดง เขตลาดพร้าว เขตวังทองหลาง เขตบางกะปิ เขตบึงกุ่มและเขตคันนายาว ซึ่งเป็นพื้นที่ธุรกิจใหม่ยังสามารถหาซื้อได้ในราคาไม่เกิน 4 ล้านบาทในบางพื้นที่ และในโซนที่เป็นย่านการค้า ติดรถไฟฟ้า หรือใกล้ห้างสรรพสินค้าอาจมีราคาที่สูงกว่านั้น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> เนื่องจากเป็นทำเลย่านเก่าแก่จึงมีอาคารพาณิชย์หลากหลายราคาให้เลือกตั้งแต่ราคาไม่เกิน 1 ล้าน ไม่เกิน 2 ล้าน ไม่เกิน 3 ล้าน หรือมากกว่า 3 ล้านบาทขึ้นไป ซึ่งก็เหมาะสำหรับคนตั้งต้นทำธุรกิจในย่านกำลังพัฒนาและมีศักยภาพมากพอสำหรับการทำการค้าขายหรือทำเป็นพื้นที่สำนักงาน
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> เนื่องจากเป็นย่านที่มีรถไฟฟ้าเข้าถึงไม่นาน ทำให้ราคาที่ดินอาจจะยังไม่สูงมากนัก จึงสามารถจับจอง ซื้อ-ขายอาคารพาณิชย์มือสอง และตึกเช่าต่างๆ ในเรตราคาเอื้อมถึงได้ง่ายกว่าหลายๆ โซนในกรุงเทพมหานคร แต่เนื่องจากเป็นทำเลที่กินอาณาเขตกว้าง ประกอบด้วยเขตหลักสี่ เขตดอนเมือง เขตสายไหม เขตบางเขน เขตคลองสามวาและเขตหนองจอก ทำให้มีรถไฟฟ้าตัดผ่านหลายสาย แน่นอนว่า ในอนาคตจะกลายเป็นทำเลศักยภาพที่มีราคาสูงขึ้นอย่างแน่นอน
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> ประกอบด้วยเขตมีนบุรี เขตลาดกระบัง เขตสะพานสูง เขตประเวศ เขตสวนหลวง เขตบางนาและเขตพระโขนง ที่ได้รับความเจริญจากกรุงเทพฯ ชั้นในและโซน CBD ทำให้เป็นย่านคึกคัก มีคนสัญจรอยู่มาก ราคาอาคารพาณิชย์จึงอยู่ในระดับที่ยังจับต้องได้มากกว่าย่านใจกลางเมือง แต่ก็เดินทางสะดวก จึงเหมาะสำหรับการตั้งต้นธุรกิจในทำเลที่เน้นการเดินทางมาง่ายจากในตัวเมืองและเขตปริมณฑลอย่างสมุทรปราการเป็นหลัก
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกอาคารพาณิชย์ในกรุงเทพ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ทำเลที่อยู่อาศัยการเลือกซื้ออาคารพาณิชย์กรุงเทพ
								</h3>
								<p class="mt-2 mb-0">
									<b>ย่าน CBD</b> เป็นโซนธุรกิจของกรุงเทพฯ ทำให้การซื้อ-ขายอาคารพาณิชย์กรุงเทพเป็นสิ่งที่ตอบโจทย์ที่สุดในแง่ของการทำกิจการ เพราะเป็นย่านที่มีกำลังซื้อสูง อีกทั้งติดต่อค้าขายสะดวกมากที่สุด จากการเป็นทำเลในแนวรถไฟฟ้าสายหลักอย่าง รถไฟฟ้า BTS สายสีเขียวซึ่งวิ่งตัดผ่านทำเลทองทั้งสถานีสนามกีฬาแห่งชาติ สยาม ราชดำริ ศาลาแดง ช่องนนทรี เซนต์หลุยส์ สุรศักดิ์ สะพานตากสิน ชิดลม เพลินจิตและบางนา หรือ MRT ก็ผ่านทั้งสถานีคลองเตย ลุมพินี สีลม สามย่าน หัวลำโพง วัดมังกร สามยอดและสนามไชย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												นอกจากนี้ยังเป็นแหล่งอาคารสำนักงานใหญ่ ห้างสรรพสินค้า และ Mega Project ขนาดยักษ์ ทำให้มีผู้คนพลุกพล่านทั้งชาวไทยและต่างชาติ
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ชั้นใน</b> เรียกได้ว่า เป็นโซนธุรกิจใหม่ที่มีศักยภาพในการเติบโตสูงต่อเนื่องจากย่าน CBD จึงเป็นแหล่งงานสำหรับคนรุ่นใหม่ มีบริษัท สำนักงาน อาคารใช้เช่า รวมถึงบ้านอาคารพาณิชย์สำหรับเหล่า Startup เป็นจำนวนมาก เหมาะสำหรับการเริ่มต้นทำกิจการที่ต้องการทำเลใกล้ย่านธุรกิจ และมีสิ่งอำนวยความสะดวกที่ครบครัน ทั้งห้างสรรพสินค้าใหญ่ ร้านอาหาร และที่สำคัญมีรถไฟฟ้าตัดผ่าน ซึ่งย่านนี้จะมีรถไฟฟ้าสายสำคัญ ได้แก่ สถานีราชเทวี พญาไท อนุสาวรีย์ชัยฯ สนามเป้า อารีย์ สะพานควาย หมอชิต พหลโยธิน ห้าแยกลาดพร้าว พหลโยธิน 24 รัชโยธิน เสนานิคม และมหาวิทยาลัยเกษตรศาสตร์ ของสถานี BTS สายสีเขียวอ่อน มีสถานี MRT เชื่อมตั้งแต่สถานีกำแพงเพชร จตุจักร พหลโยธิน รัชดาภิเษก สุทธิสาร ห้วยขวาง ศูนย์วัฒนธรรมฯ พระราม 9 เพชรบุรี สุขุมวิท ศูนย์ฯสิริกิติ์และคลองเตย รวมถึงรถไฟฟ้าสายสีเหลืองที่จะมีมาในอนาคตอีกด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>ฝั่งธนบุรี</b> ป็นย่านของชุมชนดั้งเดิม การค้าขายในย่านนี้จึงมีไว้เพื่อสำหรับคนในชุมชนเป็นส่วนใหญ่ จึงมีตึกแถวทำเลค้าขายกระจายตัวอยู่มาก เหมาะสำหรับการตั้งร้านขายของ คาเฟ่ ร้านอาหาร อาคารสำนักงานขนาดกลางและขนาดเล็ก ซึ่งในปัจจุบันมีความคึกคักมากขึ้นด้วยการมีรถไฟฟ้าทั้ง BTS สถานีกรุงธนบุรี วงเวียนใหญ่ โพธิ์นิมิตร ตลาดพลู วุฒากาศและบางหว้า ซึ่งจะเชื่อไปยัง MRT สถานีต้นทางเริ่มจากสถานีหลักสอง บางแค ภาษีเจริญ เพชรเกษม48 บางหว้า บางไผ่ อิสรภาพ ท่าพระ ไฟฉาย บางขุนนนท์ บางยี่ขัน สิรินธร บางพลัด บางอ้อ ทำให้ย่านนี้มีศักยภาพในการพัฒนาและเจริญเติบโตด้านเศรษฐกิจมากขึ้นด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>กรุงเทพฯ ตอนบน</b> เป็นโซนที่มีพื้นที่ตึกอาคาร ห้องแถวให้เช่าหรือซื้ออยู่หลายทำเลกระจายตัวอยู่หลายโซน เนื่องจากเป็นย่านของความหลากหลาย มีทั้งเขตที่ทำพื้นที่เกษตรกรรม มีโซนธุรกิจร้านค้า โครงการพาณิชย์ต่างๆ ซึ่งส่วนใหญ่จะเกาะกลุ่มตามเส้นรถไฟฟ้าต่างๆ ที่ผ่านในย่านนี้หลากหลายสาย เช่น รถไฟฟ้า BTS สายสีเขียวที่ผ่านจากกรมป่าไม้ไปจนถึงคูคต สายสีแดงที่วิ่งจากจตุจักรไปรังสิต สายสีม่วงจากสถานีบางซ่อนและวงศ์สว่าง สายสีน้ำเงินอย่างบางโพ และสายสีชมพูที่จะเปิดใช้ในอนาคตนี้
											</p>
											<p class="mt-2">
												<b>กรุงเทพฯ ตะวันออก</b> เป็นโซนที่รองรับความเจริญต่อเนื่องมาจาก CBD ทำให้มีความเจริญเติบโตด้านที่อยู่อาศัยและด้านการทำธุรกิจที่รวดเร็ว มีทั้งร้านค้า คาเฟ่ สตูดิโอ ไปจนถึงสำนักงานใหญ่น้อยมากมาย และด้วยตัวทำเลที่เดินทางเข้า-ออกเมืองสะดวกทั้งการเดินทางด้วยรถยนต์ และรถไฟฟ้าจากสถานีโซนบางจาก ปุณณวิถี อุดมสุข บางนา และแบริ่ง ทำให้เป็นอีกทำเลที่น่าจับตามองสำหรับการพัฒนาในด้านการเป็น Hub ที่อยู่อาศัยและเมืองธุรกิจ ซึ่งเหมาะสำหรับการซื้อ-ขายอาคารพาณิชย์กรุงเทพแห่งใหม่ของกรุงเทพมหานคร
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'ratchaphruek'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านราชพฤกษ์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โครงการบ้านราชพฤกษ์เป็นทำเลย่านอยู่อาศัยชั้นดีที่หลายคนจับตามอง เพราะเป็นโซนที่อยู่อาศัยที่มีสิ่งอำนวยความสะดวกครบครัน ไม่ว่าจะเป็น หมู่บ้าน บ้านเดี่ยว ทาวน์โฮม บ้านมือสอง แหล่งช้อปปิ้ง แหล่งกิน สถาบันการศึกษา สถานพยาบาล และการจราจรไม่ติดขัด เดินทางสะดวก โดยถนนราชพฤกษ์เริ่มตั้งแต่ฝั่งธนบุรี เชื่อมต่อกับโซนสาทรและผ่านจังหวัดนนทบุรีไปสิ้นสุดที่จังหวัดปทุมธานี
								</p>
								<p class="mt-2">
									ปัจจุบันมีรถไฟฟ้าตัดผ่านใกล้กับถนนราชพฤกษ์ด้วยกันทั้งหมด 4 สาย ได้แก่ สายสีเขียวสถานีบางหว้า สายสีน้ำเงินสถานีหัวลำโพง-บางแค สายสีแดงอ่อน และสายสีม่วงสถานีเตาปูนที่เป็นสถานีร่วมของบางซื่อ-ท่าพระ การพัฒนาระบบขนส่งมวลชนทำให้เขตบ้านราชพฤกษ์เติบโตขึ้นอย่างชัดเจน แล้วกลายเป็นทำเลที่นักลงทุนหลายคนให้ความสนใจ
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ บ้านราชพฤกษ์ บ้านเดี่ยว บ้านมือสอง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									จากการพัฒนาระบบขนส่งมวลชนมีรถไฟฟ้าเข้ามาเพิ่ม ทำให้บ้านราชพฤกษ์กลายเป็นโซนที่อยู่อาศัยที่มีราคาที่ดินสูงขึ้น พร้อมทั้งเป็นโซนหนึ่งในกรุงเทพฝั่งตะวันตกที่ครบครันแหล่งหนึ่ง ซึ่งในสายตาของนักอสังหาฯ บ้านราชพฤกษ์ สามารถแบ่งออกเป็น 3 โซน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>
													<b>บ้านราชพฤกษ์ตอนต้น</b> เป็นโซนที่หมู่บ้านราชพฤกษ์ บ้านเดี่ยว ทาวน์โฮม และบ้านมือสองใกล้กับคอมมูนิตี้ มอล มีถนนตัดผ่านหลายสาย ไม่ว่าเป็น ถนนกรุงธนบุรี ถนนสวนผัก ถนนพรานนก-พุทธมณฑล สาย4 และทางแยกต่างระดับบรมราชชนนี บางคนเรียกโซนนี้ว่า โซนราชพฤกษ์-สาธร ซึ่งมีความสะดวกสบายในการเดินทาง เหมาะสำหรับผู้บริหาร เจ้าของธุรกิจที่มีออฟฟิศอยู่ใจกลางกรุงเทพ เนื่องจากที่ดินบริเวณนี้มีราคาที่ค่อนข้างสูง
												</li>
												<li>
													<b>บ้านราชฤกษ์ตอนกลาง</b> หรือที่หลายคนเรียกว่า ราชพฤกษ์-วงเวียนพระราม5 โซนนี้จัดเป็นโซนที่อยู่อาศัยมีหมู่บ้านมากมาย เหมาะสำหรับคนที่ต้องการบ้านสักหลังที่ใกล้แหล่งกิน แหล่งช้อปปิ้ง และเดินทางเข้ากรุงเทพสะดวก ในราคาสมเหตุสมผล ซึ่งเป็นโซนที่เชื่อมต่อไปยังกรุงเทพฝั่งเหนือ ได้แก่ บางซื่อ จตุจักร ลาดพร้าว หลักสี่ สายไหม บางเขน และดอนเมือง ผ่านถนนสายหลักหลายสาย เช่น ถนนชัยพฤกษ์ ถนนนครอินทร์ และถนนสาย 345
												</li>
												<li>
													<b>บ้านราชพฤกษ์ตอนปลาย</b> เป็นโซนของถนนตัดใหม่ ผ่านถนนสาย 345 - ถนนสาย 346 ที่สามารถเดินทางเข้ากรุงเทพ และไปยังปทุมธานีได้อย่างรวดเร็ว เหมาะสำหรับคนที่ต้องการบ้านสักหลังในราคาเบาๆ และสามารถเดินทางไปทำงานได้สะดวก โดยบ้านราชพฤกษ์โซนนี้จะมีราคาถูกกว่าบ้านราชพฤกษ์ตอนต้น และตอนกลาง ซึ่งบางคนเรียกว่า โซนวงเวียนพระราม 5 - ถนน 345
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในย่านราชพฤกษ์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									เดินทางง่ายด้วยรถส่วนตัว
								</h3>
								<p class="mt-2 mb-0">
									เขตบ้านราชพฤกษ์เป็นโซนที่หลายครอบครัวให้ความสนใจ เพราะถนนตลอดทั้งเส้นไม่มีสัญญาณไฟจราจร สามารถวิ่งได้รวดเดียวจากเหนือจรดใต้ การจราจรไม่ติดขัด ถนนใหญ่ไม่ติดไฟแดง สามารถขับตั้งแต่สาทรไปถึงปทุมธานีโดยไม่ติดไฟแดงแม้แต่จุดเดียว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												และยังเชื่อมต่อถนนหลายสาย ไม่ว่าจะเป็น ถนนเส้นหลักและทางด่วนโซนฝั่งใต้สามารถเข้าสู่พื้นที่ทั้งเขตเมืองนนทบุรี และย่านศูนย์กลางธุรกิจใจกลางเมือง (CBD) หรือโซนฝั่งเหนือที่เชื่อมกับถนนหลักที่สามารถมุ่งหน้าสู่จังหวัดนนทบุรีและปทุมธานีได้อย่างรวดเร็ว
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2 mb-0">
												แม้ว่าโซนราชพฤกษ์จะสามารถเดินทางด้วยรถยนต์สะดวกสบายแล้ว ยังมีรถไฟฟ้าตัดผ่านเข้าใกล้กับถนนราชพฤกษ์ทั้งหมด 4 สาย ซึ่งช่วยให้การเดินทางของผู้ที่อาศัยในโซนราชพฤกษ์เดินทางสะดวกมากขึ้น ไม่ว่าจะเป็น
											</p>
											<ul>
												<li>
													<b>สายสีเขียว</b> สถานีบางหว้า เป็นเส้นทางที่สะดวกต่อการเดินทางเข้าเมืองมาก
												</li>
												<li>
													<b>สายสีน้ำเงิน</b> เป็นสถานีที่เชื่อมต่อระหว่างสถานีบางหว้ากับสถานีสายสีน้ำเงิน ส่วนต่อขยายหัวลำโพง-บางแค
												</li>
												<li>
													<b>สายสีแดงอ่อน</b> รถไฟฟ้าชานเมืองที่เชื่อมต่อกับรถไฟฟ้าสายสีแดงเข้ม  อย่างสถานีกลางบางซื่อ
												</li>
												<li>
													<b>สายสีม่วง</b> สถานีเตาปูนที่เป็นสถานีร่วมของบางซื่อ-ท่าพระ
												</li>
											</ul>
											<p class="mt-2">
												การที่ที่มีรถไฟฟ้าตัดผ่านนอกจากจะช่วยเพิ่มความสะดวกสบายให้กับคนที่อยู่ในเขตราชพฤกษ์แล้ว ยังช่วยให้โซนราชพฤกษ์เติบโตขึ้นอย่างรวดเร็ว ส่งผลให้ราคาบ้านราชพฤกษ์มีอัตราสูงขึ้นเรื่อยๆ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ความโดดเด่นย่านราชพฤกษ์ พระราม 5
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การลงทุนซื้อบ้านราชพฤกษ์ ไม่ว่าจะเป็น หมู่บ้านราชพฤกษ์ บ้านเดี่ยว บ้านแฝด หรือ คอนโด ถือว่าเป็นการลงทุนที่น่าสนใจและคุ้มค่าอย่างมาก เพราะเป็นโซนที่เชื่อมต่อกับถนนหลายสายช่วยให้เดินทางได้สะดวกและรวดเร็ว ใกล้กับศูนย์การค้า สถานศึกษา สถานพยาบาล และรายล้อมไปด้วยธรรมชาติ ที่สำคัญราคาที่ดินและบ้านราชพฤกษ์มีแนวโน้มที่จะปรับสูงขึ้นเรื่อยๆ ในอนาคต
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												บ้านราชพฤกษ์จัดว่าเป็นโซนที่มีความหลากหลายและคึกคักไม่แพ้โซนอื่นๆ ในใจกลางเมืองกรุงเทพฯ โดยมีศูนย์การค้าและคอมมูลนิตี้ มอลล์มากมาย เพื่อรองรับคนในพื้นที่และผู้ที่สัญจรไปมา ไม่ว่าจะเป็น เดอะ วอล์ค ราชพฤกษ์ เซ็นทรัล เวลต์เกต เซ็นทรัล รัตนาธิเบศร์ เทสโก้ โลตัส และเดอะ เซอร์เคิล ราชพฤกษ์  เป็นต้น
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับครอบครัวที่มีเด็กเล็ก หรือ ลูกน้อย ที่กำลังอยู่ในวัยอนุบาล ประถม และมัธยม โซนราชพฤกษ์ยังมีสถานศึกษาที่มีคุณภาพ คอยรองรับความต้องการของคนในพื้นที่ ไม่ว่าจะเป็น โรงเรียนอนุบาลเด่นหล้า โรงเรียนสารสาสน์วิเทศราชพฤกษ์ และโรงเรียนนานาชาติ อีกมากมาย
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับผู้ที่ซื้อบ้านเดี่ยว บ้านราชพฤกษ์ หากเกิดเหตุการณ์ไม่คาด หรือ สถานการณ์ฉุกเฉินต่างๆ ระแวงรอบๆ มีสถานพยาบาลที่มีมาตรฐาน เตรียมพร้อมรองรับกับสถานการณ์ต่างๆ ไม่ว่าจะเป็น โรงพยาบาลเกษรราษฎร์ รัตนาธิเบศน์ และ โรงพยาบาลพยาบาลกรุงไทย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาในอนาคตย่านราชพฤกษ์ พระราม 5
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ปัจจุบันโซนราชพฤกษ์ พระราม 5 ได้รับการพัฒนาและมีอัตราการเติบโตอย่างรวดเร็ว ทำให้กลายเป็นโซนที่รวมความหลากหลายของผู้อยู่อาศัย และกลายเป็นทำเลศักยภาพ ส่งผลต่อราคาที่ดินทำให้ราคาที่ดิน บ้านราชพฤกษ์ ทาวน์โฮม และคอนโดสูงขึ้นอย่างต่อเนื่อง
								</p>
								<p class="mt-2">
									สำหรับผู้ที่ตัดสินใจซื้อบ้านราชพฤกษ์ ในอนาคตโซนราชพฤกษ์มีแนวโน้มการพัฒนาในหลายด้าน ไม่ว่าจะเป็น ด้านคมนาคม ที่มีระบบขนส่งมวลอย่างรถไฟฟ้าตัดใหม่เข้ามา และถนนหลักต่างๆ ที่ค่อนข้างกว้างขวางมีหลายช่องจราจรทำให้การจราจรไม่ติดขัด และถนนหลักยังเชื่อมต่อกับทำเลหลักอื่นๆ เช่น ศูนย์กลาง CBD สาทร-ตาก  นอกจากนี้ยังมีโครงการอสังหาริมทรัพย์ ได้แก่ หมู่บ้าน บ้านเดี่ยว และคอนโดมิเนียน ที่มีแนวโน้มที่จะเกิดขึ้นใหม่เรื่อยๆ
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ส่งเสริมไลฟ์สไตล์ของคุณที่บ้านราชพฤกษ์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									บ้านราชพฤกษ์เป็นย่านที่อยู่อาศัยที่กำลังได้รับความนิยม เพราะเป็นโซนที่ตอบโจทย์กับไลฟ์สไตล์ของคนที่ชอบความสงบ แต่ทำงานในเมือง โดยบ้านราชพฤกษ์สามารถเดินเข้าเมืองได้ง่าย การจราจรไม่ติดขัด ถนนเส้นหลักเชื่อมต่อกับถนนหลายสาย และเป็นโซนที่มีแหล่งของกิน แหล่งช้อปปิ้ง และสาธารณูปโภคที่ครบครันมากที่สุดในย่านปริมณฑล เหมาะสำหรับการลงทุน เพราะในอนาคตโซนราชพฤกษ์ พระราม 5 มีแนวโน้มที่จะเจริญมากกว่าเดิม ทำให้ราคาที่ดิน บ้าน และคอนโดมิเนียนมีโอกาสที่จะสูงขึ้นเรื่อยๆ
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'rama-2'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านพระราม2
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ถึงแม้ว่าย่านพระราม 2 จะเป็นเขตชานเมือง แต่ก็มีความพัฒนาและความเจริญไม่ต่างจากพื้นที่ใจกลางเมือง และมีแผนที่จะพัฒนาต่อไปในอนาคตข้างหน้า  จึงทำให้บ้านพระราม2 เป็นอีกหนึ่งทำเลที่น่าสนใจในตอนนี้
								</p>
								<p class="mt-2 mb-0">
									สำหรับใครที่สนใจโครงการบ้านพระราม2 ไม่ว่าจะเป็น บ้านเดี่ยว ทาวน์โฮม บ้านมือสอง รวมไปถึงบ้านหรู ย่านพระราม 2 มีบ้านหลากหลายราคาให้คุณได้เลือกซื้อตามความสนใจ ตั้งแต่ราคาไม่เกิน 2 ล้าน จนไปถึงราคาหลักสิบล้าน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												มาดูกันว่าบ้านพระราม2 มีอะไรที่โดดเด่นและมีสิ่งอำนวยความสะดวกอะไรบ้าง ที่จะทำให้ส่งเสริมไลฟ์สไตล์ของคุณให้ดียิ่งขึ้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในย่านพระราม2
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									เดินทางง่ายด้วยรถส่วนตัว
								</h3>
								<p class="mt-2">
									สำหรับใครจะมาซื้อบ้านพระราม 2 ด้วยรถส่วนตัว สามารถใช้ถนนเส้นทางด่วนศรีรัชและทางด่วนกาญจนาภิเษกฯ แล้วขับรถลงด่านเก็บค่าผ่านทางพิเศษบางขุนเทียน 1 ก็จะเข้าสู่ตัวเมืองเขตบางขุนเทียนทันที
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้าและขนส่งสาธารณะ
											</h3>
											<p class="mt-2 mb-0">
												เส้นทางคมนาคมแถวบ้านพระราม 2 ในเขตบางขุนเทียน จะมี
											</p>
											<ul>
												<li>
													รถโดยสารประจำทาง 558
												</li>
												<li>
													บริการวินมอเตอร์ไซต์ หน้าเซ็นทรัลพระราม 2 และ เดอะไบรท์ พระราม 2
												</li>
												<li>
													บริการรถตู้ หน้าเซ็นทรัลพระราม 2
												</li>
												<li>
													รถสองแถว บริการรับส่งปลายทางประจำแถวถนนพระราม 2 เส้นหลักที่วิ่งไปมาอยู่เสมอ นอกจากนี้ยังมี รถไฟฟ้าบีทีเอสสายสีม่วงเตาปูน-ราษฎร์บูรณะ จะเพิ่มสถานีย่านแถวพระราม 2 ในอนาคตที่จะมาเปิดในช่วงปี 2570
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านพระราม2
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ศูนย์การค้าใกล้เคียง
								</h3>
								<p class="mt-2">
									ศูนย์การค้าที่ใกล้อยู่ใจกลางเมืองพร้อมใกล้กับแถวบ้านพระราม 2 จะมี เซ็นทรัลพระราม 2 , เดอะไบรท์ พระราม 2 , เทสโก้โลตัส , บิ๊กซีและ ห้างเปิดใหม่ล่าสุด ท็อปส์ คลับ พระราม 2 แหล่งศูนย์รวมสินค้านำเข้าจากต่างประเทศเสมือนซุปเปอร์มาเก็ตขนาดใหญ่
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถานศึกษาประจำแถวบ้านพระราม 2 จะมีตั้งแต่ระดับปฐมวัยจนไปถึงเตรียมอุดมศึกษา ได้แก่ โรงเรียนบางขุนเทียนศึกษา , โรงเรียนจินดาศึกษา , โรงเรียนวัดเลา และโรงเรียนวัดบางขุนเทียนนอก นอกจากนี้ยังมีมหาวิทยาลัยประจำบางขุนเทียน 2 วิทยาเขต คือ มหาวิทยาลัยพระจอมเกล้าฯ สาขาบางมด กับ สาขาบางขุนเทียน
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถาบันรักษาแถวบ้านพระราม 2 จะมี โรงพยาบาลนครธน. ที่อยู่ติดเซ็นทรัล พระราม2 นอกจากนี้จะมีโรงพยาบาลบางมด, โรงพยาบาลบางปะกอก 8 และ บางปะกอก 9 ที่อยู่ติดขนานกับถนนพระราม 2 เส้นหลัก จึงทำให้ผู้เดินทางสังเกตเห็นตึกได้ง่าย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านพระราม2
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ในปัจจุบันบ้านพระราม 2 ย่านถนนพระราม 2 เส้นหลัก เป็นถนนใหญ่ที่เชื่อมต่อกับเส้นทางเข้าตัวเมืองกรุงเทพฯ ในทิศเหนือด้วยการขึ้นทางด่วนถนนกาญจนาภิเษกไปโซนบางนา หรือจะเข้าตัวเมืองหลวงด้วยการขับรถเข้าโซนนนทบุรีอีกด้วย อีกทั้งถ้าเดินทางในเส้นถนนพระราม 2 ต่อไป จะเป็นเส้นทางออกไปทางต่างจังหวัดอย่างสมุทรสาคร , สมุทรสงคราม , ชะอำ และแถวหัวหินในภาคใต้ได้อีกด้วย จึงทำให้เขตบางขุนเทียนมีสิ่งอำนวยความสะดวกที่ครบครัน จึงทำให้มีโครงการบ้านพระราม 2 ประเภท บ้านเดี่ยว ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด แล้วบ้านมือ 2 ในราคาไม่เกิน 2 ล้านบาท มากมาย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ไลฟ์สไตล์สุดชิลที่บ้านพระราม2
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									บ้านพระราม 2 เขตบางขุนเทียน จัดว่าเป็นแหล่งทำเลที่มีศักยภาพในการเจริญเติบโตสูง ไม่ว่าจะเป็นขนส่งสาธารณะอย่างรถไฟฟ้าที่กำลังเปิดในอนาคต ย่านช้อปปิ้งชื่อดังอย่างเซ็นทรัลพระราม 2 กับ ซุปเปอร์มาเก็ตขายสินค้านำเข้าห้างใหม่อย่าง ท็อปส์ คลับ ให้คุณได้สนุกกับการซื้อของชิลๆ สบายๆ ใครสนใจซื้อที่อยู่อาศัยในหมู่บ้านหรือบ้านมือสองพระราม 2 สามารถติดต่อนายหน้าหาบ้านกับ The Best Property ที่จะมาช่วยค้นหาบ้านแถวพระราม 2 ที่ใช่กับไลฟ์สไตล์ของคุณ ไม่ว่าจะหาบ้านหรูพระราม 2 บ้านเดี่ยวพระราม 2 โปรดไว้ใจบริการของเรา เพราะเราเชี่ยวชาญช่วยประเมินตรวจสอบคุณภาพบ้านพระราม 2  รวมไปถึงการวิเคราะห์ทำเลตลอดจนปิดการซื้อ-ขาย สนใจติดต่อได้ที่เบอร์โทร
									<a href="tel:020474282">02-047-4282</a> หรือ แอดไลน์
									<a
										href="https://line.me/ti/p/@thebestproperty"
										target="_blank"
									>
										@thebestproperty
									</a>
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'ladprao'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านลาดพร้าว
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับใครที่สนใจโครงการหมู่บ้านลาดพร้าว ต้องการซื้อบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม หรือหาบ้านเช่าในเขตลาดพร้าว ต้องยอมรับว่าย่านลาดพร้าวเป็นทำเลศักยภาพที่มีอัตราความต้องการครอบครองที่ดินสูงขึ้นอย่างต่อเนื่องในทุกๆ ปี
								</p>
								<p class="mt-2 mb-0">
									เพราะเป็นย่านที่รวมความเจริญที่ครบครัน ไม่ต่างจากย่านสยามหรือทองหล่อ ด้วยระบบคมนาคมและสิ่งอำนวยความสะดวกต่างๆ ที่สามารถรองรับความต้องการของคนในพื้นได้ พร้อมทั้งเขตลาดพร้าวยังเป็นเส้นทางการคมนาคมไปสู่จุดหมายปลายทางต่างๆ ได้อีกด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												ลองมาดูกันดีกว่า ว่ามีอะไรบ้างที่ทำให้บ้านลาดพร้าวกลายเป็นทำเลทองของผู้คนทั่วไป และนักลงทุนหลายๆ คน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในย่านลาดพร้าว
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การเดินทางในย่านลาดพร้าวเป็นอีกหนึ่งปัจจัย ที่ทำให้หลายครอบครัวตัดสินใจเลือกซื้อบ้านลาดพร้าว เพราะสามารถเดินทางได้สะดวกหลากหลายวิธี ไม่ว่าจะเป็น รถยนต์ส่วนตัว รถเมล์ รถตู้ หรือ รถไฟฟ้า BTS และยังมีการพัฒนาอยู่เรื่อยๆ อย่างต่อเนื่อง ซึ่งบ้านลาดพร้าวก็ตอบโจทย์การใช้ชีวิตประจำวันของหลายๆ คน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2 mb-0">
												การเดินทางด้วยรถยนต์ส่วนตัวเป็นอีกหนึ่งวิธีการเดินทางที่หลายคนเลือกใช้ สำหรับผู้ที่อาศัยในย่านลาดพร้าว หรือ ตัดสินใจซื้อบ้านลาดพร้าว ห้าแยกพร้าวลาดนับว่าใจกลางของย่านที่เป็นจุดเชื่อมต่อของถนนหลักหลายสาย โดยถนนแต่ละเส้นจะมุ่งไปสู่ย่านเศรษฐกิจสำคัญทั้งหมด ได้แก่ ถนนลาดพร้าว ถนนพหลโยธิน และถนนวิภาวดีรังสิต เป็นต้น
											</p>
											<p class="mt-2">
												ซึ่งเขตลาดพร้าวนับว่าเป็นย่านเศรษฐกิจที่ได้ปรับการพัฒนาเส้นทางคมนาคมอยู่เสมอ ทำให้แม้ว่าจะมีปริมาณรถยนต์ที่ค่อนข้างหนาแน่น หลายๆ คนยังคงเลือกเดินทางด้วยรถยนต์ส่วนตัว เพราะเป็นวิธีเดินทางที่สะดวก และมีเส้นทางอื่นๆ ที่สามารถเลี่ยงจุดวิกฤติที่รถติดได้
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2 mb-0">
												ปัจจุบันรถไฟฟ้า BTS สายสีเขียวมีส่วนต่อขยายมาจนถึงเขตลาดพร้าวแล้ว ทำให้การเดินทางของคนในพื้นที่สะดวกสบายมากขึ้น โดยสามารถขึ้นรถไฟฟ้า BTS สายสีเขียว สถานีห้าแยกลาดพร้าวอยู่ติดกับห้างสรรพสินค้าขนาดใหญ่อย่างเซ็นทรัลลาดพร้าวได้
											</p>
											<p class="mt-2">
												ซึ่งรถไฟฟ้า BTS สถานีห้าแยกลาดพร้าวเชื่อมต่อรถไฟฟ้าอีกหลายสาย ไม่ว่าจะเป็น รถไฟฟ้าสายสีเหลืองส่วนต่อขยาย รัชดา-แยกรัชโยธิน ที่มีแผนก่อสร้างในอนาคต และ สายสีชมพู แคราย-มีนบุรี นอกจากนี้ห้าแยกลาดพร้าวยังใกล้กับสถานีกลางบางซื่อ ที่เป็นสถานีศูนย์กลางของรถไฟฟ้าหลายสาย และในอนาคตมีแผนจะขยายและเปิดให้บริการรถไฟฟ้าสายสีเขียวเพิ่มอีกหลายสถานี
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ความโดดเด่นย่านลาดพร้าว
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ย่านลาดพร้าวเดิมที่เป็นย่านที่อยู่อาศัย แต่ต่อมาเมื่อมีการพัฒนาคมนาคมและสิ่งอำนวยความสะดวกต่างๆ เช่น มีรถไฟฟ้า BTS สายสีเขียว ทำให้ปัจจุบันสองข้างทางมีบ้านลาดพร้าว บ้านเดี่ยว ทาวน์โฮม และคอนโด ขึ้นมาเต็มสองข้างทาง และกลายเป็นย่านเศรษฐกิจที่มีความคึกคักตลอดเวลา
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												บ้านลาดพร้าวเป็นย่านเศรษฐกิจที่มีศูนย์การค้า หรือ ห้างสรรพสินค้าหลายแห่ง ซึ่งสามารถรองรับคนในพื้นที่ และ ผู้ที่สัญจรไปมาได้อย่างเพียงพอ โดยห้างสรรพสินค้าในย่านลาดพร้าว ได้แก่ เซ็นทรัลลาดพร้าว ยูเนี่ยนมอลล์ เซ็นทรัลเฟสติวัล อีสต์วิลล์ เดอะ คริสตัล และ เดอะมอลล์ บางกะปิ นอกจากนี้ย่านลาดพร้าวยังเป็นย่านที่สามารถเดินทางไปห้างสรรพสินค้าในเขตอื่นๆ ได้สะดวก เช่น เซ็นทรัลเวิลด์ สยามพารากอน และอื่นๆ
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับครอบครัวที่มีเด็กเล็ก หรือ ลูกหลานที่กำลังอยู่ในวัยประถมหรือมัธยม บ้านลาดพร้าวมีสถานศึกษาที่มีชื่อเสียงโด่งดังหลายที่ ไม่ว่าจะเป็น โรงเรียนหอวัง โรงเรียนสตรีวรนาถบางเขน โรงเรียนเซนต์จอห์น โรงเรียนบีคอนเฮาส์ แย้มสะอาดลาดพร้าว วิทยาลัยอาชีวศึกษาสันติราษฎร์ ในพระอุปถัมภ์ฯ
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับผู้ที่ซื้อโครงการคอนโด หมู่บ้าน บ้านเดี่ยว บ้านลาดพร้าว หากเกิดเหตุการณ์ไม่คาดคิด หรือ สถานการณ์ฉุกเฉินต่างๆ ระแวงรอบๆ มีสถานพยาบาลที่มีมาตรฐาน เตรียมพร้อมรองรับกับสถานการณ์ต่างๆ  ไม่ว่าจะเป็น โรงพยาบาลมิราเคิล ออฟไลฟ์ ที่อยู่ห่างจากห้าแยกลาดพร้าวเพียง 1.25 กิโลเมตร โรงพยาบาลเปาโล พหลโยธิน อยู่ห่างจากห้าแยกลาดพร้าว 2.3 กิโลเมตร และ โรงพยาบาลโกลเด้นเยียส์ ที่อยู่ห่างจากห้าแยกลาดพร้าว 4 กิโลเมตร
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาในอนาคตย่านลาดพร้าว
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ปัจจุบันย่านลาดพร้าวได้เจริญเติบโตขึ้นอย่างรวดเร็ว และมีการพัฒนาทำให้เป็นย่านที่เต็มไปด้วยความหลากหลายของผู้อยู่อาศัย ส่งผลให้ย่านลาดพร้าวเป็นทำเลที่มีศักยภาพสูง และพื้นที่ส่วนใหญ่ได้ถูกจับจองและนำไปพัฒนาแทบจะทุกตารางเมตร ทำให้โครงการบ้านลาดพร้าวหาได้ค่อนข้างยาก และมีราคาที่ค่อนข้างสูง
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												ซึ่งอีกไม่นานเมื่อสถานีรถไฟฟ้าเปิดให้บริการครบทั้งหมดทุกเส้นทางแล้ว ย่านลาดพร้าวจะกลายเป็นย่านที่มีศักยภาพมากขึ้นและมีมูลค่าที่ดินสูงขึ้น และปฏิเสธไม่ได้เลยว่าถนนรัชดา - ห้าแยกลาดพร้าว เป็นทำเลแห่งศักยภาพที่จะกลายเป็นศูนย์กลางเศรษฐกิจใหม่ของประเทศไทยในอนาคต
											</p>
											<p class="mt-2">
												นอกจากนี้บริเวณลาดพร้าวตอนต้น หรือ Northern CBD กลายเป็นทำเลที่มีศักยภาพสูงสุดในเขตลาดพร้าว หลังจากที่สถานีรถไฟฟ้าห้าแยกลาดพร้าวได้เปิดให้บริการ ได้ทำลายข้อครหาในเรื่องการจราจรติดไปจนหมด ช่วยให้ผู้คนสามารถเดินทางได้สะดวกมากยิ่งขึ้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ส่งเสริมไลฟ์สไตล์ของคุณที่บ้านลาดพร้าว
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านลาดพร้าวเป็นย่านที่เต็มไปด้วยความหลากหลาย และเพียบพร้อมไปด้วยไลฟ์สไตล์ทุกรูปแบบที่ตอบโจทย์ชีวิตสังคมเมือง ไม่ว่าจะเป็น ที่อยู่อาศัยหลากหลายรูปแบบให้เลือกสรร แหล่งช้อปปิ้งที่มีศูนย์การค้าขนาดใหญ่ แหล่งออฟฟิศ สวนสาธารณะ สถาบันการศึกษา สถานพยาบาล และขนส่งมวลชนที่เปิดให้บริการ ช่วยให้การเดินทางสะดวกสบายมากขึ้น
								</p>
								<p class="mt-2">
									สำหรับผู้ที่ตัดสินใจซื้อบ้านลาดพร้าวในโครงการบ้านเดี่ยว ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด หรือ บ้านมือสองแถวลาดพร้าว ไม่จำเป็นต้องกังวลเรื่องสิ่งอำนวยความสะดวกขั้นพื้นฐานที่ควรจะมีไปได้เลย ซึ่งย่านลาดพร้าวเป็นย่านที่เหมาะกับผู้คนหลากหลายกลุ่ม และสามารถตอบโจทย์ไลฟ์สไลต์ชีวิตของคนเมืองได้อย่างยอดเยี่ยม
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'phaholyothin'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านพหลโยธิน
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									จากที่ได้เกริ่นไปข้างต้นว่าโครงการบ้านพหลโยธินมีรูปแบบบ้านภายในโครงการให้เลือกเป็นจำนวนมากไม่ว่าจะเป็นบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม หรือจะเป็นบ้านติดรถไฟฟ้าก็มีให้เลือกเช่นกัน แต่ข้อมูลเพียงเท่านี้ก็ยังไม่เพียงพอต่อความน่าสนใจในย่านพหลโยธิน เพราะย่านนี้เต็มไปด้วยความครึกครื้น รวมไปถึงความสะดวกสบายที่มาพร้อมกับสาธารณูปโภคอย่างครบครัน อีกทั้งในแต่ละโครงการก็ยังมีแนวโน้มว่าจะถูกพัฒนาให้ดีมากยิ่งขึ้นทั้งในแง่ของการเดินทาง การใช้ชีวิต หรือความสะดวกสบายที่จำเป็นต่อการใช้ชีวิตก็ถูกเลือกให้เป็นปัจจัยหลักที่สำคัญในแต่ละโครงการด้วย โดยเราได้รวบรวมความน่าอยู่ของบ้านพหลโยธินมาให้คุณได้นำมาพิจารณาว่าควรจะเลือกซื้อบ้านพหลโยธินหรือไม่ และถ้าอ่านบทความนี้จบขอบอกเลยว่าคุณจะต้องชอบย่านพหลโยธินอย่างแน่นอน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในย่านพหลโยธิน
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ถ้าอยากจะเลือกซื้อบ้านใกล้รถไฟฟ้าเราอยากให้คุณเลือกบ้านพหลโยธิน เนื่องจากการเดินทางของเส้นพหลโยธินสามารถเดินทางได้ง่ายและสะดวกไม่ว่าจะใช้รถส่วนตัวหรือใช้บริการรถไฟฟ้าก็สามารถเดินทางไปยังสถานที่สำคัญในกรุงเทพได้ทั้งหมด
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												หากคุณมีรถส่วนตัวแล้วอยากเดินทางไปสถานที่ต่าง ๆ ในย่านพหลโยธินก็หมดห่วงได้เลยว่าจะต้องเดินทางไกล เพราะสิ่งอำนวยความสะดวกอยู่ล้อมรอบเต็มไปหมด อีกทั้งก็ยังหมดห่วงในเรื่องเส้นทางเพราะมีถนนที่สร้างใหม่ เดินทางได้สะดวก ไม่ต้องแออัดและเสี่ยงในการโดนรถยนต์คันอื่นเบียด ซึ่งย่านบ้านพหลโยธินถือได้ว่าเป็นถนนสายหลักของใจกลางกรุงเทพเลยทีเดียว เพราะอยู่ใกล้กับเขตต่าง ๆ เช่น เขตราชเทวีตัดผ่านเขตพญาไท เขตจตุจักร เขตบางเขนและเขตดอนเมืองก็อยู่ในเส้นพหลโยธินอีกด้วย ดังนั้นถ้าคุณมีรถส่วนตัวและอยากจะเดินทางด้วยรถของคุณเอง บ้านย่านพหลโยธินก็สามารถใช้รถเดินทางได้สะดวก เพราะถนนเส้นพหลโยธินอยู่ใกล้กับถนนเส้นหลักมากมายสามารถเข้าถึงใจกลางเมืองได้รวดเร็วอีกด้วย
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												ใครที่อยู่บ้านพหลโยธิน ในส่วนของการเดินทางด้วยรถไฟฟ้าในย่านพหลโยธินก็สามารถเดินทางได้สะดวก ไม่ว่าจะเป็นรถไฟฟ้าหรือรถไฟฟ้าใต้ดิน ก็มีให้บริการอยู่หลายสถานี เช่น รถไฟฟ้าสายสีเขียวที่สามารถเดินทางไปยังสถานที่ใจกลางเมืองอย่างสยาม ทองหล่อ อโศก หรือรถไฟฟ้าสายสีแดงก็สามารถเดินทางไปยังรังสิต-บางซื่อ และในอนาคตย่านบ้านพหลโยธินก็จะมีรถไฟฟ้าสายสีชมพูที่จะเชื่อมต่อกันทำให้การเดินทางสะดวกสบายมากยิ่งขึ้น ไม่ต้องต่อรถไฟฟ้าหรือรถอื่น ๆ อีกหลายต่อ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านพหลโยธิน
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									สำหรับบ้านพหลโยธินเป็นทำเลที่มีศักยภาพและเหมาะสมกับการอยู่อาศัยเป็นอย่างมาก เนื่องจากสามารถเข้าหรือออกเมืองได้สะดวก อีกทั้งการเดินทางถือว่าสะดวกมากถึงแม้จะใช้รถส่วนตัวก็ตาม และย่านนี้ยังรายล้อมไปด้วยสถานที่ Community Mall อีกด้วย ถ้าหากคุณมาอาศัยอยู่ที่นี่คุณสามารถใช้ชีวิตประจำวันกับครอบครัวได้อย่างเต็มที่ และยังมีสถานที่สำหรับทำกิจกรรมในครอบครัวไม่ว่าจะเป็นการทานข้าว เที่ยว หรือพักผ่อนในวันหยุด รวมไปถึงสถานศึกษาและสถานพยาบาลก็ยังอยู่ในย่านนี้ไม่ต้องเดินทางไกลออกนอกเขตนี้เลย โดยรวมแล้วบ้านพหลโยธินเป็นย่านที่เหมาะมาก ๆ สำหรับคนที่ต้องการหมู่บ้านใกล้รถไฟฟ้าหรือหมู่บ้านที่เต็มไปด้วยสิ่งอำนวยความสะดวก รวมไปถึงสามารถทำกิจกรรมกับครอบครัวได้ในวันหยุดหรือวันสำคัญของครอบครัวได้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												แน่นอนว่าการมีศูนย์การค้าที่เต็มไปด้วยสิ่งอำนวยความสะดวก ไม่ว่าจะเป็นร้านเสื้อผ้า ร้านรองเท้า ร้านอาหารชื่อดังรวมไปถึงโรงภาพยนตร์ ใคร ๆ ก็อยากให้อยู่ใกล้กับละแวกบ้านของตนเอง ซึ่งบ้านพหลโยธินเป็นย่านที่เต็มไปด้วยศูนย์การค้ามากมายที่พร้อมให้บริการคุณอย่างแน่นอน เช่น เซ็นทรัลลาดพร้าวที่เป็นศูนย์การค้าขนาดใหญ่และได้รับความนิยมเป็นอย่างมากจากคนในละแวกนั้น และฟิวเจอร์พาร์ค รังสิต ก็ถือได้ว่าเป็นศูนย์การค้าขนาดใหญ่ที่ได้รับความนิยมไม่แพ้กัน หรือจะเมเจอร์ ซีนีเพล็กซ์ รัชโยธินที่เป็นทั้งศูนย์การค้าและโรงภาพยนตร์ที่มีบริการครบวงจร
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2 mb-0">
												นอกจากนี้ทางด้านมหาวิทยาลัยก็อยู่ในละแวกบ้านพหลโยธินเหมือนกัน เช่น มหาวิทยาลัยรังสิต มหาวิทยาลัยธรรมศาสตร์ มหาวิทยาลัยกรุงเทพ และมหาวิทยาลัยนอร์ท กรุงเทพ ทั้งหมดนี้เป็นเพียงแค่ส่วนหนึ่งที่เราอยากให้คุณหายห่วงได้เลยว่ามีสถานศึกษาชื่อดังมากมายอยู่ในย่านนี้ และไม่ต้องกังวลเรื่องเผื่อเวลาสำหรับการเดินทางเพราะสามารถเดินทางได้สะดวกเป็นอย่างมาก
											</p>
											<p class="mt-2">
												หนึ่งในการหาสถานศึกษาสำหรับบุตรหลาน คือ สถานศึกษาที่อยู่ใกล้บ้านหรือเป็นสถานศึกษาที่สามารถเดินทางไปได้ง่ายและสะดวก ไม่ต้องเผื่อเวลาการเดินทางหลายชั่วโมงเพื่อไปให้ทันเข้าเรียน และย่านพหลโยธินเป็นย่านที่ตอบโจทย์ข้อนี้เป็นอย่างมาก เพราะบ้านพหลโยธินเต็มไปด้วยสถานศึกษาชื่อดังที่อยู่ในละแวกนี้ เช่น โรงเรียนหอวัง โรงเรียนสวนกุหลาบรังสิต โรงเรียนบีคอนเฮาส์แย้มสอาดรังสิต โรงเรียนนานาชาติสยาม และโรงเรียนสาธิตมหาวิทยาลัยธรรมศาสตร์ก็อยู่ในย่านนี้เช่นกัน
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถานที่สำคัญอีกอย่างสำหรับการเลือกซื้อหมู่บ้านนอกจากจะเป็นสถานศึกษา ศูนย์การค้าหรือแหล่งอำนวยความสะดวกแล้วนั้นยังต้องศึกษาด้วยว่าบ้านในละแวกนั้นอยู่ใกล้กับสถานพยาบาลหรือไม่ เนื่องจากถ้าหากเกิดเหตุฉุกเฉินก็สามารถเดินทางไปยังสถานพยาบาลได้อย่างทันท่วงที ซึ่งบ้านพหลโยธินเองก็อยู่ใกล้กับสถานพยาบาลชื่อดังไม่ว่าจะเป็นโรงพยาบาลเปาโลเมโมเรียล โรงพยาบาลเอกชนที่ให้บริการทางการแพทย์ครบวงจร โรงพยาบาลสายหยุดที่เป็นโรงพยาบาลที่ให้บริการครบวงจรเช่นกันและยังให้บริการตรวจสุขภาพเคลื่อนที่อีกด้วย ดังนั้นถ้าหากมีเหตุการณ์ฉุกเฉินเกิดขึ้นก็หมดห่วงได้เลยว่าคุณจะเดินทางไปได้ทันเวลาอย่างแน่นอน หากเลือกซื้อบ้านพหลโยธิน
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ทำเลและที่อยู่อาศัยย่านพหลโยธิน
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ทำเลย่านพหลโยธินเป็นย่านที่เต็มไปด้วยสำนักงานภาคเอกชนหลายแห่งรวมไปถึงสำนักงานรัฐวิสาหกิจ หรือหน่วยงานภาครัฐด้วยเช่นกันที่อยู่ภายในละแวกนี้ ซึ่งย่านบ้านพหลโยธินนี้ก็ถือได้ว่าเป็นสถานที่ที่ใครหลาย ๆ คนอยากมาอาศัยอยู่ เนื่องจากใกล้สถานที่ทำงานอีกทั้งยังเดินทางได้สะดวก ถึงแม้จะไม่ใช้คนในพื้นที่หรือเป็นคนต่างจังหวัดที่มาทำงานที่กรุงเทพก็ยังเลือกที่จะอาศัยในคอนโดหรือบ้านในย่านพหลโยธิน
								</p>
								<p class="mt-2">
									เนื่องจากบ้านพหลโยธินอยู่ติดกับรถไฟหลายสาย อีกทั้งยังสามารถเดินทางไปสนามบินดอนเมืองหรือสนามบินสุวรรณภูมิได้สะดวกอีกด้วย เพียงแค่ใช้รถไฟฟ้าใต้ดินหรือแอร์พอร์ตลิงก์ก็เดินทางไปสนามบินได้แล้ว ซึ่งจากเหตุผลเหล่านี้ก็ทำให้เกิดความต้องการทางด้านที่อยู่อาศัยของบ้านพหลโยธินที่สูงมาก และมันยังส่งไปยังธุรกิจอสังหาริมทรัพย์ก็ครึกครื้นเนื่องจากเกิดความต้องการสูงในเรื่องของที่อยู่อาศัยรวมไปถึงธุรกิจและการค้าก็เช่นกัน ซึ่งที่ผ่านมานี้หลังจากที่การก่อสร้าง BTS ได้เสร็จสิ้นลง การพัฒนาถนนย่านนี้ก็มีความเรียบร้อยมากยิ่งขึ้นด้วย แม้ว่าที่ผ่านมาการก่อสร้างทำให้ถนนหลายสายในย่านนี้เกิดหลุมหรือทางขรุขระทำให้เดินทางได้ไม่สะดวก แต่ปัจจุบันก็มีถนนเดินทางที่ดีขึ้น ทำให้ย่านบ้านพหลโยธินหายห่วงเรื่องการเดินทาง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ส่งเสริมไลฟ์สไตล์ของคุณที่บ้านพลโยธิน
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ย่านพหลโยธินเป็นอีกสถานที่ที่เต็มไปด้วยความอุดมสมบูรณ์ ความครึกครื้นรวมไปถึงความสะดวกสบายที่รายล้อมไปด้วยสิ่งอำนวยความสะดวกและสาธารณูปโภคที่เข้าถึงได้อย่างครบครัน ทั้งนี้สภาพแวดล้อมของบ้านพหลโยธินก็ยังเงียบสงบถึงแม้จะเต็มไปด้วยศูนย์การค้าหรืออาคารสำนักงานมากมาย
								</p>
								<p class="mt-2">
									อย่างไรก็ตามย่านบ้านพหลโยธินก็ยังคงเป็นย่านที่เราอยากให้คุณได้ลองมาสัมผัสถึงความสะดวกในการใช้ชีวิตประจำวันซึ่งคุณจะต้องชื่นชอบอย่างแน่นอน เพราะไม่ว่าจะหันไปทางไหนก็จะเจอแต่สภาพแวดล้อมที่ครบครันในเรื่องการเดินทาง ศูนย์การค้า สถานพยาบาลและสถานศึกษา โดยทั้งหมดนี้จะทำให้ชีวิตในแต่ละวันของคุณง่ายมากขึ้นที่บ้านพหลโยธิน
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'ramintra'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านรามอินทรา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									รามอินทราถือว่าเป็นพื้นที่ที่ได้รับอิทธิพลความเจริญและมีการเติบโตทางเศรษฐกิจแบบก้าวกระโดด มีรถไฟฟ้าสายสีชมพูวิ่งผ่าน มีถนนหลายสายตัดผ่าน ผู้อยู่อาศัยบ้านรามอินทราจึงสามารถเดินทางได้สะดวกไม่ว่าเป็นรถยนต์ส่วนตัวหรือรถประจำทาง มีห้างสรรพสินค้าชั้นนำ ร้านอาหาร คาเฟ่ สวนสาธารณะ โรงเรียน และโรงพยาบาลเปิดให้บริการหลายแห่ง ซึ่งแทบไม่ต่างอะไรกับการใช้ชีวิตอยู่ใจกลางเมืองกรุงเทพ แถมรถไม่ติด ที่อยู่อาศัยไม่แออัด ผู้ที่อยู่บ้านรามอินทราสามารถใช้ชีวิตแบบสโลว์ไลฟ์ท่ามกลางความเจริญได้
								</p>
								<p class="mt-2">
									การมีบ้านจัดสรร ทาวน์โฮม บ้านมือสอง ย่านรามอินทรา วงแหวน นวมินทร์ เลียบด่วน เป็นอีกหนึ่งตัวเลือกที่ดีสำหรับคุณและคนในครอบครัว เพราะบ้านรามอินทราถือว่าเป็นการลงทุนที่คุ้มค่า เพื่อคุณภาพชีวิตซึ่งต้องมาพร้อมกับที่อยู่อาศัยที่ดี และสิ่งแวดล้อมรอบบ้านที่น่าอยู่ การซื้ออสังหาริมทรัพย์ถือว่าเป็นการวางเงินก้อนโตและต้องใช้เวลาผ่อนนานหลายปี ดังนั้นก่อนจะตัดสินใจซื้อบ้านสักหลังเราอยากให้คุณคำนึงถึงสภาพความเป็นอยู่และบริเวณโดยรอบ เราขอเป็นส่วนหนึ่งในการคัดสรรคุณภาพชีวิตที่ดีให้คุณกับโครงการบ้านรามอินทรา
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในย่านรามอินทรา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ย่านรามอินทราถือว่าเป็นอีกหนึ่งย่านที่สามารถตัดผ่านไปยังถนนสายอื่น ๆ ได้เยอะ ทำให้มีรถยนต์ส่วนตัว รถไฟฟ้า และขนส่งสาธารณะหลายสายขับผ่าน วันนี้เราได้รวบรวมวิธีการเดินทาง 3 รูปแบบที่สะดวกสบายสำหรับผู้สนใจบ้านรามอินทราไว้ให้แล้ว จะมีอะไรบ้างไปดูกันเลย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												รามอินทราเป็นย่านที่มีถนนตัดผ่านเพื่อเชื่อมไปยังถนนสายอื่นได้หลายสาย เช่น ถนนนวมินทร์ ถนนคู้บอน ถนนพระยาสุเรนทร์ ถนนประดิษฐ์มนูธรรม และเสรีไทย ซึ่งง่ายต่อการขับเข้าเมืองหรือออกนอกจังหวัด นอกจากนี้ยังมีทางด่วนพิเศษเพื่ออำนวยความสะดวกรวดเร็วในการเดินทาง ซึ่งมีอยู่ 2 เส้นทางด้วยกันคือ ทางพิเศษฉลองรัช ตั้งอยู่บริเวณถนนรามอินทราตัดกับถนนประดิษฐ์มนูธรรม และทางพิเศษกาญจนาภิเษก ตั้งอยู่บริเวณแยกเดอะพรอมานาด
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												อีกไม่นานจะมีรถไฟฟ้าสายสีชมพูวิ่งเปิดให้บริการ โดยวิ่งผ่านเส้นทาง แคราย-ปากเกร็ด-หลักสี่-วงแหวนรอบนอก-มีนบุรี ซึ่งรถไฟฟ้าสายนี้จะเริ่มวิ่งจากถนนรัตนาธิเบศร์บริเวณด้านหน้าศูนย์ราชการจังหวัดนนทบุรี และเลี้ยวซ้ายผ่านแยกแครายเข้าสู่ถนนติวานนท์ ผ่านสถาบันโรคทรวงอก แยกสนามบินน้ำ วัดชลประทานรังสฤษดิ์ ไปจนถึง 5 แยกปากเกร็ด จากนั้นรถไฟฟ้าจะเลี้ยวขวาผ่านศูนย์ประชุมอิมแพ็ค ศูนย์ราชการเฉลิมพระเกียรติ 80 พรรษา และแยกหลักสี่วงเวียนอนุสาวรีย์พิทักษ์รัฐธรรมนูญ จากนั้นรถไฟฟ้าจะวิ่งตามเส้นรามอินทรามุ่งหน้าสู่มีนบุรี ระยะทางในการวิ่งรถไฟฟ้าของสายนี้จะอยู่ที่ 34.5 กิโลเมตร
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยขนส่งสาธารณะ
											</h3>
											<p class="mt-2 mb-0">
												ย่านรามอินทราจะมีรถเมล์ รถตู้ รถสองแถว วินมอเตอร์ไซค์ คอยให้บริการอยู่ทั่วบริเวณตลอดทั้งวัน โดยมีรถประจำทางที่วิ่งผ่าน ดังนี้
											</p>
											<ul>
												<li class="mt-2">
													รถเมล์<br>
													รถเมล์สาย 22 :  ต้นสายสวนสยาม - ปลายทางสาธุประดิษฐ์<br>
													รถเมล์สาย 22 :  ต้นสายสวนสยาม - ปลายทางสาธุประดิษฐ์<br>
													รถเมล์สาย 26 :  ต้นสายมีนบุรี - ปลายทางอนุสาวรีย์<br>
													รถเมล์สาย 36 :  ต้นสายห้วยขวาง - ปลายทางท่าน้ำสี่พระยา<br>
													รถเมล์สาย 60 :  ต้นสายหมู่บ้านปัฐวิกรณ์ - ปลายทางปากคลองตลาด<br>
													รถเมล์สาย 71 :  ต้นสายสวนสยาม - ปลายทางวัดธาตุทอง<br>
													รถเมล์สาย 96 :  ต้นสายมีนบุรี - ปลายทางสถานีรถไฟฟ้าหมอชิต<br>
													รถเมล์สาย 115 : ต้นสายเคหะร่มเกล้า - ปลายทางสีลม
												</li>
												<li class="mt-2">
													รถตู้<br>
													มีรถตู้หลายสายวิ่งผ่านถนนรามอินทรา เพื่อวิ่งตามทางไปยังมหาวิทยาเกษตรศาสตร์ เซ็นทรัลรามอินทรา เซ็นทรัลลาดพร้าว จตุจักร อนุสาวรีย์ชัยสมรภูมิ หรือแยกออกไปทาง มหาวิทยาลัยรังสิต เซียรังสิต ฟิวเจอร์พาร์ครังสิต หรือจะมุ่งหน้าสู่สายแจ้งวัฒนะ เป็นต้น
												</li>
												<li class="mt-2">
													รถสองแถว<br>
													รถสองแถวจะมีคิวรถจอดอยู่ที่บริเวณหน้าห้างสรรพสินค้าแฟชั่นไอแลนด์ เพื่อวิ่งให้บริการตลอดเส้นรามอินทรา
												</li>
												<li class="mt-2">
													วินมอเตอร์ไซค์<br>
													คิววินมอเตอร์ไซค์จะตั้งอยู่ทั่วบริเวณถนนรามอินทราตามจุดต่าง ๆ เช่น ตลาด หน้าห้างสรรพสินค้า หน้าหมู่บ้าน ป้ายรถเมล์ และหัวมุมซอยต่าง ๆ เป็นต้น
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ความโดดเด่นย่านรามอินทรา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									โครงการหมู่บ้านรามอินทราเป็นพื้นที่ที่มีสิ่งอำนวยความสะดวกรอบด้านอย่างครบครันไม่ว่าจะเป็นศูนย์การค้า สถานศึกษา และสถานพยาบาล ซึ่งยังไม่รวมคาเฟ่ ร้านอาหาร และพื้นที่ให้บริการรูปแบบอื่น ๆ ทำให้ผู้อยู่อาศัยในย่านนี้ไม่ต้องเดินทางไกลเพื่อไปใช้บริการ แต่วันนี้เราจะมาพูดถึง 3 ปัจจัยหลักเพื่อเป็นตัวเลือกในการตัดสินใจให้แก่คุณก่อน ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<ul>
												<li>เดอะ พรอมานาด ถนนรามอินทรา</li>
												<li>แฟชั่นไอส์แลนด์ ถนนรามอินทรา</li>
												<li>เซ็นทรัล เฟสติวัล อีสต์วิลล์ ถนนประดิษฐ์มนูธรรม</li>
												<li>คริสตัล ดีไซน์ เซ็นเตอร์ (CDC)  ถนนประดิษฐ์มนูธรรม</li>
												<li>เดอะวอล์ค เกษตร-นวมินทร์  ถนนประดิษฐ์มนูธรรม</li>
												<li>ชิครีพลับบลิค สาขาประดิษฐ์มนูธรรม  ถนนประดิษฐ์มนูธรรม</li>
												<li>เดอะ คริสตรัล พาร์ค รามอินทรา ถนนประดิษฐ์มนูธรรม</li>
												<li>อีสพาร์คคอมมูนิตี้ มอลล์ ถนนรามอินทรา</li>
												<li>เดอะ แจ๊ส รามอินทรา ถนนลาดปลาเค้า</li>
												<li>บิ๊กซี สาขารามอินทรา ถนนรามอินทรา</li>
												<li>เทสโก้ โลตัส สาขารามอินทรา ถนนรามอินทรา</li>
												<li>แม็คโคร สาขารามอินทรา ถนนรามอินทรา</li>
												<li>โฮมโปร สาขาเอกมัย-รามอินทรา ถนนประดิษฐ์มนูธรรม</li>
												<li>โรบินสัน สาขารามอินทรา ถนนรามอินทรา</li>
											</ul>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<ul>
												<li>โรงเรียนเลิศหล้า ถนนเกษตร-นวมินทร์</li>
												<li>โรงเรียนสาธิตพัฒนา ถนนปัญญาอิทรา</li>
												<li>โรงเรียนสายอักษร ถนนรามอินทรา</li>
												<li>โรงเรียนสารสาสน์วิเทศสายไหม ถนนสุขาภิบาล5</li>
												<li>โรงเรียนบดินทรเดชา (สิงห์ สิงหเสนี) 2 ถนนนวมินทร์</li>
												<li>โรงเรียนสตรีวิทยา 2 ถนนสุคนธสวัสดิ์</li>
												<li>โรงเรียนสตรีเศรษฐบุตรบำเพ็ญ ถนนสีหบุรานกิจ</li>
												<li>โรงเรียนอมาตยกุล ถนนพหลโยธิน</li>
												<li>โรงเรียนโสมาภานุสรณ์ บดินทรเดชา ถนนนวมินทร์</li>
												<li>โรงเรียนนานาชาตินีวาอเมริกัน ย่านเลียบด่วนรามอินทรา</li>
												<li>มหาวิทยาลัยศรีปทุม ถนนพหลโยธิน</li>
												<li>มหาวิทยาเกษตรศาสตร์ ถนนงามวงศ์วาน</li>
											</ul>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<ul>
												<li>โรงพยาบาลซีจีเอช สายไหม</li>
												<li>โรงพยบาล.อินทรารัตน์ รามอินทรา</li>
												<li>โรงพยาบาลสินแพทย์ รามอินทรา โรงพยาบาลเอกชนระดับศูนย์การแพทย์ บนถนนรามอินทรา</li>
												<li>โรงพยาบาลพญาไท นวมินทร์ ถนนนวมินทร์</li>
												<li>โรงพยาบาลนวเวช ถนนรัชดา-รามอินทรา</li>
												<li>โรงพยาบาลคลองสามวา ถนนไมตรีจิตต์</li>
												<li>โรงพยาบาลนพรัตน์ฯ โรงพยาบาลในสังกัดกระทรวงสาธารณสุข</li>
												<li>โรงพยาบาลเสรีรักษ์ ถนนเสรีไทย</li>
												<li>โรงพยาบาลรามคำแหง ถนนรามคำแหง ใกล้แยกลำสาลี</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ทำเลและที่อยู่อาศัยย่านรามอินทรา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ความเจริญจากใจกลางเมืองกรุงเทพได้แพร่อิทธิพลครอบคลุมมาถึงย่านบ้านรามอินทรา ซึ่งทำให้ย่านนี้เป็นที่จับตามองของนักลงทุนไม่ว่าจะเป็นด้านอสังหาริมทรัพย์ ด้านศูนย์การค้า ร้านอาหาร และร้านคาเฟ่อย่างมาก ที่ย่านรามอินทรากลายมาเป็นพื้นที่ทำเลทองได้นั้น เนื่องจากอยู่ไม่ไกลจากใจกลางเมืองมากนัก มีถนนตัดผ่านหลายสาย มีรถไฟฟ้าวิ่งผ่าน ใกล้ทางด่วน และมีสาธารณูปโภคที่ครบครัน บ้านรามอินทราจึงเหมาะสำหรับคนยุคใหม่ที่ไม่ต้องการใช้ชีวิตแบบเร่งรีบ
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ไลฟ์สไตล์สุดชิลที่บ้านรามอินทรา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สภาพแวดล้อมย่านบ้านรามอินทราถือว่าเป็นพื้นที่ทำเลคุณภาพ ผู้คนไม่แออัด ปลอดโปร่ง ไม่ค่อยมีตึกสูงคอยบดบังทัศนวิสัย และน้อยมากที่จะมีโรงงานปล่อยแก๊ซ ปล่อยควัน หรือปล่อยของเสียลงสู่คลอง สภาพความเป็นอยู่ของผู้คนไม่พลุกพล่าน มีจุดบริการรถสาธารณะทุกพื้นที่ ผู้ที่อยู่บ้านรามอินทราสามารถเดินทางโดยใช้บริการขนส่งสาธารณะได้สะดวก
								</p>
								<p class="mt-2">
									ถ้าหากคุณใช้รถยนต์ส่วนตัวในการเดินทาง สามารถเลือกใช้เส้นทางลัดตัดผ่านซอยหรือแยกต่าง ๆ เพื่อมุ่งหน้าสู่ถนนสายอื่นได้เช่นกัน หรือจะใช้บริการทางด่วนพิเศษที่มีให้บริการถึง 2 สายได้แก่ ทางพิเศษฉลองรัชและทางพิเศษกาญจนาภิเษก นอกจากยังมีโครงการบ้านจัดสรรเกิดขึ้นมากมายเพื่อรองรับผู้ที่ต้องการย้ายมาอยู่บ้านรามอินทรา ไม่ว่าจะเป็นบ้านเดี่ยว บ้านมือหนึ่ง บ้านมือสอง บ้านแฝด บ้านทาวน์เฮ้าส์ บ้านทาวน์โฮม หรือคอนโดมิเนียม ซึ่งมาพร้อมกับระบบสาธารณูปโภคแบบครบวงจร เหมาะสำหรับผู้ที่ชอบความสะดวกสบายที่พบเจอได้ง่าย ๆ ใกล้บ้าน
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'lat-krabang'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านลาดกระบัง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านลาดกระบังในปัจจุบันเริ่มมีมูลค่าที่ดินที่เพิ่มสูงขึ้นเรื่อย ๆ ในทุก ๆ ปี เนื่องจากการขยายตัวของตัวเมือง และสิ่งอำนวยความสะดวกต่าง ๆ ทำให้เรียกได้ว่า บ้านเดี่ยวแถวร่มเกล้า แถวลาดกระบัง รวมถึงที่อยู่อาศัยประเภทอื่น ๆ ในย่านแถวนี้ จัดได้ว่าอยู่ในทำเลทอง ที่มีศักยภาพที่จะพัฒนามูลค่า และอัตราความต้องการถือครองที่ดินในที่นี้สูงขึ้นเรื่อย ๆ อย่างต่อเนื่อง
								</p>
								<p class="mt-2">
									แม้จะมีระยะทางที่ไกลจากใจกลางเมืองกรุงเทพ แต่หมู่บ้านแถวลาดกระบังก็มีความครบครันของสิ่งอำนวยความสะดวกไม่ต่างจากในย่านใจกลางเมืองอย่างสยาม หรือสีลม ทั้งโรงพยาบาล ห้างสรรพสินค้า โรงเรียน มหาวิทยาลัย พร้อมทั้งมีระบบคมนาคมที่สะดวกรองรับความต้องการของคนในพื้นที่ได้ และยังเพิ่มความสะดวกสบายไปอีกขั้นสำหรับผู้ที่ชอบเดินทาง เพราะบ้านลาดกระบังนั้นอยู่ใกล้กับสนามบินสุวรรณภูมิ และเป็นย่านที่ออกสู่ต่างจังหวัดในภาคตะวันออกของประเทศไทยได้อย่างรวดเร็วและนอกจากนี้มีปัจจัยอะไรอีกบ้าง? ที่ทำให้บ้านลาดกระบังทั้งมือหนึ่ง และ มือสอง เป็นที่นิยมอย่างมากในผู้คนทั่วไป และกลุ่มนักลงทุนหลายๆ ท่าน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านลาดกระบัง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การเดินทางในย่านลาดกระบังเป็นอีกหนึ่งปัจจัย ที่ผู้อยู่อาศัยเลือกตัดสินใจซื้อ - ขายบ้านลาดกระบังกัน เพราะในย่านลาดกระบัง รวมถึงละแวกใกล้เคียง ไม่เพียงแค่เดินทางสะดวกด้วยรถยนต์ส่วนตัวเท่านั้น แต่ยังมีขนส่งสาธารณะอื่น ๆ ที่สะดวกสบายอื่น ๆ อย่างรถเมล์ รถตู้ รถไฟ หรือ รถไฟฟ้า ที่ยังมีการพัฒนาเส้นทางเพิ่มมากขึ้นอยู่เรื่อย ๆ อย่างต่อเนื่อง ทำให้บ้านลาดกระบังสามารถตอบโจทย์การใช้ชีวิตประจำวันของผู้อยู่อาศัยในกรุงเทพหลาย ๆ ท่านได้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2 mb-0">
												หากพูดถึงถนนเส้นหลักของย่านลาดกระบังนั้นคือ ถนนลาดกระบัง เป็นหนึ่งในถนนเส้นสำคัญของชาวกรุงเทพ ที่สามารถใช้เดินทางออกสู่ภาคตะวันออกของประเทศไทยได้ ถึงแม้จะเป็นถนนที่ออกสู่ต่างจังหวัด แต่ตัวถนนมีการซ่อมบำรุง ดูแลอยู่อย่างสม่ำเสมอ ทำให้สภาพถนนดูดีไม่ต่างจากถนนในตัวเมืองเลย อีกทั้งยังมีช่องจราจรที่กว้างขวาง แบ่งแยกทิศทางการวิ่งของรถอย่างชัดเจน และมีไหล่ทางมากพอให้รถสามารถจอดพักรถได้
											</p>
											<p class="mt-2">
												ส่วนเส้นทางการเดินทางเข้าสู่ตัวเมืองนั้นก็ไม่ได้มีความยากลำบาก เพราะถนนลาดกระบัง ติดกับเส้นทางของถนนรามคำแหงที่จะมุ่งตรงไปสู่เขตลาดพร้าว ที่นับเป็นย่านเศรษฐกิจสำคัญอีกย่านหนึ่งของกรุงเทพ
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้าและขนส่งสาธรณะ
											</h3>
											<p class="mt-2 mb-0">
												ในย่านลาดกระบังมีขนส่งสาธารณะทั้งรถตู้ รถไฟ รถเมล์ที่มีสายสำคัญ เช่น รถเมล์สาย 92 รถเมล์สาย 517 รถเมล์สาย 553 และรถเมล์สาย 555 และนอกจากนี้ยังมีการให้บริการขนส่งรถไฟฟ้าแอร์พอร์ต เรล ลิงก์ที่เป็นอีกหนึ่งทางเลือกที่ใช้เดินทางเข้าสู่ส่วนกรุงเทพชั้นในได้อย่างรวดเร็ว ซึ่งเป็นเส้นทางการเดินทางสุวรรณภูมิ - พญาไท - บางซื่อ จะเห็นได้ว่าไม่เพียงแค่เป็นเส้นทางเดินทางเข้าสู่พื้นที่กรุงเทพชั้นในเท่านั้น แต่ยังเป็นเส้นทางตรงเข้าสู่สนามบินสุวรรณภูมิด้วยเช่นกัน
											</p>
											<p class="mt-2">
												ที่สำคัญรถไฟฟ้าแอร์พอร์ต เรล ลิงก์ยังใช้เป็นเส้นทางเชื่อมต่อสู่ระบบขนส่งสาธารณะอื่น ๆ ได้อีก และในปัจจุบันนี้ยังมีการก่อสร้างสายรถไฟฟ้าเพิ่มเติมที่สามารถเชื่อมต่อไปยังเส้นทางอื่น ๆ ได้ในอนาคต เช่น
											</p>
											<ul>
												<li>
													เชื่อมต่อกับรถไฟฟ้า BTS ที่สถานีพญาไท เพื่อเดินทางเข้าสู่รถไฟฟ้า BTS สายอื่น ๆ เช่น สายสีลม สายบางหว้า สายแบริ่ง สายหมอชิต - คูคต
												</li>
												<li>
													เชื่อมต่อกับรถไฟฟ้าใต้ดิน MRT ที่สถานีมักกะสัน (หรือสถานี MRT เพชรบุรี)
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านลาดกระบัง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									พูดกันอย่างให้เข้าใจง่าย ๆ เลยนั้น คือ ย่านลาดกระบัง ถือเป็นพื้นที่ทำเลทองของกรุงเทพส่วนตะวันออก เพราะเป็นหนึ่งในย่านของจุดเชื่อมต่อของระบบคมนาคมหลากหลายเส้นทาง ทั้งถนนสายหลัก ถนนสายรอง รวมถึงทางด่วนในการเข้า - ออกตัวเมือง และจุดพิเศษของย่านลาดกระบังเลยก็คือ ระบบขนส่ง แอร์พอร์ต เรล ลิงก์ ที่เป็นเหมือนตัวเชื่อมระหว่างใจกลางเมืองกรุงเทพไปสู่สนามบินสุวรรณภูมิ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												บ้านลาดกระบังเป็นอีกหนึ่งย่านที่มีห้างสรรพสินค้าหลากหลายแห่ง สามารถรองรับทั้งคนในพื้นที่ และ ผู้ที่สัญจรไปมาได้อย่างเพียงพอ โดยห้างสรรพสินค้าในย่านลาดกระบัง ได้แก่
											</p>
											<ul>
												<li>โรบินสัน ไลฟ์สไตล์ ลาดกระบัง</li>
												<li>แม็คโคร ลาดกระบัง</li>
												<li>สยามพรีเมี่ยมเอาท์เล็ต</li>
												<li>เซ็นทรัล วิลเลจ</li>
												<li>แบงค็อก มอลล์</li>
												<li>เดอะพาซิโอมอลล์ ลาดกระบัง</li>
												<li>ซีคอนสแควร์</li>
												<li>พาราไดซ์ พาร์ค</li>
												<li>เมกาบางนา</li>
												<li>มาร์เก็ตวิลเลจ สุวรรณภูมิ</li>
											</ul>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับครอบครัวที่มีเด็กเล็ก หรือ ลูกหลานที่กำลังอยู่ในวัยอนุบาล ประถม หรือมัธยม ก็ไม่ต้องเป็นกังวล เพราะบ้านแถวลาดกระบัง ร่มเกล้ามีสถานศึกษาที่มีชื่อเสียง โด่งดังทั้งโรงเรียนรัฐบาล และเอกชนหลายที่รองรับในส่วนนี้ ไม่ว่าจะเป็น โรงเรียนเทพศิรินทร์ร่มเกล้า โรงเรียนสารสาสรน์วิเทศร่มเกล้า หรือในครอบครัวที่มีบุตรหลานที่กำลังจะศึกษาต่อในระดับมหาวิทยาลัย ย่านบ้านลาดกระบังก็มีสถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง มหาวิทยาลัยมีชื่อเสียงอันดับต้น ๆ ของประเทศไทยรองรับอยู่ด้วย
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับผู้ที่อยู่อาศัยในย่านบ้านลาดกระบังก็ไม่ต้องกังวลใจ หากเกิดกรณีฉุกเฉิน หรือสถานการณ์ไม่คาดฝันขึ้น เพราะในบริเวณรอบ ๆ ในเขตลาดกระบัง มีสถานพยาบาลที่มีมาตรฐาน เตรียมพร้อมรับรองสถานการณ์อยู่ ไม่ว่าจะเป็นโรงพยาบาลลาดกระบัง อยู่ห่างจากรถไฟฟ้าแอร์พอร์ต เรล ลิงก์ ลาดกระบัง 4.7 กิโลเมตร และ โรงพยาบาลสิรินธร โรงพยาบาลจุฬารัตน์ ที่เป็นโรงพยาบาลที่สำคัญในย่านนี้
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาของทำเลและที่อยู่อาศัยย่านลาดกระบัง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									แรกเริ่มเดิมทีย่านลาดกระบังเป็นชุมชนอยู่อาศัยที่เติบโตมาจากย่านมีนบุรีมาอย่างยาวนานแล้วกว่า 80 ปี แต่ต่อมาย่านลาดกระบังถูกภาครัฐวางบทบาทให้เป็นย่านอุตสาหกรรม จึงขับเคลื่อนย่านนี้ด้วยนิคมอุตสาหกรรม ควบคู่กับการเกิดที่อยู่อาศัยที่รองรับคนทำงานในย่านนี้เป็นหลัก แต่ต่อมาเมื่อการขยายตัวของสิ่งอำนวยความสะดวกจากภายในตัวเมืองกรุงเทพขยายมา ไม่ว่าจะระบบขนส่งรถไฟฟ้า ห้างสรรพสินค้า โรงพยาบาล โรงเรียนต่าง ๆ รวมถึงการสร้างสนามบินสุวรรณภูมิขึ้นมาในบริเวณใกล้เคียง ทำให้ในที่สุดย่านลาดกระบังจึงเป็นทำเลทองในปัจจุบันที่ใคร ๆ ก็เริ่มจะให้ความสนใจเข้ามาลงทุนซื้อ - ขาย หรือย้ายเข้ามาพักอาศัยในย่านบ้านลาดกระบัง จึงเริ่มเกิดโครงการบ้านลาดกระบังใหม่ ๆ ทั้ง บ้านจัดสรร ทาวน์โฮม ทาวน์เฮ้าส์ คอนโดลาดกระบังขึ้นนั่นเอง
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ออกแบบไลฟ์สไตล์ของคุณที่บ้านลาดกระบัง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านลาดกระบังแม้แต่เดิมภาครัฐจะวางโครงสร้างให้พื้นที่ส่วนนี้เป็นพื้นที่ของนิคมอุตสาหกรรม แต่ในปัจจุบันเราจะเห็นได้ว่าพื้นที่ในย่านลาดกระบัง ถูกพัฒนาให้เจริญก้าวหน้าขึ้นไปมาก และยังมีโครงการใหญ่จากภาครัฐอีกมากมายที่จะถูกสร้างขึ้นในอนาคต ทั้งสนามบินสุวรรณภูมิ เฟส 2 รถไฟความเร็วสูง เชื่อมต่อ 3 สนามบิน ได่แก้ สนามบินดอนเมือง สนามบินสุวรรณภูมิ สนามบินอู่ตะเภา รวมถึงโครงการจากส่วนของภาคเอกชนอีกด้วย
								</p>
								<p class="mt-2">
									สำหรับผู้ที่ตัดสินใจซื้อบ้านลาดกระบังในโครงการบ้านเดี่ยว ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด หรือ บ้านมือสองแถวลาดกระบัง ก็คงคลายความกังวลในเรื่องสิ่งอำนวยความสะดวกขั้นพื้นฐานที่ควรจะมีไปได้เลย เพราะบ้านแถวลาดกระบังสามารถตอบโจทย์ความต้องการในส่วนนี้ของผู้อยู่อาศัยไปได้
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'saimai'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านสายไหม
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านสายไหม แต่เดิมเป็นพื้นที่ได้รับความเจริญขยายตัวออกมาจากพื้นที่ใกล้เคียงอย่างย่านบางเขน ย่านดอนเมือง ทำให้ในปัจจุบันย่านสายไหม หรือย่านวัชรพลนี้เป็นพื้นที่เจริญพื้นที่หนึ่งของกรุงเทพส่วนเหนือ มีการเปิดทำการของห้างสรรพสินค้ารายใหญ่ ๆ ประกอบกับโรงพยาบาล สถานศึกษาจำนวนมาก ทำให้ปัจจุบันบ้านสายไหมจึงเป็นหนึ่งในพื้นที่ทำเลทองที่มีการซื้อ - ขายบ้านสายไหมในกลุ่มผู้อยู่อาศัย และนักลงทุนมากยิ่งขึ้น
								</p>
								<p class="mt-2 mb-0">
									ไม่เพียงเท่านั้นอีกหนึ่งจุดสำคัญที่บ้านสายไหมดึงดูดกลุ่มผู้อยู่อาศัยทั่วไป และนักลงทุนก็คือ หมู่บ้านสายไหมนั้นแวดล้อมไปด้วยพื้นที่สาธารณะ พื้นที่สีเขียว เอาใจผู้อาศัยสายรักธรรมชาติ สายออกกำลังกาย หรืออยากใช้ชีวิตเงียบสงบ แบบ Slow Life
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												แม้จะไม่ได้เป็นสวนสาธารณะขนาดใหญ่ แต่บ้านแถวสายไหมก็มีสวนสาธารณะหลายสวนกระจายอยู่รอบ ๆ เขต ทำให้ใครที่คิดอยากจะมาปลูกที่อยู่อาศัยไม่ว่าจะบ้านเดี่ยว บ้านมือสอง ทาวน์เฮ้าส์ ทาวน์โฮม คอนโด ย่านเขตสายไหม เพื่อให้ได้รับพลังงานในการพักผ่อนหย่อนใจอย่างเต็มที่ ไม่ควรปล่อยให้บ้านสายไหมหลุดออกจากหนึ่งตัวเลือกลิสต์ในใจของคุณ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในย่านสายไหม
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การเดินทางของผู้อยู่อาศัยในแถบบ้านสายไหมนั้นไม่ได้ลำบากอย่างที่ใครหลายคนคิด เพราะเส้นทางและระบบขนส่งสาธารณะในย่านนี้มีการพัฒนาใหม่อยู่อย่างสม่ำเสมอ ตามแผนการขยายเส้นทางคมนาคมของภาครัฐ เพื่อช่วยให้การสัญจรในย่านสายไหม และวัชรพลคล่องตัวมากยิ่งขึ้น พร้อมสนับสนุนให้ภาพรวมของพื้นที่บริเวณนี้เจริญเติบโตมากยิ่งขึ้นไปอีก
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2 mb-0">
												การเดินทางด้วยรถยนต์ส่วนตัวไม่ใช่เรื่องยากสำหรับผู้อยู่อาศัยละแวกบ้านสายไหม เพราะย่านสายไหมนี่มีถนนหลากหลายเส้นทางในการเชื่อมต่อไปยังพื้นที่ต่าง ๆ โดยถนนเส้นหลักของย่านสายไหม คือ ถนนสายไหม ซึ่งยาวต่อเนื่องมาจากถนนพหลโยธินยาวไปถึงคลองบึงพระยาสุเรนทร์
											</p>
											<p class="mt-2 mb-0">
												แม้ถนนสายไหมจะไม่ได้กว้างมาก แต่มีสภาพถนนที่ดี มีซอยแยกย่อยจากถนนเส้นหลักจำนวนมาก สามารถทะลุไปยังถนนลำลูกกาได้ เนื่องจากมีซอยแยกย่อยเยอะ ทำให้ถึงแม้ในเวลาเร่งด่วน จะมีปริมาณรถแน่นหนา ก็สามารถทำการลัดเลาะไปยังซอยต่าง ๆ ได้
											</p>
											<p class="mt-2">
												ไม่ใช่แค่ถนนสายหลักเท่านั้น แต่ย่านสายไหมยังมีทางพิเศษอีก 2 เส้นทาง คือ วงแหวนรอบนอกกรุงเทพมหานครฝั่งตะวันออก หรือทางพิเศษกาญจนพิเษก และทางพิเศษฉลองรัช
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้าและขนส่งสาธรณะ
											</h3>
											<p class="mt-2 mb-0">
												สำหรับผู้อาศัยที่ไม่มีรถยนต์ส่วนตัวก็ไม่ต้องกังวลใจ เพราะในย่านสายไหมมีการให้บริการของขนส่งสาธารณะทั้งรถเมล์ และรถไฟฟ้า โดยรถเมล์ที่ให้บริการ ได้แก่ รถเมล์สาย 543 รถเมล์สาย 1009
											</p>
											<p class="mt-2">
												ในส่วนระบบขนส่งรถไฟฟ้าในย่านสายไหม คือ รถไฟฟ้าสายสีเขียว ที่เชื่อมต่อจากสถานีจตุจักรตรงยาวตามเส้นพหลโยธินไปถึงคูคต ซึ่งเป็นการเดินทางที่ช่วยประหยัดเวลาเดินทาง และสามารถเชื่อมต่อสู่พื้นที่อื่น ๆ ด้วยรถไฟฟ้าสายสีแดง (รังสิต - บางซื่อ) สายสีชมพู (มีนบุรี - แคราย)
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านสายไหม
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ในปัจจุบันปฏิเสธไม่ได้เลยว่าบ้านสายไหมเป็นอีกหนึ่งย่านดาวเด่น ที่ใครหลาย ๆ คนจับตามอง เพราะมีบรรยากาศความสะดวกสบายของความเป็นเมือง ผสมผสานกับความเงียบสงบของพื้นที่สีเขียวได้อย่างลงตัว
								</p>
								<p class="mt-2">
									ดังนั้นบ้านสายไหมนั้นมีอะไรน่าสนใจ เหมาะกับการใช้ชีวิตของคุณ ที่ตอบโจทย์ไลฟ์สไตล์คนเมืองสุดเพอร์เฟคของคุณได้บ้าง
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับสายช็อปปิ้งก็ไม่ต้องไปไกลถึงสยามแล้ว เพราะในย่านสายไหมเองกมีห้างสรรพสินค้ารองรับความต้องการของผู้อยู่อาศัยทุกขนาดรองรับ ไม่ว่าจะเป็นแหล่งชิลเอาท์เดินเล่นเพลิน ๆ หรือแหล่งเดินช็อปปิ้งอย่างจริงจัง ถูกใจรองรับทุกระดับทุกไลฟ์สไตล์ เช่น
											</p>
											<ul>
												<li>ตลาดยิ่งเจริญ (ตลาดสะพานใหม่)</li>
												<li>ซูปเปอร์มาร์เก็ตท็อปส์ ซูปเปอร์มาร์เก็ตบิ๊กซี ซูปเปอร์มาร์เก็ตโลตัส ซูปเปอร์มาร์เก็ตแม็คโคร</li>
												<li>ฟิวเจอร์พาร์ครังสิต</li>
												<li>และห้างอื่น ๆ บริเวณใกล้เคียง เช่น เมกะบางนา อีเกีย เป็นต้น</li>
											</ul>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												ครอบครัวผู้อยู่อาศัยที่มีบุตรหลานไม่ว่าจะรุ่นวัยอนุบาล ประถม มัธยม หรือโตถึงระดับมหาวิทยาลัย ก็ไม่ต้องกังวลใจว่าจะต้องเดินทางไปศึกษาไกล เพราะในย่านบ้านสายไหมเอง ก็มีสถานศึกษาที่มีชื่อเสียง มีคุณภาพได้มาตรฐานระดับประเทศรองรับอยู่จำนวนมาก ให้ผู้ปกครองและลูกหลานของท่านสามารถเลือกเข้าศึกษาได้ตามต้องการ ได้แก่
											</p>
											<ul>
												<li>โรงเรียนสารสาสน์วิเทศสายไหม</li>
												<li>โรงเรียนฤทธิยะวรรณาลัย</li>
												<li>โรงเรียนศิริวัฒน์วิทยา</li>
												<li>โรงเรียนราชวินิตบางเขน</li>
												<li>โรงเรียนสาธิตแห่งมหาวิทยาลัยเกษตรศาสตร์</li>
												<li>มหาวิทยาลัยเกษตรศาสตร์</li>
												<li>มหาวิทยาลัยรังสิต</li>
												<li>มหาวิทยาลัยกรุงเทพฯ</li>
												<li>มหาวิทยาลัยศรีปทุม</li>
											</ul>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												ในกรณีที่อาจจะเกิดเหตุการณ์ไม่คาดฝัน หรือมีอาการเจ็บป่วยใด ๆ ก็ไม่ต้องกังวลใจ เนื่องจากในเขตสายไหมเองก็มีสถานพยาบาลที่มีมาตรฐานมากมายทั้งของหน่วยงานรัฐ และเอกชน ที่พร้อมจะให้บริการคุณได้ทุกระดับอย่างมั่นใจ
											</p>
											<ul>
												<li>โรงพยาบาลสายไหม</li>
												<li>โรงพยาบาลซีจีเอช สายไหม</li>
												<li>โรงพยาบาล บี แคร์ เมดิคอลเซ็นเตอร์</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								จุดเด่นของทำเลและที่อยู่อาศัยย่านสายไหม
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									แต่เดิมทีสายไหมเป็นชื่อของหมู่บ้านในจังหวัดปทุมธานี ก่อนที่จะได้รับความเจริญหลั่งไหลมาจากย่านใกล้เคียงอย่างย่านบางเขน และย่านดอนเมือง ทั้งทางด้านเศรษฐกิจ การคมนาคม สาธารณูปโภค จนมีจำนวนประชากรที่อยู่อาศัยจำนวนมาก จึงถูกยกระดับเข้ามาเป็นเขตหนึ่งในกรุงเทพมหานคร ทำให้ ณ ปัจจุบันนี้ ย่านสายไหมเป็นหนึ่งใน 50 เขตการปกครองของกรุงเทพที่มีจำนวนประชากรอยู่อาศัยมากที่สุด ตั้งแต่ปี พ.ศ. 2557
								</p>
								<p class="mt-2 mb-0">
									ในปัจจุบันจึงมีโครงการที่พักอาศัยใหม่ ๆ เกิดขึ้นมากมายหลากหลายรูปแบบ ทำให้มีการซื้อ - ขายตั้งแต่บ้านเดี่ยว บ้านมือสอง ทาวเฮ้าส์ ทาวน์โฮม คอนโด เขตสายไหมอย่างครึกครื้น เป็นอีกหนึ่งย่านดาวเด่นที่ผู้ประกอบการรายใหญ่ล้วนมาปักธงเปิดโครงการที่พักอาศัย รวมถึงมาเปิดธุรกิจ และสิ่งอำนวยความสะดวกมากมายในย่านนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												นอกจากนี้ผู้พักอาศัย นักลงทุนรายเล็ก รายใหญ่ที่มองการณ์ไกล ต่างมองเห็นแนวโน้มในการเจริญเติบโตของที่ดินในย่านนี้ เพราะยังมีโพรเจกต์ยักษ์ใหญ่อีกมากมายจากภาครัฐ และภาคเอกชนที่เลือกเข้ามาพัฒนาที่ดินในย่านบ้านสายใหม่ให้เจริญรุ่งเรือง และการค้าขายในพื้นที่ครึกครื้นมากยิ่งขึ้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ส่งเสริมไลฟ์สไตล์ของคุณที่บ้านสายไหม
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									คงจะเห็นแล้วว่าบ้านสายไหมนั้นไม่ได้ห่างไกลจากความสะดวกสบายจากใจกลางเมืองอย่างที่คิด กลับเป็นย่านที่ผสมผสานไลฟ์สไตล์ระหว่างความเป็นเมือง และความเป็นชุมชนพื้นที่สีเขียวที่เงียบสงบได้อย่างลงตัว เชื่อว่าถ้าได้ลองมาสัมผัสกับบรรยากาศในบ้านแถวสายไหม คุณจะหลงรักสเน่ห์ของย่านสายไหม ได้อย่างไม่รู้ตัวแน่นอน
								</p>
								<p class="mt-2 mb-0">
									ทั้งพื้นที่สาธารณะสีเขียวที่สบายตา เหมาะแก่การพาครอบครัวออกมาทำกิจกรรมพักผ่อนร่วมกัน อย่างเดินเล่น ออกกำลังกาย หรืออยากจะสัมผัสกับบรรยากาศเมืองก็มีห้างสรรพสินค้ามากมายให้คุณไปใช้บริการ หรืออยากเดินทางเข้าสู่ใจกลางเมืองด้วยขนส่งรถไฟฟ้าก็สะดวก
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												จึงขอการันตีเลยว่าผู้ที่ตัดสินใจซื้อบ้านสายไหม ในโครงการบ้านเดี่ยว ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด หรือ บ้านมือสองแถวสายไหม คุณจะไม่ผิดหวัง เพราะย่านแห่งนี้มีมนต์สะกด และสเน่ห์เฉพาะตัวที่ชวนให้คุณมาสัมผัส และตกหลุมรักอยู่นั่นเอง
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'onnut'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านอ่อนนุช
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									หนึ่งในนิยามที่สามารถจำกัดความของโครงการบ้านอ่อนนุชได้ ก็คงเป็นวลีที่ว่า “บ้านอ่อนนุช ติดกลางเมือง เดินทางง่ายด้วยรถไฟฟ้า รายล้อมด้วยของกิน ฟินกับแหล่งช้อปปิ้ง” เพียงเท่านี้ก็เรียกความสนใจจากผู้อยู่อาศัย และนักลงทุนได้จำนวนมาก
								</p>
								<p class="mt-2">
									เพราะบ้านอ่อนนุชอยู่ติดใจกลางเมือง และยังมีระบบคมนาคมที่สะดวกด้วยรถไฟฟ้า BTS สถานีอ่อนนุช เข้าถึงย่านสยาม อโศก ทองหล่อ เอกมัยได้เลย โดยไม่ต้องต่อรถ เข้ากับไลฟ์สไตล์คนเมืองที่เร่งรีบแบบสุด ประหยัดทั้งค่าเดินทาง ประหยัดทั้งเวลา หรือจะหาที่ทำงาน WFH ก็มี Co - Working Space ให้เลือกใช้บริการได้อย่างจุใจ และยังฟินต่อกับห้างสรรพสินค้ามากมายให้เลือกกิน ดื่ม ช้อปปิ้งได้อย่างเต็มที่
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในย่านอ่อนนุช
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									อย่างที่ใคร ๆ ก็รู้กันดีว่าย่านบ้านอ่อนนุชนั้นคับคั่งไปด้วยรูปแบบการเดินทางที่สะดวกสบายหลายรูปแบบ ทำให้ผู้อยู่อาศัยในย่านนี้ไม่ต้องกลัวเลยว่าจะเดินทางไปไหนมาไหนไม่สะดวก เพราะย่านหมู่บ้านแถวอ่อนนุชนั้นมีทั้งระบบขนส่งรถไฟฟ้า BTS มีถนนหลากหลายเส้นทาง รวมไปถึงทางด่วนต่าง ๆ อีกด้วย และหากใครกลัวว่าในเวลาคับขันจะเดินทางไม่ทัน ก็ยังมีบริการวินมอเตอร์ไซต์กระจายประจำอยู่ทุกมุมถนนให้เลือกใช้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2 mb-0">
												สำหรับผู้อยู่อาศัยในโครงกาารบ้านอ่อนนุชนั้นนอกจากจะสามารถใช้งานถนนสายหลักเดินทางไปในพื้นที่ต่าง ๆ ได้ เช่น ถนนพัฒนาการ ถนนศรีนครินทร์ ถนนสุขาภิบาล ถนนกาญจนาภิเษก เป็นต้น และยังมีทางด่วนที่เชื่อมต่อไปยังเส้นทางต่าง ๆ มาตอบสนองความต้องการให้กับผู้ใช้รถใช้ถนนทุกคนให้สะดวกรวดเร็วมากยิ่งขึ้นด้วยทางขึ้น - ลงด่วนฉลองรัช ที่อยู่ภายในซอยสุขุมวิท 50
											</p>
											<p class="mt-2 mb-0">
												เท่านั้นยังไม่พอท้ายซอยสุขุมวิท 50 ยังมีทางลงทางด่วนเฉลิมมหานคร ที่นำเข้าสู่ย่านอ่อนนุชพอดิบพอดี เพื่อเชื่อมไปยังถนนทางรถไฟสายเก่าปากน้ำ ลัดไปสู่ถนนกล้วยน้ำไท ต่อด้วยถนนพระราม 4 ได้
											</p>
											<p class="mt-2">
												แต่กลับกันหากผู้อาศัยย่านบ้านอ่อนนุชต้องการเดินทางไปสู่โซนดาวคะนอง - ดินแดง - แจ้งวัฒนะ ก็สามารถใช้บริการทางด่วนเฉลิมมหานครได้ที่ซอยสุขุมวิท 54 เช่นกัน
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้าและขนส่งสาธรณะ
											</h3>
											<p class="mt-2 mb-0">
												BTS อ่อนนุชเป็นหนึ่งในรูปแบบการเดินทางที่โดดเด่นของย่านอ่อนนุช เพราะเป็นเส้นทางที่พาผู้โดยสารมุ่งตรงไปสู่ใจกลางเมือง เช่น สยาม อโศก ทองหล่อ เอกมัยได้อย่างง่ายดาย
											</p>
											<p class="mt-2">
												ไม่เพียงเท่านั้นในอนาคตย่านหมู่บ้านอ่อนนุช จะมีการพัฒนาเส้นทางรถไฟฟ้าสายใหม่ ๆ ขึ้น ได้แก่ รถไฟฟ้าสายสีเหลือง พาดผ่านฝั่งถนนศรีนครินทร์ มุ่งตรงไปยังย่านลาดพร้าว ต่อไปยังย่านสำโรง จังหวัดสมุทรปราการได้
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านอ่อนนุช
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									บรรยากาศรอบ ๆ ละแวกบ้านอ่อนนุชนั้นตอบสนองชีวิตของเป็นคนเมืองของชาวกรุงเทพได้ทุกจุด ไม่ว่าจะเต็มไปด้วยร้านอาหาร ห้างสรรพสินค้า ไม่ขาดตรงบกพร่องด้านอุปโภคบริโภคแล้ว ยังตอบโจทย์ชีวิตพนังงานออฟฟิศกรุงเทพด้วยคาเฟ่ ร้านกาแฟ Co - Working Space กระจายตัวอยู่ทุก ๆ จุด
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												ใครที่อาศัยอยู่แถบบ้านอ่อนนุชนั้นพูดได้เลยว่าคึกคักไปด้วยอาหารการกินแน่นอน เพราะบ้านย่านอ่อนนุชนั้นเต็มไปด้วยตลาดนัด ห้างสรรพสินค้า Super Store นอกจากที่จะเลือกอิ่มหนำสำราญไปกับอาหารมากมายแล้ว ยังเพลิดเพลินไปกับการช้อปปิ้งในห้างสรรพสินค้า และ Community Malls มากมายได้ เช่น
											</p>
											<ul>
												<li>Tesco Lotus อ่อนนุช</li>
												<li>Big C อ่อนนุช</li>
												<li>ตลาดนัด Big C อ่อนนุช</li>
												<li>Makro อ่อนนุช</li>
												<li>Century The Movie Plaza อ่อนนุช</li>
												<li>Street food  อ่อนนุช</li>
												<li>People Park Community Lifestyle</li>
												<li>Habito Mall Community</li>
												<li>Hubba-To Co-Working Space</li>
											</ul>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2 mb-0">
												บอกได้เลยว่าใครที่ตัดสินใจมาอาศัยอยู่ในย่านบ้านอ่อนนุช บอกได้คำเดียวเลยว่าคุณตัดสินใจไม่ผิด เพราะบ้านอ่อนนุชนั้นตอบสนองให้คุณตั้งแต่เรื่องพื้นฐานในชีวิต อย่างเรื่องของสถานศึกษาของบุตรหลานในครอบครัวของคุณ
											</p>
											<p class="mt-2">
												แรกเริ่มเดิมทีคงมีครอบครัวไม่น้อยเลยที่หากจะตัดสินใจซื้อที่อยู่อาศัยสักที่ ก็คงพึงพิจารณาถึงที่ศึกษาเล่าเรียนให้กับบุตรหลาน ซึ่งย่านอ่อนนุชเองก็สามารถทำให้คุณตัดสินใจได้ง่ายขึ้น เพราะบริเวณนี้รายล้อมไปด้วยสถานศึกษาที่มีมาตรฐาน ชื่อเสียงโดดดังทั้งโรงเรียนไทย และนานาชาติ ได้แก่
											</p>
											<ul>
												<li>โรงเรียนเตรียมอุดมศึกษาพัฒนาการ</li>
												<li>Wells International School</li>
												<li>Ekamai International School</li>
												<li>Bangkok International Preparatory and Secondary School</li>
											</ul>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												เชื่อว่าอีกหนึ่งปัจจัยในการตัดสินใจซื้อบ้านสักหลังก็คงหนีไม่พ้นเรื่องของการอยู่ใกล้สถานพยาบาล เผื่อในกรณีฉุกเฉินหรือมีเหตุการณ์ไม่คาดฝันก็จะสามารถเข้าทำการรักษาได้อย่างทันท่วงที ซึ่งในย่านอ่อนนุชนี้ก็มีโรงพยาบาลคุณภาพอย่างโรงพยาบาลสุขุมวิท  ช่วยเพิ่มความอุ่นใจ ดูแลคุณในยามเจ็บป่วย หรือประสบอุบัติเหตุได้ เพราะอยู่ใกล้ ๆ ไม่ไกลจากสถานี BTS เอกมัย ทำให้สามารถเดินทางไปถึงมือแพทย์ได้อย่างรวดเร็วทันใจ  นอกจากนี้ยังมีโรงพยาบาลกล้วยน้ำไท และคลินิกทางการแพทย์ที่อยู่ในย่านนี้อีกมากมาย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								จุดเด่นและการพัฒนาของทำเลย่านอ่อนนุช
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับผู้ที่ตัดสินใจอาศัยอยู่บ้านอ่อนนุชไม่ว่าจะเป็นบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม คอนโด หรือบ้านมือสองแถวอ่อนนุช คุณจะรู้สึกตัดสินใจไม่ผิดเลย เพราะบ้านอ่อนนุชนั้นมีแนวโน้มในการพัฒนาที่ดินเจริญเติบโตอย่างก้าวกระโดดในอนาคตแน่นอน
								</p>
								<p class="mt-2">
									ด้วยการขยับขยายตัวของรถไฟฟ้าที่ต่อยาวไปถึงยังสมุทารปราการ จึงเริ่มมีโครงการบ้านที่อยู่อาศัยแถวอ่อนนุชเกิดขึ้นมากมาย จึงนำมาสู่การลงทุนของสิ่งอำนวยความสะดวกมากมายในบริเวณนี้ ทำให้ย่านอ่อนนุชนี้มีความคึกคักไม่ต่างจากใจกลางเมืองของกรุงเทพเลย ส่งผลให้ตัวเลขผู้อยู่อาศัยในย่านอ่อนนุชเพิ่มตัวสูงขึ้นในทุก ๆ ปี  และในอนาคตเมื่อตึกอาคารออฟฟิศต่าง ๆ ขยายเข้ามาอีก จะยิ่งทำให้ทำเลนี้เป็นหนึ่งในทำเลที่น่าจับตามองของนักลงทุนทั้งชาวไทย และชาวต่างประเทศแน่นอน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								เติมเต็มไลฟ์สไตล์ของคุณที่บ้านอ่อนนุช
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับใครที่มองหาย่านทำเลที่อยู่อาศัยที่พรั่งพร้อมไปด้วยแหล่งอำนวยความสะดวกที่ครบครันตั้งแต่อาหาร สถานที่ทำงาน สถานที่ที่ตอบโจทย์ปัจจัยพื้นฐานในการใช้ชีวิต  รวมถึงสถานที่ให้ความบันเทิง หรือทำกิจกรรมยามว่าง บ้านอ่อนนุชถือว่าเป็นอีกหนึ่งทำเลที่น่าสนใจที่จะตอบสนองต่อความต้องการของคุณในจุด ๆ นี้ เท่านั้นยังไม่พอหากคุณอยากเดินทางไปสู่ใจกลางเมือง บ้านอ่อนนุชก็ยังรายล้อมไปด้วยระบบขนส่งสาธารณะที่ช่วยให้คุณภาพชีวิตของคุณดีขึ้นได้นั่นเอง
								</p>
								<p class="mt-2">
									เพราะฉะนั้นอย่ารอช้าที่จะเข้ามาสัมผัสกับบรรยากาศในย่านที่น่ารักน่าสนใจอีกหนึ่งย่าน อย่างย่านบ้านอ่อนนุช ที่มีให้คุณเลือกสรรมากมายตั้งแต่ที่อยู่อาศัยประเภทบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม คอนโด หรือบ้านมือสองครบ จบ หมดในที่เดียว
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'ramkhamhaeng'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านรามคำแหง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โครงการบ้านรามคำแหง หนึ่งในทำเลสุดฮอตถูกใจชาวเมือง ด้วยทำเลที่เชื่อมต่อกับย่านพระราม 9 พร้อมระบบการขนส่งที่หลากหลายที่เชื่อมต่อกันทั้ง Airport rail link BTS และ MRT ทำให้เรียกได้ว่า ย่านรามคำแหงนี้ เดินทางไปทางไหนก็สะดวก
								</p>
								<p class="mt-2">
									และด้วยการขยายตัวของระบบขนส่งสาธารณะเข้ามาสู่ย่านรามคำแหง ทำให้สิ่งอำนวยความสะดวกต่าง ๆ เริ่มขยายความเจริญเข้ามาสู่ในพื้นที่นี้ ทำให้รอบ ๆ ละแวกบ้านรามคำแหงมีสิ่งอำนวยความสะดวกมากมายตั้งแต่ห้างสรรพสินค้า สถาบันการศึกษา สถานพยาบาล สวนสนุก โรงหนัง ร้านอาหาร ฟิตเนส และสนามกีฬา
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านรามคำแหง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									โครงการหมู่บ้านแถวรามคำแหงนั้นช่วยตอบโจทย์ชีวิตของคุณให้ง่ายขึ้นด้วยการเดินทางด้วยรถยนต์ส่วนตัว และระบบขนส่งสาธารณะอย่างรถไฟฟ้า รถเมล์ เรือ เพื่อให้ผู้อยู่อาศัยในบริเวณย่านรามคำแหงสามารถเดินทางไปสู่พื้นที่ต่าง ๆ ได้ ทั้งย่านใจกลางเมืองอย่างสยาม สีลม สาทร หรือจะออกไปสู่พื้นที่อื่น ๆ อย่างลาดพร้าว เพชรบุรี พระราม 9 หรือจะมุ่งตรงไปสู่สนามบินสุวรรณภูมิก็ได้เช่นกัน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2 mb-0">
												ในย่านรามคำแหงนั้นมีถนนเส้นทางการเดินทางที่หลากหลายตั้งแต่ถนนสายหลัก ถนนสายรอง หรือทางด่วนพิเศษต่าง ๆ ที่ช่วยให้การเดินทางของคุณสะดวกสบายมากขึ้น เริ่มต้นด้วยถนนสายหลักอย่างถนนรามคำแหง ถนนลาดพร้าว ถนนศรีนครินทร์
											</p>
											<p class="mt-2 mb-0">
												โดยถนนรามคำแหงเป็นถนนสายหลักของย่านรามคำแหงที่ตัดกับถนนในย่านอื่นหลากหลายจุด เช่น ถนนเพชรบุรี ถนนพัฒนาการ ถนนสุขุมวิท 71 ถนนพระราม 9 ถนนศรีนครินทร์ และถนนกาญจนาภิเษก
											</p>
											<p class="mt-2">
												ในส่วนของทางด่วนพิเศษ ในย่านรามคำแหงมีทางด่วนพิเศษศรีรัชที่ช่วยแบ่งเบาการจราจรบนทางพิเศษเฉลิมมหานคร และถนนรามอินทราลงไปได้ พร้อมเพิ่มประสิทธิภาพให้กับการเดินทางในกรุงเทพให้เป็นโครงข่ายที่สมบูรณ์มากยิ่งขึ้น
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้าและขนส่งสาธารณะ
											</h3>
											<p class="mt-2 mb-0">
												ในปัจจุบันนี้ในย่านรามคำแหงมีระบบขนส่งทั้งรถเมล์ เรือ และรวมถึงระบบขนส่งรถไฟฟ้าอย่าง Airport rail link ที่มีสถานีรามคำแหงตั้งอยู่พอดิบพอดี ซึ่ง Airport rail link จะสามารถพาคุณเดินทางไปได้ตั้งใจกลางเมืองอย่างบริเวณพญาไท ยาวไปถึงสนามบินสุวรรณภูมิ จังหวัดสมุทรปราการ
											</p>
											<p class="mt-2 mb-0">
												และในอนาคตตามแผนการพัฒนาระบบขนส่งของภาครัฐ ในบริเวณย่านรามคำแหงจะมีการเพิ่มสายรถไฟฟ้าใต้ดิน MRT สายสีส้ม ยาวตั้งแต่สถานีศูนย์วัฒนธรรมแห่งประเทศไทย ไปจนถึงเขตย่านมีนบุรีที่เป็นปลายสายของถนนรามคำแหง
											</p>
											<p class="mt-2">
												นอกจากนี้ยังมีรถไฟฟ้าใต้ดิน MRT สายสีเหลืองที่จะพาคุณเดินทางได้ตั้งแต่ย่านลาดพร้าวยาวไปจนถึงย่านสำโรง จังหวัดสมุทรปราการกันเลยทีเดียว และยังสามารถใช้สายรถไฟฟ้าเหล่านี้ไปเปลี่ยนสายรถไฟฟ้าอื่น ๆ ได้ ทั้งรถไฟฟ้าใต้ดินสายสีน้ำเงิน และรถไฟฟ้า BTS
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านรามคำแหง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									สำหรับใครที่คิดจะลงทุนซื้อ - ขายบ้านรามคำแหง บอกได้เลยว่าคิดไม่ผิด เพราะย่านบ้านรามคำแหงนี้จัดได้เป็นย่าน EDB (Extension Business District) หรือพื้นที่รองรับการขยายของตัวเมือง สามารถเชื่อมต่อความเจริญจากพื้นที่ใจกลางเมืองได้ ทั้งการคมนาคม รวมถึงสิ่งอำนวยความสะดวกต่าง ๆ มากมาย เช่น ห้างสรรพสินค้า สถานศึกษา และสถานพยาบาล
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												ศูนย์การค้า หรือห้างสรรพสินค้าในละแวกบ้านรามคำแหง มีพื้นที่ให้คุณเลือกสรรใช้เวลาว่าง กับตัวเอง หรือคนรัก ครอบครัวให้เลือกหลากหลาย ครบถ้วนทุกขนาด ทุกรูปแบบตั้งแต่ Super Store ไว้ซื้อของใช้อุปโภคบริโภค หรือห้างสรรพสินค้าที่ให้คุณเดินช้อปปิ้งได้อย่างเพลิดเพลิน เช่น
											</p>
											<ul>
												<li>เดอะมอลล์บางกะปิ</li>
												<li>เดอะมอลล์รามคำแหง</li>
												<li>แฮปปี้แลนด์ เซ็นเตอร์</li>
												<li>เทสโก้โลตัส บางกะปิ</li>
												<li>แมคโคร</li>
												<li>Big C รามคำแหง</li>
												<li>The Scene Town in Town</li>
											</ul>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												ในส่วนของด้านการศึกษา ผู้อยู่อาศัยในย่านบ้านรามคำแหงไม่ต้องเป็นกังวล เพราะในบริเวณนี้มีสถานศึกษารองรับเด็กวัยเรียนทุกช่วงวัยตั้งแต่อนุบาล ประถม มัธยม ไปจนถึงระดับมหาวิทยาลัยที่มีชื่อเสียง มีคุณภาพให้ผู้ปกครอง และลูกหลานเลือกเข้ารับการศึกษามากมาย ได้แก่
											</p>
											<ul>
												<li>โรงเรียนบดินทร์เดชา</li>
												<li>โรงเรียนเตรียมอุดมศึกษาน้อมเกล้า</li>
												<li>โรงเรียนบางกะปิ</li>
												<li>มหาวิทยาลัยรามคำแหง</li>
												<li>มหาวิทยาลัยอัสสัมชัญ</li>
											</ul>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												โครงการบ้านรามคำแหงในบริเวณนี้เป็นหนึ่งในย่านศูนย์รวมสถานพยาบาลที่มีชื่อเสียงหลากหลายที่ ทั้งโรงพยาบาล หรือคลินิกสถานพยาบาลขนาดเล็ก - ใหญ่พร้อมด้วยเครื่องมือทางการแพทย์ที่ครบครัน และทันสมัย ดูแลคุณจากเหตุการณ์ฉุกเฉินให้ปลอดภัยถึงมือแพทย์อย่างรวดเร็ว ได้แก่
											</p>
											<ul>
												<li>โรงพยาบาลสมิติเวช ศรีนครินทร์</li>
												<li>โรงพยาบาลรามคำแหง</li>
												<li>โรงพยาบาลเวชธานี</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								จุดเด่นและการพัฒนาของทำเลย่านรามคำแหง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การันตีได้เลยว่าย่านรามคำแหงนั้นมีอนาคตที่เจริญเติบโตก้าวหน้ามากแน่นอน เพราะแต่เดิมปัจจุบันนี้ย่านรามคำแหงก็จัดเป็นพื้นที่ขยายความเจริญจากใจกลางเมืองกรุงเทพมามากมายอยู่แล้ว และยังมีแนวโน้มพัฒนาความเจริญมากขึ้นเรื่อย ๆ จากการพัฒนาของเส้นทางรถไฟฟ้า และสิ่งอำนวยความสะดวกต่าง ๆ ที่กำลังเข้ามาสู่พื้นที่รามคำแหงนั่นเอง จึงบอกได้เลยว่าย่านรามคำแหงเป็นอีกหนึ่งทำเลทอง ที่เหมาะกับนักลงทุนธุรกิจอสังหาริมทรัพย์ และผู้อยู่อาศัยทั่วไปเข้ามาอยู่อาศัย หรือลงทุนซื้อ - ขายบ้านรามคำแหงได้อย่างไม่ต้องกลัวขาดทุน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								เลือกไลฟ์สไตล์ดี ๆ เลือกบ้านรามคำแหง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สรุปให้ใครหลาย ๆ คนเข้าใจกันง่าย ๆ ได้เลยว่า “บ้านรามคำแหง ทำเลทองสุดฮอต ที่ครบครันทุกเรื่องของชีวิตคนเมือง”  เพราะย่านรามคำแหงมีสิ่งอำนวยความสะดวกดูแล ตอบสนองไลฟ์สไตล์ของผู้อยู่อาศัยได้อย่างครบครัน
								</p>
								<p class="mt-2">
									ดังนั้นถ้าใครที่กำลังมองหาบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม หรือคอนโด ทั้งมือหนึ่ง และมือสอง ย่านรามคำแหงเป็นอีกหนึ่งพื้นที่ที่น่าสนใจ ที่กำลังเรียกร้องให้คุณเข้ามาสัมผัสกับไลฟ์สไตล์สุดคูล ที่ตอบสนองทุกความต้องการของผู้คนจากทุกกลุ่มวัยอย่างแน่นอน
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'phra-ram-nine'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านพระราม 9
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ใครจะซื้อหรือจะขายบ้านพระราม 9 บอกเลยว่าที่นี่จะเป็นแหล่งลงทุนที่ให้กำไรแก่ผู้ทำธุรกิจเช่าในอนาคตสูง เนื่องจากความน่าอยู่ของโซนนี้ อยู่ติดกับรถไฟฟ้าภายในตัวเมืองถึง 3 สาย ทั้งรถไฟฟ้า BTS , MRT และ Airport Rail Link ตั้งอยู่บนถนนพระราม 9 เส้นหลัก พร้อมทั้งมีศูนย์ให้บริการอย่างอาคารสำนักงาน ห้างสรรพสินค้าขนาดใหญ่ และโรงพยาบาลที่ทันสมัย ทำให้ที่นี่คือแหล่งที่อยู่อาศัยที่มีสิ่งอำนวยความสะดวกครบถ้วน เหมาะสำหรับผู้ที่ชอบไลฟ์สไตล์ในเมือง ครึกครื้น ดึกแค่ไหนทุกที่ยังครื้นเครงตลอด 24 ชม.
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านพระราม 9
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									หาซื้อบ้านพระราม 9 นั้นเป็นทำเลที่อยู่อาศัยที่เหมาะสำหรับผู้ต้องการความสะดวกสบาย ด้วยแหล่งคมนาคมที่ครบครัน จะนั่งรถไฟฟ้า หรือนั่งรถส่วนตัวเดินทาง ก็มีถนนเชื่อมไปยังทางด่วนและถนนเส้นหลักได้หลายสาย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												สามารถเดินทางด้วยถนนพระราม 9 เส้นหลักไปยังถนนศรีนครินทร์ได้อีกเส้นทาง แม้จราจรบนถนนจะแออัดอยู่บ้าง แต่รถขยับเรื่อยๆ ไม่ติดเป็นชั่วโมงแน่นอน และยังมีถนนเส้นทางพิเศษอีก คือทางพิเศษเฉลิมมหานคร กับทางพิเศษศรีรัช โดยวิ่งตามถนนพระราม 9 แล้วขึ้นทางด่วนได้เลย
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												ใครที่ปักหลักอยู่บ้านแถวพระราม 9 รถไฟฟ้าจะมีสถานี MRT พระราม 9  ใกล้กับห้าง Central Rama 9 ให้คนเดินสะดวก ด้วยเส้น MRT สายสีน้ำเงิน และยังสามารถเปลี่ยนสายไปยังรถไฟฟ้าสายสุขุมวิทเส้นสีเขียวได้อีกด้วย นอกจากนี้ยังมีรถไฟฟ้า Airport Rail Link สถานีมักกะสัน และในอนาคตจะมี MRT สายสีส้มล้อมรอบย่านพระราม 9 ในภายหลังด้วย นับว่าบ้านใครอยู่หมู่บ้านพระราม 9 ก็ใช้แหล่งคมนาคมเดินทางแทนรถยนต์ได้
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านพระราม 9
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเลบ้านพระราม 9 จัดว่าเป็นโซนที่ครบครันเรื่องซูเปอร์มาร์เก็ต ย่านห้างสรรพสินค้า สถาบันการศึกษา รวมไปถึงศูนย์การรักษาเลยทีเดียว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												ศูนย์การค้าหลักประจำถนนพระราม 9 ที่โดดเด่น คือ เซ็นทรัลพระราม 9 (Central Rama 9) กับห้างฟอร์จูนทาวน์ (Fortune Town) ที่อยู่ตรงข้ามโดยมีถนนพระราม 9 คั่นกลางไว้
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												จะมีโรงเรียนพระราม 9 กาญจนาภิเษก อยู่ติดกับถนนพระราม 9 เส้นหลัก และยังมีสถาบันกวดวิชาอื่นๆ ที่อยู่ตามถนนใหญ่ และตามห้างสรรพสินค้าอีกด้วย
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถานรักษาพยาบาลบริเวณบ้านพระราม 9 จะมีโรงพยาบาลพระราม 9 ตึกขนาดใหญ่ เป็นศูนย์การรักษาเอกชนให้กับประชากรภายในตัวเมือง สามารถเดินทางด้วยรถไฟฟ้า MRT สถานีเพชรบุรี หรือ Airport Rail Link สถานีมักกะสัน แล้วต่อรถบัสของโรงพยาบาลฟรีได้
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาย่านพระราม 9 ในอนาคต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									เนื่องจากบ้านพระราม 9 เป็นโซน  NEW CBD (New Central Business District) ย่านธุรกิจแห่งใหม่ที่มีแหล่งการลงทุนสูงขึ้นทุกๆ ปี ปีละ 8% และให้ผลตอบแทนราคาเช่า ปีละ 5% ทุกๆ ปี จึงทำให้ธุรกิจปล่อยเช่าบ้านมือสอง ทาวน์โฮม คอนโด จะให้กำไรสูงขึ้นไปอีก
								</p>
								<p class="mt-2">
									ด้วยเหตุนี้ ทำให้มีโครงการบ้านพระราม 9 เกิดขึ้นมากมาย ด้วยย่านนี้มีห้างสรรพสินค้าขนาดใหญ่ ตึกธุรกิจผุดออกมาขนาบข้างกับถนนใหญ่ เรียกได้ว่าเป็นเขตทำเลทองที่ควรจับตามองกันเลยทีเดียว
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ไลฟ์สไตล์คนเมือง ที่บ้านพระราม 9
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ไลฟ์สไตล์คนเมือง ที่บ้านพระราม 9 จัดเป็นวิถีชีวิตที่ล้อมรอบไปด้วยสิ่งอำนวยความสะดวก จะเดินห้าง เที่ยวกลางคืนก็มีแหล่งผับ บาร์ไว้พักผ่อนหย่อนใจ หรือจะไปทำงานภายในตัวเมือง ที่นี่มีศูนย์คมนาคม รถไฟฟ้า 3 สาย ที่พร้อมพาคุณเดินทางไปทั่วทั้งเมืองได้อย่างครอบคลุม
								</p>
								<p class="mt-2">
									ใครสนใจบ้านแถวพระราม 9 สามารถติดต่อสอบถาม นายหน้า The Best Property ที่พร้อมช่วยค้นหาสไตล์บ้านที่ใช่กับไลฟ์สไตล์ของคุณ จะหาบ้านเดี่ยวพระราม 9 , บ้านมือพระราม 9 , ทาวน์โฮมพระราม 9 และบ้านรูปแบบอื่นๆ สนใจปรึกษาได้ที่ เบอร์โทร 02-047-4282 หรือ แอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'min-buri'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านมีนบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									โครงการบ้านมีนบุรีเป็นบ้านกรุงเทพที่มีโครงการบ้านจัดสรรเปิดให้ผู้อยู่อาศัยได้จับจองซื้อกันมากมาย ไม่ว่าจะเป็นหมู่บ้านประเภท บ้านเดี่ยว, บ้านมือสอง, ทาวน์โฮม, ทาวน์เฮ้าส์, คอนโด ฯลฯ ในย่านรามอินทรา มีนบุรี-นิมิตใหม่ ถนนสุวินทวงศ์ตอนปลาย บริเวณโครงการมีถนนเชื่อมกับทางด่วน เป็นเส้นทางนำเข้าสู่ตัวเมืองและต่างจังหวัดอย่างถนนกาญจนาภิเษก นอกจากนี้ยังมีรถไฟฟ้า BTS สายสีเหลือง สีส้ม สีชมพูที่จะเข้ามาในย่านนี้ในอนาคตอันใกล้
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านมีนบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ใครกำลังหาซื้อบ้านมีนบุรีอยู่ บอกได้เลยว่าย่านนี้เป็นทำเลที่อยู่อาศัยที่เหมาะสำหรับผู้ที่ต้องการความสะดวกสบาย ด้วยแหล่งคมนาคมที่ครบครัน จะนั่งรถไฟฟ้า หรือนั่งรถส่วนตัวเดินทางก็มีถนนเชื่อมไปยังทางด่วนเส้นหลักได้หลายสาย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												สามารถเดินทางโดยใช้ถนนรามอินทราเส้นหลัก แล้วเลยไปถนนสุวินทวงศ์เพื่อไปถนนรามคำแหง และยังไปเส้นสุขาภิบาล 3 ต่อเส้นทางด่วนมอเตอร์เวย์กาญจนาภิเษกหมายเลข 9 ไปยังตัวเมืองได้ง่ายๆ อีกด้วย
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												ใครที่กำลังเล็งซื้อบ้านแถวมีนบุรี ควรรีบซื้อไว้ด่วน เพราะในอนาคตอันใกล้นี้ บ้านมีนบุรีจะมีโครงการรถไฟฟ้าสายสีเหลือง ลาดพร้าว-สำโรง, สายสีส้ม ศูนย์วัฒนธรรมฯ-ตลิ่งชัน และสายสีชมพู แคราย-ปากเกร็ด-หลักสี่-วงแหวนรอบนอก-มีนบุรีมาเชื่อมสถานีมีนบุรี
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านมีนบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ทำเลบ้านมีนบุรี จัดว่าเป็นโซนที่ครบครันเรื่องซูเปอร์มาร์เก็ต ตลาดนัด สถาบันการศึกษา รวมไปถึงสถานพยาบาลใหญ่ๆ ด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												แหล่งช้อปปิ้งหลักๆ แถวบ้านมีนบุรี จะมีตลาดนัดมีนบุรี มีนบุรีจตุจักร ส่วนซูเปอร์มาร์เก็ตจะมีบิ๊กซีแถวถนนสุวินทวงศ์ และเทสโก้โลตัสแถวสุขาภิบาล 3
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												จะมีโรงเรียนมีนบุรีกับมีนบุรีศึกษาประจำเขต อยู่ติดกับถนนสีหบุรานุกิจ ไม่ไกลจากตลาดนัดมีนบุรีประมาณ 600 กว่าเมตร
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถานรักษาพยาบาลประจำแถวบ้านมีนบุรี จะมี โรงพยาบาลนวมินทร์ 9 ประจำเขตมีนบุรี เป็นศูนย์การรักษาเอกชนให้กับประชากรภายในตัวเมือง สามารถเดินทางด้วยรถไฟฟ้า BTS สถานีหมอชิต แล้วรอรถเมล์สาย 96 จะถึงโรงพยาบาลในถนนเส้นหลักทันที
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาที่อยู่อาศัยย่านมีนบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									เนื่องจากแถวบ้านมีนบุรี เป็นโซนที่จะมีแหล่งคมนาคมในอนาคตที่ผู้อยู่อาศัยสามารถเข้าถึงได้ง่ายและครอบคลุม จึงเป็นเขตย่านชานเมืองที่เหมาะกับการอยู่อาศัย หรือทำธุรกิจขายเช่าบ้านเดี่ยว คอนโด รวมไปถึงบ้านมือสองมีนบุรีไว้เก็งกำไร เพราะเขตนี้เป็นจุดที่ห่างไกลจากตัวเมืองพอสมควร เหมาะสำหรับผู้ที่อยากใช้ชีวิตชิลๆ สบายๆ มีพื้นที่ส่วนตัวแต่มีสิ่งอำนวยความสะดวกครบครัน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ออกแบบไลฟ์สไตล์ของคุณ ที่บ้านมีนบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ไลฟ์สไตล์ชานเมือง ที่บ้านมีนบุรี จัดเป็นวิถีชีวิตชานเมืองที่มีแหล่งอำนวยความสะดวกล้อมรอบ เข้าถึงง่ายไม่แพ้ในตัวเมือง พร้อมมีรถไฟฟ้าคอยให้บริการในอนาคต สามารถเดินทางเข้าตัวเมืองได้สะดวกสบาย
								</p>
								<p class="mt-2">
									ใครสนใจบ้านแถวมีนบุรี  สามารถติดต่อสอบถาม นายหน้า The Best Property ที่พร้อมช่วยค้นหาแนวบ้านที่ใช่กับไลฟ์สไตล์ของคุณ จะหาบ้านเดี่ยวมีนบุรี, บ้านมือสองมีนบุรี, ทาวน์โฮมมีนบุรี และบ้านรูปแบบอื่นๆ สนใจปรึกษาได้ที่ เบอร์โทร 02-047-4282 หรือ แอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'suanluang'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านสวนหลวง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โครงการบ้านสวนหลวงเป็นหนึ่งในบ้านกรุงเทพที่มีความเจริญรุ่งเรืองในอนาคตในไม่ช้า เนื่องจากจะมีรถไฟฟ้าสายสีเหลืองเปิดภายในครึ่งปีแรกนี้ และห้างสรรพสินค้า โรงพยาบาล สถานศึกษา ใกล้ชิดแนวรถไฟฟ้า ทำให้มีบ้านจัดสรร ไม่ว่าจะเป็นหมู่บ้านประเภท บ้านเดี่ยว , บ้านมือสอง , คอนโด , ทาวน์เฮ้าส์ , ทาวน์โฮม ฯลฯ ในย่านลาดพร้าว - สำโรง บนถนนศรีนครินทร์นับไม่ถ้วน
								</p>
								<p class="mt-2">
									เนื่องจากบ้านสวนหลวงเป็นเส้นทางที่เชื่อมกับทางด่วนเชื่อมกับตัวเมืองและต่างจังหวัดอย่างถนนกาญจนาภิเษกอยู่แล้ว ทำให้ย่านชานเมืองนี้มีความอุดมสมบูรณ์ในด้านการอยู่อาศัยไม่แพ้เขตตัวเมืองเลย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านสวนหลวง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ใครกำลังหาซื้อบ้านสวนหลวงนั้น ขอการันตีเลยว่าเป็นทำเลที่อยู่อาศัยที่เหมาะสำหรับผู้ต้องการอยู่ชานเมือง แต่ต้องการเดินทางเข้า-ออกสู่ตัวเมืองและต่างจังหวัดได้สะดวก นอกจากนี้ยังมีแหล่งคมนาคมอย่างรถไฟฟ้าสายสีเหลืองที่จะให้เปิดใช้บริการในไม่ช้า สามารถเชื่อมต่อเข้าสู่รถไฟฟ้าสายสีเขียวเส้นหลักได้สะดวกสบาย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												สามารถเดินทางถนนสวนหลวง เส้นหลักไปยังถนนศรีครินทร์ได้อีกเส้นทาง เพื่อต่อเส้นทางไปยังถนนพัฒนาการ บางนาตราด อุดมสุข และขึ้นเส้นทางด่วนกาญจนาภิเษกหมายเลข 7 ไปฉะเชิงเทรา , ชลบุรี หรือหมายเลข 9 ขึ้นอยุธยา , สระบุรีได้เช่นกัน
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้าและขนส่งสาธารณะ
											</h3>
											<p class="mt-2">
												ในอนาคตไม่ไกล เขตบ้านสวนหลวงจะมีรถไฟฟ้าสายสีเหลืองวิ่งต้อนรับให้ผู้โดยสารในกลางปีที่ 2566 ใครที่มีเป้าหมายจะขาย เช่า หรือ ซื้อบ้านสวนหลวงมาเก็งกำไร รับประกันความคุ้มค่าการลงทุนแน่นอน เพราะบ้านสวนหลวงจะมีโครงการรถไฟฟ้าสายสีเหลือง ลาดพร้าว-สำโรง , Airport Rail Link หัวหมาก เชื่อมการเดินทางเข้าสู่ตัวเมืองได้สะดวก เดินทางรวดเร็วมากขึ้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านสวนหลวง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									สิ่งอำนวยความสะดวกแถวบ้านสวนหลวงหลักๆ จะมี ห้างสรรพสินค้าขนาดใหญ่บนถนนศรีนครินทร์กับบางนาตราด และโรงยาบาลในซอยเฉลิมพระเกียรติกับถนนศรีนครินทร์เลย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												แหล่งช้อปปิ้งหลักๆ แถวบ้านสวนหลวงจะมี Thanya Park , Season Square , Paradise Place กับ Paradise Park ตามถนนศรีนครินทร์เลย และยังมีมอลล์ขนาดใหญ่อย่าง Mega Bangna บนถนนบางนาตราดอีกเช่นกัน
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												จะมีโรงเรียนอนุบาลเปล่งประสิทธิ์ในซอยสวนหลวง ร.9 อยู่ติดกับถนนศรีนครินทร์ ส่วนโรงเรียนระดับอุดมศึกษาจะมีโรงเรียนลาซาลในซอยลาซาล
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถานรักษาพยาบาลประจำแถวบ้านสวนหลวง จะมี โรงพยาบาลสินแพทย์ ศูนย์การรักษาเอกชนในซอยถนนเฉลิมพระเกียรติ แต่หากเดินทางข้ามถนนบางนา-ตราดถนนศรีนครินทร์ต่อ จะมี โรงพยาบาลศรีนครินทร์ บางนาซอยลาซาล พร้อมรถไฟฟ้าสายสีเหลืองศรีลาซาลที่จะเปิดภายในครึ่งปีแรก
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาที่อยู่อาศัยย่านสวนหลวง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									บ้านสวนหลวง เป็นโซนชานเมืองฝั่งตะวันออกที่มีความเอื้องฟูแก่กับผู้อยู่อาศัยไม่แพ้ภายในตัวเมืองในอนาคต เพราะย่านนี้มีถนนศรีนครินทร์ที่เชื่อมต่อไปยังเส้นเฉลิมพระเกียรติ บางนาตราด อุดมสุข เข้าตัวเมืองได้สะดวก ทำให้เป็นโซนที่เหมาะสมการลงทุนเช่าคอนโด บ้านเดี่ยว คอนโด รวมไปถึงขายบ้านมือสองสวนหลวงได้ดีอีกหนึ่งเขต ด้วยรถไฟฟ้าที่กำลังเปิดในอนาคต และมีแหล่งท่องเที่ยว รักษาอยู่มานานแล้ว จึงเป็นที่ที่น่าอยู่อาศัยเป็นอย่างมาก
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								เลือกไลฟ์สไตล์ดี ๆ เลือกบ้านสวนหลวง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									บ้านสวนหลวง โซนทำเลทองที่มีสิ่งอำนวยสะดวกครบครันไม่แพ้ในตัวเมืองอีกหนึ่งเขต เพราะมีรถไฟฟ้าตามแนวถนนศรีนครินทร์พร้อมเปิดภายในปีนี้ จึงเป็นแหล่งที่พักน่าอาศัยอีกหนึ่งเขต ใครสนใจบ้านสวนหลวง  สามารถติดต่อสอบถาม นายหน้า The Best Property ที่พร้อมช่วยค้นหาแนวบ้านที่ใช่กับไลฟ์สไตล์ของคุณ จะหาบ้านเดี่ยวสวนหลวง , บ้านมือสองสวนหลวง , ทาวน์โฮมสวนหลวง และบ้านรูปแบบอื่นๆ สนใจปรึกษาได้ที่ เบอร์โทร 02-047-4282 หรือ แอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'prakanong'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านพระโขนง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									สำหรับใครที่สนใจโครงการบ้านพระโขนง โซนนี้เป็นบ้านกรุงเทพที่ไม่ไกลจากตัวเมือง แต่มูลค่าอสังหาริมทรัพย์มีราคาที่ถูกกว่าโซนอื่นๆ ตั้งแต่ฝั่งคลองเตย - บางนา - สมุทรปราการ ด้วยศักยภาพของเขตบ้านพระโขนงได้รับอิทธิพลจากฝั่งอโศก ทำให้ที่อยู่อาศัยที่นี่มีความอุดมสมบูรณ์ทางด้านสิ่งอำนวยความสะดวกเป็นอย่างมาก
								</p>
								<p class="mt-2">
									มาดูกันดีกว่าว่า ศักยภาพทำเลในย่านบ้านพระโขนงนี้มีอะไรที่น่าสนใจบ้างทั้งในด้านการเดินทาง การใช้ชีวิต และภาพรวมของทำเลและที่อยู่อาศัย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านพระโขนง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ด้วยที่บ้านพระโขนงเป็นเขตพื้นที่อยู่ติดกับถนนใหญ่เส้นหลักเข้าตัวเมือง และยังมีรถไฟฟ้าประจำเขตเปิดใช้บริการได้สะดวกสบาย ทำให้ผู้อยู่อาศัยที่อยู่บ้านพระโขนงสามารถเดินทางเข้า-ออกจากเมืองได้สะดวกสบาย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												ใครสะดวกเดินทางด้วยรถส่วนตัว บ้านพระโขนงจะมีเส้นทางเข้าตัวเมืองชั้นในกทม.ง่ายๆ โดยใช้ถนนสุขุมวิท หรือขึ้นทางด่วนไปถนนพระราม 4 , ถนนรามอินทรา หรือถนนกาญจนาภิเษกก็ได้
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้าและขนส่งสาธารณะ
											</h3>
											<p class="mt-2">
												ใครอยู่บ้านพระโขนง ไม่ต้องกังวลเรื่องการเดินทางเลย เพราะขนส่งสาธารณะประจำเขตจะมีรถไฟฟ้าสายสีเขียวที่วิ่งระนาบเดียวกับถนนสุขุมวิทเส้นเข้าเมืองชั้นในของกรุงเทพฯ ได้สะดวกสบาย นอกจากนี้ยังมีรถเมล์วิ่งสาย 2 , 23 , 25 , 38 , 40 , 48 , 149, 501 , 508 , 511 ตามทางออกสถานีพระโขนงหมายเลข 2 กับ 3
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านพระโขนง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ความเป็นอยู่ของชาวหมู่บ้านพระโขนง จะเป็นชุมชนที่มีความสะดวกในทุกๆ ด้าน เนื่องจากเขตนี้มีเส้นสุขุมวิทผ่านทางมา ทำให้มีรถไฟฟ้าส่วนต่อขยายยาวไปถึงสมุทรปราการ จึงมีแหล่งช้อปปิ้ง แหล่งฝึกทักษะ สถานศึกษาประจำเขตพระโขนง และโรงพยาบาลใกล้ๆ ถนนสุขุท ที่ช่วยให้ผู้อาศัยสามารถทำธุระโดยใช้ถนนเส้นหลักได้รวดเร็ว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												แหล่งคอมมูนิตี้มอลล์ภายในเขตบ้านพระโขนง จะมีศูนย์การค้าซัมเมอร์ฮิลล์ติดใกล้ๆ กับสถานีพระโขนง และ เดอะฟิลล์ สุขุมวิท54 จะอยู่ข้างสำนักงานเขตพระโขนงเลย นอกจากนี้ในย่านพระโขนงจะมีร้าน Workshop คาเฟ่ และร้านเหล้าสไตล์อิซากายะตามรอบๆในโซนนี้
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สำหรับครอบครัวที่มีบุตรหลาน อยากจะหาบ้านพระโขนง ยังมีโรงเรียนประจำเขต อาทิ โรงเรียน พระโขนง , โรงเรียนพระแม่มารี , โรงเรียนวัดธาตุทอง และโรงเรียนดาราคาม ใกล้ๆ กับถนนสุขุมวิท
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												โครงการบ้านพระโขนงและบ้านอื่นๆ จะมี โรงพยาบาลสุขุมวิท , โรงพยาบาลกล้วยน้ำไท และ โรงพยาบาลรวมใจรัก บนถนนสุขุมวิทเส้นหลักโดยตรง
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาที่อยู่อาศัยย่านพระโขนง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านแถวพระโขนง จัดเป็นทำเลที่อยู่ติดกับชั้นในของตัวเมืองกทม. ตอนปลาย ด้วยที่เขตนี้มีรถไฟฟ้าสายสีเขียวเส้นหลักอยู่ระนาบเดียวกับถนนสุขุมวิท ทำให้ย่านนี้เป็นที่น่าจับตามองทั้งในแง่ผู้ซื้อ นักลงทุน และผู้พัฒนาอสังหาริมทรัพย์ การเดินทางเข้า-ออกเมืองสะดวก เหมาะกับผู้อยู่อาศัยทุกๆ ไลฟ์สไตล์ ซึ่งในแต่ละโซนก็มีเอกลักษณ์ทางด้านทำเลที่เหมาะสำหรับผู้อยู่อาศัยที่ค่อนข้างแตกต่างกัน ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li><b>โซนคลองเตย</b> ย่านนี้เป็นโซนฝั่งทิศเหนือของพระโขนง มีบ้านเดี่ยว คอนโด , บ้านมือสอง , หมู่บ้าน และโครงการบ้านจัดสรรชุกชุมให้เลือกหลายรูปแบบ คุณสามารถเดินทางด้วยการขึ้นรถไฟฟ้าสายสีน้ำเงิน MRT (สถานีคลองเตย) หรือหากต้องการเดินทางด้วยรถส่วนตัว สามารถขึ้น ถนนพระราม 4 และ ทางด่วนพิเศษเฉลิมมหานคร</li>
												<li><b>โซนบางนา</b> ย่านนี้เป็นโซนฝั่งทิศตะวันออกของพระโขนง จะมีแหล่งสตรีทฟู้ดในซอยอุดมสุข และคอมมูนิตี้มอลล์ขนาดใหญ่บนถนนศรีนครินทร์ อาทิ ซีคอนสแควร์ , พาราไดช์ พาร์ค และตลาดนัดรถไฟกลางคืน คุณสามารถเดินทางด้วยการขึ้นรถไฟฟ้าสายสีเขียว (สถานีอุดมสุข - บางนา) หรือหากต้องการเดินทางด้วยรถส่วนตัว สามารถขึ้น ถนนบางนา-ตราด , ถนนสุขุมวิท หรือขึ้นทางด่วน ทางพิเศษบางพลี-สุขสวัสดิ์ เข้าเมืองได้ง่ายๆ</li>
												<li><b>โซนสมุทรปราการ</b> ย่านนี้เป็นโซนฝั่งทิศใต้ของพระโขนง มีชื่อเสียงเป็นแหล่งอุตสาหกรรมชั้นนำ ปัจจุบันได้มีโครงการบ้านเดี่ยวทาวน์โฮม , ทาวน์เฮ้าส์ , คอนโดมากมาย คุณสามารถเดินทางด้วยการขึ้นรถไฟฟ้าสายสีเขียว (สถานีแพรกษา) หรือหากต้องการเดินทางด้วยรถส่วนตัว สามารถขึ้น ถนนสุขุมวิท และ ทางพิเศษบางพลี-สุขสวัสดิ์ จากถนนบางนา-ตราด</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								บ้านพระโขนง โดดเด่นทุกไลฟ์สไตล์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โซนโดยรวมพระโขนงดั้งเดิม มีความเจริญทางด้านขนส่ง รวมไปถึงไลฟ์สไตล์ในการใช้ชีวิตอาศัยที่ดีอยู่แล้ว ภายในอนาคตข้างหน้า จะมีรถไฟฟ้าขยายส่วนต่อจากสถานีสำโรง กระจายโซนพระโขนงอื่นๆ โดยเฉพาะโซนบางนามากขึ้น ดังนั้นใครอยู่แถวชานเมืองของพระโขนงจึงสามารถใช้ขนส่งสาธารณะเข้าเมืองได้อย่างสบายๆ
								</p>
								<p class="mt-2">
									หากใครสนใจซื้อที่อยู่อาศัยในหมู่บ้านพระโขนง สามารถติดต่อนายหน้าหาบ้านกับ The Best Property ที่จะมาช่วยค้นหาบ้านแถวพระราม 2 ที่ใช่กับไลฟ์สไตล์ของคุณ ไม่ว่าจะหาบ้านเดี่ยวพระโขนง หรือ บ้านมือสองพระโขนง โปรดไว้ใจบริการของเรา เพราะเราเชี่ยวชาญช่วยประเมินตรวจสอบคุณภาพบ้านพระโขนง  รวมไปถึงการวิเคราะห์ทำเลตลอดจนปิดการซื้อ-ขาย สนใจติดต่อได้ที่เบอร์โทร 02-047-4282 หรือ แอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'ra-ma-three'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านพระราม 3
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									โครงการหมู่บ้านพระราม 3 จัดเป็นพื้นที่บ้านกรุงเทพสำหรับอยู่อาศัยที่มีความสะดวกสบายและเหมาะกับการอยู่อาศัยมากอีกหนึ่งทำเล เพราะด้วยโครงการบ้านต่างๆ ในย่านนี้ มีราคาขายบ้านพระราม 3 ต่างกันไป ให้ผู้จะซื้อพิจารณาเลือกได้ตามศักยภาพทางการเงิน ทำให้ผู้อาศัยแต่ละไลฟ์สไตล์ สามารถอยู่ร่วมกันในเขตนี้ได้อย่างสะดวกสบาย ทั้งยังมีแหล่งคอมมูนิตี้มอลล์ โรงพยาบาล รวมไปถึงรถไฟฟ้าในอนาคตที่กำลังสร้างสถานีพระราม 3 - ท่าพระ ในอีกไม่ไกล จะช่วยเพิ่มความสะดวกการเดินทางแก่ผู้อยู่อาศัยละแวกนี้มากขึ้น
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านพระราม 3
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ในแง่การเดินทางบ้านพระราม 3 ถือว่ามีความสะดวกสบายในการใช้รถส่วนตัว ในด้านการใช้ขนส่งสาธารณะจะมีโครงการรถไฟฟ้าสายสีเทา 3 ระยะที่ผ่านพระราม 3-ท่าพระ ในอนาคต
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												โครงการบ้านพระราม 3 จะมีเส้นทางด่วนพิเศษอยู่ใกล้ๆ อาทิ เส้นศรีรัชกับเส้นเฉลิมมหานคร ที่สามารถเดินทางจากถนนรัชดาภิเษกตัดกับถนนสาธุประดิษฐ์เข้าสู่เส้นทางด่วนได้เลย
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												โครงการรถไฟฟ้าที่ใกล้บ้านแถวพระราม 3 มากที่สุดคือ รถโดยสารด่วนพิเศษ BRT สะพานพระราม 3 ซึ่งสามารถเชื่อมต่อไปยังรถไฟฟ้า BTS สายสีลมได้ที่สถานีช่องนนทรี
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านพระราม 3
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ในด้านความเป็นอยู่ของหมู่บ้านพระราม 3 จะอยู่ติดกับสะพานข้ามแม่น้ำเจ้าพระยา ที่สามารถเดินทางไปถนนหลากหลายสาย เช่น ถนนรัชดาภิเษกหรือถนนสมเด็จพระเจ้าตากสิน ที่สามารถเดินทางเข้า-ออกตัวเมืองได้สะดวก จึงมีสิ่งปลูกสร้าง อย่างโครงการบ้านเดี่ยวพระราม 3 ทาวน์โฮมพระราม 3 รวมไปถึงศูนย์การค้า สถานศึกษา และสถานพยาบาลประจำเขตนี้ด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												คอมมูนิตี้มอลล์บ้านพระราม 3 จะมี เซ็นทรัลพระราม 3 กับ Terminal Rama 3 และจะมีแหล่งตลาดสดอย่าง ห้างสรรพสินค้าแม็คโคร สาทร, ตลาดนางลิ้นจี่, ตลาดคลองเตย ที่พร้อมเปิดบริการตลอด 24 ชั่วโมง
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												ใครมีบุตรหลานอาศัยอยู่บ้านพระราม 3 ที่นี่มีโรงเรียนระดับรัฐบาล เอกชน ตั้งแต่ปฐมวัย เตรียมอุดมศึกษา และระดับมหาวิทยาลัย อาทิ โรงเรียนเจ้าพระยาวิทยาคม โรงเรียนวัดยานนาวา โรงเรียนวัดดอกไม้  มหาวิทยาลัยเทคโนโลยีราชมงคลกรุงเทพ หรือโรงเรียนนานาชาติ King’s College International School, New Sathorn International School, Shrewbury International School, St. Andrews International School
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												ในด้านสถานพยาบาล แถวบ้านพระราม 3 จะมีโรงพยาบาลเจริญกรุงประชารักษ์  และโรงพยาบาลไทยจักษุด้านการรักษาตาโดยเฉพาะ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาย่านพระราม 3 ในอนาคต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านพระราม 3 จัดเป็นทำเลที่อยู่ติดกับชั้นในของตัวเมืองกรุงเทพมหานครฝั่งตะวันตก ด้วยเขตนี้มีรถสายด่วน BRT  คอยรับ-ส่งถึงรถไฟฟ้าสายสีลม จึงทำให้เป็นพื้นที่ที่เหมาะแก่การลงทุนอสังหาริมทรัพย์สูง และในอนาคตจะมีรถไฟฟ้าสายสีเทาเปิดให้ใช้บริการอีกด้วย ทำให้บ้านพระราม 3 มีความสะดวกสบายในด้านการเดินทางที่มากขึ้น ซึ่งในแต่ละโซนก็มีเอกลักษณ์ทางด้านทำเลที่เหมาะสำหรับผู้อยู่อาศัยที่ค่อนข้างแตกต่างกัน
								</p>
								<p class="mt-2">
									อย่างเช่น โซนยานนาวา ย่านนี้เป็นโซนฝั่งทางทิศตะวันออกเฉียงใต้ติดกับถนนพระราม 3 ซึ่งจะมีศูนย์การค้าใกล้เคียงอย่าง Terminal และ Central Rama 3 อีกทั้งถนนพระราม 3 เชื่อมต่อถึง ถนนรัชดาภิเษก, ถนนนราธิวาสราชนครินทร์, ถนนสาธุประดิษฐ์โดยตรง และยังมีหลายๆ โครงการปักหลักขายบ้านสาธุประดิษฐ์อีกด้วย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ไลฟ์สไตล์คนเมือง ที่บ้านพระราม 3
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โดยรวมแล้วบ้านพระราม 3 เป็นโซนอาศัยที่เหมาะสมกับไลฟ์สไตล์คนในเมืองสูงไม่แพ้กับโซนในเส้นสุขุมวิทเส้นหลักเลย ด้วยราคาตลาดอสังหาริมทรัพย์ไม่สูง และอาจราคาสูงได้มากกว่านี้ในอนาคต เพราะขนส่งสาธารณะจะมาเปิดใช้บริการในย่านพระราม 3
								</p>
								<p class="mt-2">
									แต่หากใครสนใจซื้อที่อยู่อาศัยในหมู่บ้านพระราม 3 สามารถติดต่อนายหน้าหาบ้านกับ The Best Property ที่จะมาช่วยค้นหาบ้านแถวพระราม 3 ที่ใช่กับไลฟ์สไตล์ของคุณ ไม่ว่าจะหาบ้านเดี่ยวพระราม 3  หรือบ้านมือสองพระราม 3  โปรดไว้ใจบริการของเรา เพราะเราเชี่ยวชาญจริง ช่วยประเมินตรวจสอบคุณภาพบ้านพระราม 3 รวมไปถึงการวิเคราะห์ทำเลตลอดจนปิดการซื้อ-ขาย สนใจติดต่อได้ที่เบอร์โทร 02-047-4282 หรือ แอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'pinklao'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านปิ่นเกล้า
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									บ้านแถวปิ่นเกล้า เป็นชุมชนบ้านกรุงเทพย่านฝั่งธนบุรีที่อยู่ติดกับแม่น้ำเจ้าพระยาในย่านบางกอกน้อย และถนนเส้นหลักมี 4 ศูนย์ห้างสรรพสินค้าขนาดใหญ่ในเขตนี้ จึงทำให้มีโครงการบ้านแถวปิ่นเกล้า ประเภทคอนโด ทาวน์โฮม ทาวน์เฮ้าส์ บ้านมือสองมากมายเปิดให้ลงทุน จับจองกันมากมาย ขนส่งสาธารณะที่นี่มีทั้งแบบรถ เรือ และในอนาคตจะมีรถไฟฟ้าถึง 3 สาย ที่จะขยายสถานีมาถึงปิ่นเกล้าด้วย ยิ่งทำให้ย่านนี้มีความน่าอยู่มากขึ้นอีก
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านปิ่นเกล้า
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การเดินทางจากบ้านแถวปิ่นเกล้า จัดว่ามีความสะดวกสบายด้านการใช้รถส่วนตัวกับขนส่งสาธารณะจำพวก รถเมล์ วินมอเตอร์ไซค์ แท็กซี่ และในอนาคตไม่ไกลจะมีแหล่งคมนาคมอย่างรถไฟฟ้าถึงสามสาย ที่จะเพิ่มส่วนต่อขยายมาถึงบ้านปิ่นเกล้าอีก นับได้ว่าแหล่งทำเลนี้จะมีศักยภาพด้านการอยู่อาศัยรวมไปถึงขนส่งมวลชนด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												ในโครงการบ้านปิ่นเกล้าจะติดอยู่กับถนน 3 เส้นทางคือ ถนนบรมราชชนนี, ถนนสมเด็จพระปิ่นเกล้า และถนนจรัญสนิทวงศ์ ที่สามารถขึ้นเส้นทางด่วนพิเศษศรีรัช – วงแหวนรอบนอก
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												ในอนาคตของย่านบ้านปิ่นเกล้า จะมีรถไฟฟ้าขยายต่อถึง 3 สาย ได้แก่ รถไฟฟ้า BTS สายสีส้ม (ตลิ่งชัน - มีนบุรี), สายสีแดง (ศาลายา - บางตำหรุ), และรถไฟฟ้าใต้ดิน MRT (บางซื่อ - พุทธมณฑลสาย 4)
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านปิ่นเกล้า
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ย่านหมู่บ้านปิ่นเกล้าจัดเป็นพื้นที่ที่ชุกชุมไปด้วยคอมมูนิตี้มอลล์ตั้งแต่สมัยอดีตจวบจนปัจจุบัน หลายปีผ่านไปจึงมีศูนย์การค้าที่มีตั้งแต่ระดับห้างทั่วไปจนไปถึงห้างระดับพรีเมี่ยมชั้นนำประจำเขตมากมาย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												ศูนย์การค้าประจำบ้านแถวปิ่นเกล้าที่โดดเด่น จะมี เมอร์รี่คิงส์ ที่มีจุดเด่นคือ “ลิฟต์แก้ว” ที่สามารถดูวิวทั่วเมือง, ห้างเวลโก ปิ่นเกล้า,ห้างพาต้า ปิ่นเกล้า, และ ห้างเซ็นทรัล ปิ่นเกล้าช้อปปิ้งมอลล์ขนาดใหญ่
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												โดยโรงเรียนที่อยู่ใกล้ๆ แถวบ้านปิ่นเกล้า อยู่พื้นที่ใกล้เคียงแถวห้างเซ็นทรัล ปิ่นเกล้า จะมีโรงเรียนอนุบาลคุณแม่, โรงเรียนอนุบาลธรรมภิรักษ์ธนบุรี, โรงเรียนมัธยมวัดนายโรง, โรงเรียนธรรมภิรักษ์, โรงเรียนมัธยมวัดดุสิตาราม, วิทยาลัยอินเตอร์เทคลำปาง LIT (ศูนย์กรุงเทพฯ), และ วิทยาลัยเทคโนโลยีจรัลสนิทวงศ์
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												โรงพยาบาลแถวบ้านปิ่นเกล้า อยู่พื้นที่ใกล้เคียงแถวห้างเซ็นทรัล ปิ่นเกล้า จะมีโรงพยาบาลศิริราชปิยมหาราชการุณย์, โรงพยาบาลเจ้าพระยา เปิดให้บริการ 24 ชั่วโมง, และโรงพยาบาลเฉพาะทางผิวหนังอโศก สาขาปิ่นเกล้า
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาย่านปิ่นเกล้า ในอนาคต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ศักยภาพย่านบ้านปิ่นเกล้าในอนาคต จะเจริญเติบโตอย่างแน่นอน เนื่องจากย่านปิ่นเกล้ามีความเจริญทางด้านต่างๆ มานานแล้ว ในย่านนี้มีคอมมูนิตี้มอลล์มากมาย และอยู่ติดกับใจกลางเมือง เดินทางเข้าเมืองชั้นในได้ไม่ยาก เมื่อมีรถไฟฟ้าขยายสถานีเข้ามาอีก ย่านนี้ก็จะยิ่งเจริญขึ้นอีก โดยโซนที่โดดเด่นในย่านปิ่นเกล้า มีดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li><b>โซนบางพลัด</b> หนึ่งในเขตของบ้านฝั่งธนในปิ่นเกล้า มีถนนเส้นหลักคือถนนจรัญสนิทวงศ์ กับถนนสิรินธร มีโครงการบ้านปิ่นเกล้าประเภทต่างๆ อย่างบ้านเดี่ยว คอนโด บ้านมือสอง ทาวน์โฮมปิ่นเกล้ามากมาย เพราะย่านเขตนี้อยู่ใกล้กับโซนอนุสาวรีย์ อารีย์ สะพานควาย และจตุจักร จึงมีแหล่งของกินมากมายในตลาดนัดกลางคืน </li>
												<li><b>โซนบางกอกน้อย</b> หนึ่งในเขตของบ้านฝั่งธนในปิ่นเกล้า มีถนนเส้นหลักคือ ถนนบรมราชชนนี และถนนสมเด็จพระปิ่นเกล้าทางตอนเหนือ เป็นโซนที่รวมแหล่งท่องเที่ยวประวัติศาสตร์ไทย อาทิ วัดประจำท้องถิ่นวัดระฆัง วังหลัง และยังเป็นโซนที่ติดกับแม่น้ำเจ้าพระยาฝั่งตะวันตก</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ออกแบบไลฟ์สไตล์ของคุณที่บ้านปิ่นเกล้า
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โครงการบ้านปิ่นเกล้าเป็นชุมชนที่มีความครึกครื้น มีสิ่งอำนวยความสะดวกตามถนนเส้นหลักมากมาย ทั้งยังมีรถไฟฟ้าที่จะเปิดใช้บริการในอนาคตอีก ยิ่งทำให้พื้นที่นี้มีศักยภาพในการลงทุนสูง
								</p>
								<p class="mt-2">
									แต่หากใครสนใจซื้อที่อยู่อาศัยในหมู่บ้านปิ่นเกล้า สามารถติดต่อนายหน้าหาบ้านจาก The Best Property ได้เลย เราจะมาช่วยค้นหาบ้านแถวบ้านปิ่นเกล้า ที่ใช่กับไลฟ์สไตล์ของคุณ ไม่ว่าจะหาบ้านเดี่ยวปิ่นเกล้า หรือบ้านมือสองปิ่นเกล้า  โปรดไว้ใจบริการของเรา เพราะเราเชี่ยวชาญช่วยประเมินตรวจสอบคุณภาพบ้านบ้านปิ่นเกล้า  รวมไปถึงการวิเคราะห์ทำเลตลอดจนปิดการซื้อ-ขาย สนใจติดต่อได้ที่เบอร์โทร 02-047-4282 หรือแอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'ratchadapisek'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านรัชดา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โครงการบ้านรัชดา จัดเป็นย่านชั้นในเกือบใจกลางเมืองของกรุงเทพมหานคร สาเหตุที่รัชดาเป็นที่ที่เหมาะจะซื้อบ้านกรุงเทพสักหลัง เป็นเพราะรัชดานับเป็นเขต New CBD (Central Business District) หรือโซนธุรกิจเจเนอเรชันใหม่ของกรุงเทพฯ ทำให้มีสภาพการแข่งขันทางเศรษฐกิจสูง จึงมีโครงการอสังหาริมทรัพย์มากมาย อาทิ หมู่บ้าน คอนโดมิเนียม ทาวน์โฮม ทาวน์เฮ้าส์ แม้กระทั่งบ้านจัดสรร บ้านเดี่ยวรัชดา
								</p>
								<p class="mt-2">
									มาดูกันดีกว่าว่า ศักยภาพทำเลในย่านบ้านรัชดานี้มีอะไรที่น่าสนใจบ้าง ทั้งในด้านการเดินทาง การใช้ชีวิต ภาพรวมของทำเล และที่อยู่อาศัย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านรัชดา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การเดินทางหากมีบ้านแถวรัชดานั้นสะดวกมาก เนื่องจากพื้นนี้ที่ติดกับถนนที่ทอดไปถึงชั้นในของกรุงเทพฯ มีขนส่งสาธารณะพร้อมบริการทั่วทิศ ไม่ว่าจะเป็นรถโดยสารประจำทาง รถไฟฟ้า MRT สายสีน้ำเงิน และโครงการรถไฟฟ้าสายใหม่ที่จะเปิดในอนาคตไม่ไกล ทั้งยังมีทางด่วนพิเศษให้ผู้ใช้รถส่วนตัวเดินทางได้สะดวกด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												การเดินทางด้วยรถส่วนตัวแถวบ้านรัชดานั้นสะดวกมาก ถนนย่านนี้มีความยาวถึง 45 กิโลเมตร โดยถนนหลักๆ ที่แบ่งโซนกันชัดเจนจะมีถนนรัชดา - พระราม 9 (ถนนนสุขุมวิท, ถนนเพชรบุรี, ถนนพระราม 3, ถนนลาดพร้าว, ถนนวิภาวดีรังสิต, ถนนประชาชื่น, นนทบุรี) และถนนรัชดา - ท่าพระ (ถนนบางกรวย-ไทรน้อย, ถนนเพชรเกษม, ถนนจรัญสนิทวงศ์)
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												ใจกลางเมืองบ้านรัชดา จะมีรถไฟฟ้า MRT สถานีพระราม 9 ที่สามารถเดินทางไปรถไฟฟ้าสายสุขุมวิทเส้นหลักไม่กี่สถานี นอกจากนี้ในอนาคตจะมีรถไฟฟ้า MRT สายสีส้ม (ศูนย์วัฒนธรรมฯ – มีนบุรี) เป็นส่วนต่อขยายผ่านรัชดาอีกด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านรัชดา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ด้านการอยู่อาศัยของบ้านรัชดา จะรายล้อมไปด้วยสิ่งอำนวยความสะดวกที่ครบครัน ทั้งศูนย์การค้าระดับพรีเมี่ยม สถานศึกษาชั้นนำ และสถานรักษาทั้งของรัฐบาลและเอกชน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												ย่านการค้าในชุมชนนี้จะมีซุปเปอร์มาร์เก็ต อาทิ สยามจัสโก้, โรบินสัน, และบิ๊กซีซูเปอร์เซ็นเตอร์ ส่วนคอมมูนิตี้มอลล์ขนาดใหญ่จะมี Central Rama 9 และ Fotune Town
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2 mb-0">
												สถานศึกษาที่อยู่ใกล้รถไฟฟ้า MRT (ช่วงลาดพร้าว - พระราม 9) โดยเริ่มต้นจาก
											</p>
											<ul>
												<li>สถานีพระราม 9 จะมี โรงเรียนแม่พระฟาติมา</li>
												<li>สถานีศูนย์วัฒนธรรมฯ มีโรงเรียนอนุบาลลีนา</li>
												<li>สถานีห้วยขวาง มีโรงเรียนกุนนทีรุทธารามวิทยาคม กับโรงเรียนเตรียมอุดมศึกษาพัฒนาการ รัชดา</li>
												<li>สถานีสุทธิสาร มีโรงเรียนสมฤทัย</li>
												<li>สถานีรัชดาภิเษก มีโรงเรียนอนุบาลสัตย์สงวนอนุสรณ์, โรงเรียนปัญจทรัพย์ และโรงเรียนอนุบาลสัตย์สงวนอนุสรณ์</li>
												<li>สถานีลาดพร้าว มีโรงเรียนอนุบาลแย้มสอาด กับ โรงเรียนอนุบาลอาภาภิรมย์</li>
											</ul>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												หากพูดถึงสถานรักษาใกล้เคียงแถวบ้านรัชดามากที่สุด จะเป็นโรงพยาบาลเอกชนพระราม 9 ส่วนถ้าเป็นแถวรัชดา - ท่าพระ จะเป็น โรงพยาบาลรัชดา-ท่าพระ เลย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาย่านรัชดา ในอนาคต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ความคึกคักในหมู่บ้านรัชดายังคงต่อเนื่องและมีศักยภาพในการเติบโตประสิทธิภาพสูง เพราะย่านนี้เป็นชุมชนติดถนนชั้นในของกรุงเทพมหานคร ทำให้ย่านนี้เป็นที่น่าจับตามองทั้งในแง่ผู้ซื้อ นักลงทุน และผู้พัฒนาอสังหาริมทรัพย์ การเดินทางเข้า-ออกเมืองสะดวก เหมาะกับผู้อยู่อาศัยทุกๆ ไลฟ์สไตล์
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								เลือกไลฟ์สไตล์ดีๆ ใจกลางเมือง เลือกบ้านรัชดา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โซนบ้านรัชดา มีความสะดวกสบายด้านการอยู่อาศัยมานานแล้ว เพราะมีความเจริญด้านขนส่ง ห้างสรรพสินค้าใจกลางเมือง และยังมีรถไฟฟ้าสายสีใหม่เปิดภายในอนาคตข้างหน้า หากใครสนใจซื้อบ้าน บ้านรัชดานั้น ถือว่าเป็นตัวเลือกที่ดี จากทำเลที่อยู่แล้วครบเครื่องด้านไลฟ์สไตล์แน่นอน
								</p>
								<p class="mt-2">
									หากใครสนใจซื้อที่อยู่อาศัยในหมู่บ้านรัชดา สามารถติดต่อนายหน้าหาบ้านกับ The Best Property ได้เลย เราจะมาช่วยค้นหาบ้านรัชดา ที่ใช่กับไลฟ์สไตล์ของคุณ ไม่ว่าจะหาบ้านเดี่ยวรัชดา หรือบ้านมือสองรัชดา โปรดไว้ใจบริการของเรา เพราะเราเชี่ยวชาญ ช่วยประเมินตรวจสอบคุณภาพบ้านรัชดา รวมไปถึงวิเคราะห์ทำเลตลอดจนปิดการซื้อ-ขาย สนใจติดต่อได้ที่เบอร์โทร 02-047-4282 หรือ แอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'don-mueang'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านดอนเมือง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									โครงการบ้านดอนเมือง เป็นย่านที่อยู่อาศัย ที่จะมีทั้งคนในประเทศและต่างชาติอยู่มากที่สุดอีกหนึ่งเขต เพราะเป็นพื้นที่ติดกับสนามบินดอนเมือง ทำให้มีผู้คนมากมายมาทำธุระแถวนี้ค่อนข้างมาก ด้วยศักยภาพทำเลที่ใกล้กับสนามบิน จึงมีแหล่งขนส่งสาธารณะรวมไปถึงธุรกิจอสังหาริมทรัพย์มากมาย อาทิ บ้านเดี่ยวดอนเมือง ทาวน์โฮมดอนเมือง บ้านแฝดดอนเมือง และบ้านมือสองดอนเมืองประเภทต่างๆ เพื่อรองรับคนที่ประกอบอาชีพในสนามบินได้เช่าไว้อยู่อาศัย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางย่านดอนเมือง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									พูดถึงการเดินทางแถวบ้านดอนเมือง จะมีความสะดวก เข้า-ออกตัวเมืองและต่างจังหวัดได้ง่าย เพราะถนนดอนเมืองเชื่อมกับถนนเส้นย่อยกับเส้นหลักหลายเส้นทาง รวมไปถึงรถไฟฟ้าอีกด้วย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												การเดินทางรถส่วนตัวจากบ้านดอนเมืองจะมีถนนวิภาวดีรังสิต ที่สามารถเข้าสู่ถนนสุขุมวิทเส้นหลักในเมืองชั้นในได้สะดวก หรือถ้าจะออกไปต่างจังหวัดสามารถใช้เส้นถนนพหลโยธินตรงออกไปสู่นครนายก อยุธยาได้เลย
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												หากพูดถึงศูนย์กลางของบ้านดอนเมืองจะเป็นสนามบินดอนเมืองมีรถไฟฟ้าสายสีแดง (สถานีรังสิต - สถานีกลางบางซื่อ) ที่สามารถนั่งต่อรถไฟฟ้า MRT ใต้ดินสถานีบางซื่อเข้าตัวเมืองได้สะดวกสบาย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								สิ่งอำนวยความสะดวกย่านดอนเมือง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ศักยภาพของบ้านดอนเมืองรายล้อมไปด้วยคอมมูนิตี้มอลล์ ตลาด โรงพยาบาล และสถานศึกษาหลายแห่ง เนื่องจากย่านนี้เป็นชุมชนใกล้กับสนามบินประจำเขต ทำให้บรรยากาศความเป็นอยู่ในดอนเมือง กลายเป็นเขตชุมชนที่น่าอยู่ มีผู้อยู่อาศัยค่อนข้างมาก
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												ศูนย์การค้ารอบๆ แถวบ้านดอนเมืองจะมี Happy Avenue Don Mueang, เจ๊เล้ง ดอนเมือง ส่วนตลาดของชำ จะมี ตลาดใหม่ ดอนเมือง, ตลาดวัฒนานันท์ (ตลาดฝั่งโขง), ตลาดโฮโซนวัน ดอนเมือง และตลาดโกสุมรวมใจ
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถานศึกษาระดับเตรียมอุดมศึกษาแถวบ้านดอนเมืองจะมี โรงเรียนดอนเมืองจาตุรจินดา, โรงเรียนดอนเมืองทหารอากาศบำรุง, โรงเรียนบริบูรณ์ศิลป์ศึกษา, โรงเรียนสีกัน, โรงเรียนบำรุงรวิวรรณวิทยา, โรงเรียนประชาอุทิศ, โรงเรียนเปรมประชา, โรงเรียนพหลโยธิน, โรงเรียนวัดดอนเมือง, โรงเรียนวัดเวฬุวนาราม, โรงเรียนพระหฤทัยดอนเมือง,โรงเรียนธนินทรวิทยา, โรงเรียนนานาชาติฮาโรว์ และวิทยาลัยเทคนิคดอนเมือง
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												สถานพยาบาลที่ใกล้แถวบ้านดอนเมืองมากที่สุด จะมี โรงพยาบาลทหาร โรงพยาบาลภูมิพลอดุลยเดช โรงพยาบาลสีกัน และโรงพยาบาลมงกุฎวัฒนะ
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								การพัฒนาย่านดอนเมืองในอนาคต
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ลักษณะการอยู่อาศัยของหมู่บ้านดอนเมืองมีความสุขสบายไม่แพ้กับการอาศัยในเมืองชั้นในของกทม. ด้วยความที่พื้นที่เขตนี้ติดอยู่สนามบิน มีผู้คนเดินทางจากดอนเมืองไปยังเส้นทางในเมืองและนอกเมืองมากมาย จึงทำให้ที่นี่มีศักยภาพการลงทุนอสังหาริมทรัพย์สูง ย่านดอนเมืองแบ่งเขตออกเป็นสี่โซน ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li><b>โซนปทุมธานี</b> ฝั่งทิศเหนือของดอนเมือง มีถนนรังสิต - ปทุมธานีสามารถเข้าสู่ตัวเมืองได้ง่าย เขตนี้จะมีความโดดเด่นด้านร้านอาหารริมถนนตามซอยต่างๆ และร้านอาหารติดริมแม่น้ำเจ้าพระยาที่บรรยากาศดีมาก</li>
												<li><b>โซนสายไหม</b> ฝั่งทิศตะวันออกของดอนเมืองติดอยู่กับเส้นถนนพหลโยธินเข้าสู่ตัวเมืองหรือออกจากต่างจังหวัดไปฝั่งอยุธยาได้สะดวก</li>
												<li><b>โซนหลักสี่</b> ฝั่งทิศตะวันตกของดอนเมือง เป็นย่านที่พักอยู่อาศัยโดยเฉพาะ มีจุดเชื่อมต่อถึงตัวเมืองได้ผ่านการเปลี่ยนสายรถไฟฟ้า หรือนั่งรถส่วนตัวเข้ามาถนนชั้นในกทม. ได้ง่าย</li>
												<li><b>โซนนนทบุรี</b> ฝั่งทิศใต้ของดอนเมือง เป็นแถบเมืองกรุงเก่าของกรุงเทพฯ เป็นสถานที่ท่องเที่ยวเยี่ยมชมศิลปะเก่าแก่สไตล์เมืองนนท์</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ไลฟ์สไตล์สุดชิลที่บ้านดอนเมือง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									โซนบ้านดอนเมือง เป็นเขตที่ได้รับอิทธิพลมาจากสนามบินประจำพื้นที่ ทำให้ศักยภาพความเป็นอยู่ในเขตดอนเมืองนี้มีมูลค่าสูงขึ้นทุกๆ ปี นอกจากนี้การก่อตั้งรถไฟฟ้าสายสีแดงโดยตรงจากสนามบินดอนเมือง ทำให้อสังหาริมทรัพย์ในโซนนี้น่าลงทุนมากขึ้นไปอีก
								</p>
								<p class="mt-2">
									หากใครสนใจซื้อบ้านดอนเมือง สามารถติดต่อนายหน้าหาบ้านกับ The Best Property ที่จะมาช่วยค้นหาบ้านแถวดอนเมือง ราคาถูก ที่ใช่กับไลฟ์สไตล์ของคุณ ไม่ว่าจะหาบ้านเดี่ยวดอนเมืองสรงประภา หรือ บ้านเดี่ยวดอนเมืองหลังสี่ โปรดไว้ใจบริการของเรา เพราะเราเชี่ยวชาญ ช่วยประเมินตรวจสอบคุณภาพราคาขายบ้านดอนเมือง รวมไปถึงการวิเคราะห์ทำเล ตลอดจนปิดการซื้อ-ขาย สนใจติดต่อได้ที่เบอร์โทร 02-047-4282 หรือ แอดไลน์ @thebestproperty
								</p>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'prawet'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								โครงการบ้านประเวศ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									สำหรับผู้ที่ชอบการอาศัยอยู่ในเมืองก็อาจเล็งโครงการบ้านเดี่ยวในตัวเมืองไว้แต่ก็มักจะพบว่าราคาบ้านในตัวเมืองนั้นสูงมาก อีกทั้งหายากมาก ๆ ด้วย เขตประเวศเป็นย่านที่ขยับออกมาจากตัวเมืองอยู่บ้างแต่กลับมีความครึกครื้นอย่างมาก มีแหล่งท่องเที่ยวชอปปิงมากมาย เรื่องการเดินทางก็สามารถเดินทางเข้าตัวเมืองหรือออกต่างจังหวัดได้ง่ายมาก ไม่ว่าจะเดินทางด้วยรถส่วนตัว ขนส่งสาธารณะเช่น รถโดยสารประจำทาง รถไฟฟ้าแอร์พอร์ตเรลลิงก์ รถไฟฟ้าสายสีเขียวและสายสีเหลือง (ลาดพร้าว-สำโรง) ที่จะพาคุณเข้าสู่ตัวเมืองได้อย่างรวดเร็วและสะดวกสุด ๆ อีกทั้งยังมีราคาถูกกว่าบ้านในตัวเมืองหลายเท่า ทำให้โครงการบ้านประเวศที่มีราคาไม่แรงนั้นเป็นตัวเลือกที่น่าสนใจไม่น้อย
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ บ้านประเวศ บ้านเดี่ยว บ้านมือสอง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									เขตประเวศนั้นจะแบ่งเขตการปกครองออกเป็น 3 แขวง ได้แก่
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>แขวงประเวศ ตั้งอยู่ตอนบนของเขตประเวศ ติดกับเขตสะพานสูง เขตสวนหลวง และเขตลาดกระบัง ที่แขวงประเวศมีถนนอ่อนนุช-ลาดกระบังตัดผ่านทำให้สามารถเดินทางไปเขตอ่อนนุชและเดินทางเข้าเมืองได้สะดวก ราคาบ้านมือสองทาวน์เฮ้าส์ในแขวงประเวศนี้ราคาเริ่มต้นจะอยู่ที่ประมาณ 2 ล้านบาทเท่านั้น</li>
												<li>แขวงดอกไม้  ตั้งอยู่ฝั่งตะวันออกของเขตประเวศ ติดกับเขตลาดกระบัง และอำเภอบางพลี จังหวัดสมุทรปราการ สำหรับใครที่ทำงานแถวสมุทรปราการแต่ยังอยากอยู่ในกรุงเทพ แขวงดอกไม้เขตประเวศก็เป็นที่ที่น่าสนใจไม่น้อย ราคาบ้านมือสองทาวน์เฮ้าส์ในแขวงดอกไม้ราคาเริ่มต้นอยู่ที่ประมาณ 2 ล้านบาท</li>
												<li>แขวงหนองบอน ตั้งอยู่ฝั่งตะวันตกของเขตประเวศ ติดกับเขตพระโขนง เขตบางนา และเขตสวนหลวง แขวงหนองบอนเป็นแขวงในเขตประเวศที่ใกล้กับตัวเมืองที่สุด และในย่านนี้มีความคึกคักมากที่สุดไม่ว่าจะเป็นแหล่งชอปปิง ตลาด ห้างสรรพสินค้ามากมาย อีกทั้งเร็ว ๆ นี้กำลังจะมีรถไฟฟ้าสีเหลืองพาดผ่าน ทำให้การเดินทางเข้าตัวเมืองทำได้ง่ายขึ้นอีกด้วย ซึ่งราคาบ้านมือสองทาวน์เฮ้าส์แขวงหนองบอนจะเริ่มต้นอยู่ที่ 2 ล้านบาทเท่านั้น</li>
											</ul>
											<p class="mt-2">
												จะเห็นได้ว่าทั้งราคาโครงการบ้านทั้งสามแขวงเขตประเวศนั้นจะไม่ต่างกันมากนัก เพราะก็นับว่ายังอยู่ในเขตประเวศเหมือนกันและยังคงเข้าถึงสถานที่สำคัญหลายแห่งในเมืองได้ไม่ยาก
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								การเดินทางในเขตประเวศ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									การเดินทางในเขตประเวศนั้นสามารถเดินทางได้สะดวกมาก ๆ ไม่ว่าจะเดินทางเข้าสู่ตัวเมือง หรือจะเดินทางออกต่างจังหวัดก็ทำได้ทั้งนั้น มีถนนเชื่อมต่อหลายเขตหลายสาย มีรถไฟฟ้าที่จะพาคุณเข้าสู่ตัวเมืองได้ในเวลาอันสั้น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												เดินทางง่ายด้วยรถส่วนตัว
											</h3>
											<p class="mt-2">
												ที่เขตประเวศมีถนนที่เชื่อมต่อกับเขตอื่น ๆ ใกล้เคียงอยู่หลายสาย ยกตัวอย่างเช่น หากต้องการเดินทางไปเขตลาดกระบังก็สามารถใช้ถนนอ่อนนุช-ลาดกระบังได้เลย หากต้องการเข้าตัวเมืองหรือออกไปสมุทรปราการก็สามารถใช้ถนนมอเตอร์เวย์ที่อยู่ตรงแขวงดอกไม้ หรือจะใช้ทางพิเศษศรีรัชเข้าตัวเมืองผ่านแขวงสวนหลวง แขวงบางกะปิก็ได้เช่นกัน
											</p>

											<h3 class="mt-3">
												เดินทางสะดวกด้วยรถไฟฟ้า
											</h3>
											<p class="mt-2">
												การเดินทางด้วยรถไฟฟ้าในปัจจุบันเป็นวิธีการเดินทางที่สะดวก รวดเร็ว ผู้คนนิยมใช้บริการมากที่สุด ซึ่งเขตบ้านประเวศก็มีรถไฟฟ้าตัดผ่านอยู่หลายสายไม่ว่าจะเป็นแอร์พอร์ตเรลลิงก์ รถไฟฟ้าสายสีเขียว และในเร็ว ๆ นี้ก็จะมีรถไฟฟ้าสายสีเหลืองให้บริการเพิ่มอีกสาย ทำให้บ้านประเวศเป็นย่านทำเลดีที่ไม่ควรพลาด
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ความโดดเด่นย่านเขตประเวศ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									หากคุณกำลังลังเลอยู่ว่าจะหาซื้อบ้านประเวศ หรือหาบ้านเช่าประเวศดีหรือไม่ เราขอแนะนำความโดดเด่นของย่านเขตประเวศที่หากคุณได้อ่านแล้วอาจตัดสินใจย้ายมาอยู่บ้านประเวศง่ายขึ้น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ศูนย์การค้าใกล้เคียง
											</h3>
											<p class="mt-2">
												ถึงแม้ว่าเขตประเวศจะเป็นเขตที่อยู่ชานเมืองของกรุงเทพ แต่กลับมีความเจริญแทบจะไม่ต่างจากในเมืองเลย โดยศูนย์การค้าที่อยู่ใกล้เคียงที่หากคุณมีบ้านประเวศก็สามารถเดินทางไปได้ไม่ไกลมีหลายที่มาก ยกตัวอย่างเช่น ซีคอนสแควร์ พาราไดซ์เพลส พาราไดซ์พาร์ค ธัญญาพาร์ค โลตัสอ่อนนุช โลตัสบางนาตราด เมกาบางนา เซ็นทรัลบางนา และในอนาคตก็กำลังจะมีห้างสรรพสินค้าใหม่อยู่ที่สี่แยกบางนา สำหรับชาวเขตบ้านประเวศก็สามารถเดินทางมาได้ไม่ยากเลย
											</p>

											<h3 class="mt-3">
												สถานศึกษาที่ใกล้เคียง
											</h3>
											<p class="mt-2">
												เพราะเขตบ้านประเวศเป็นเขตที่พักอาศัย มีชุมชนและหมู่บ้านค่อนข้างมาก ทำให้มีสถานศึกษาที่อยู่ใกล้เคียงกับเขตประเวศมากมาย เช่น โรงเรียนเตรียมอุดมศึกษาพัฒนาการ โรงเรียนราชวินิตบางแก้ว โรงเรียนอนุบาลจินดาพร โรงเรียนมัธยมสุวิทย์เสรีอนุสรณ์ โรงเรียนฝึกอาชีพกรุงเทพมหานคร (ประเวศ) โรงเรียนลาซาล โรงเรียนเซนต์โยเซฟบางนา เป็นต้น
											</p>

											<h3 class="mt-3">
												สถานพยาบาลที่ใกล้เคียง
											</h3>
											<p class="mt-2 mb-0">
												ก่อนจะตัดสินใจเลือกซื้อบ้านประเวศหรือหาบ้านเช่าประเวศควรจะดูก่อนว่ามีสถานพยาบาลหรือไม่ เพราะการเจ็บป่วยมักเกิดขึ้นโดยไม่ตั้งใจ หากเกิดป่วยหรือบาดเจ็บขึ้น การที่มีบ้านใกล้สถานพยาบาลหรือเดินทางไปสถานพยาบาลสะดวกก็จะสะดวกมากขึ้น
											</p>
											<p class="mt-2">
												ในเขตประเวศเองก็มีสถานพยาบาลทั้งคลินิกและโรงพยาบาลมากมายที่สามารถเดินทางจากบ้านประเวศไปได้ไม่ยาก เช่น โรงพยาบาลสิรินธร โรงพยาบาลสมิติเวชศรีนครินทร์ โรงพยาบาลวิภาราม พัฒนาการ โรงพยาบาลสินแพทย์ ศรีนครินทร์ โรงพยาบาลศิครินทร์ เป็นต้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								เขตประเวศ ย่านกำลังพัฒนา
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									เขตประเวศเป็นเขตชานเมืองของกรุงเทพมหานครที่กำลังจะกลายเป็นย่านสำหรับรองรับการขยายตัวของประชากรที่หลั่งไหลเข้ามาอาศัยในกรุงเทพฯ มากขึ้น โดยพื้นที่เขตประเวศนั้นเป็นเขตที่มีถนนและเส้นทางเชื่อมต่อเข้าสู่ตัวเมืองง่าย ๆ ไม่ว่าจะเป็นทางด่วนหรือรถไฟฟ้า ทำให้ย่านเขตประเวศเป็นที่คึกคักขึ้นอย่างมาก
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												อีกทั้งยังมีรถไฟฟ้าสายใหม่อย่างรถไฟฟ้าสีเหลืองที่เชื่อมเขตประเวศมุ่งเข้าสู่ย่านลาดพร้าวซึ่งเป็นอีกหนึ่งย่ายที่มีสถานที่สำคัญมากมาย ทำให้ผู้รับเหมา เจ้าของโครงการบ้านที่พักอาศัยได้เข้ามาลงทุนและสร้างโครงการบ้านเดี่ยวในเขตประเวศ หรือแม้แต่โครงการอาคารชุด คอนโดมิเนียมก็เริ่มเข้ามามากขึ้น และเมื่อเขตประเวศกำลังเป็นที่น่าสนใจทำให้มีธุรกิจร้านค้าเกิดขึ้นมากมาย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								“บ้านประเวศ” สะดวกสบาย ตอบโจทย์ทุกไลฟ์สไตล์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									บ้านประเวศเป็นอีกหนึ่งทางเลือกสำหรับผู้ที่ต้องการความสะดวกแบบในตัวเมืองอย่างครบครัน เพราะที่เขตประเวศมีครบทุกอย่างไม่ว่าจะเป็นแหล่งชอปปิง ห้างสรรพสินค้าต่าง ๆ โรงเรียน โรงพยาบาล เรียกว่าไม่ต้องเดินทางไปไหนไกลบ้านเลย
								</p>
								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												อีกทั้งในขณะนี้ราคาบ้านประเวศยังไม่สูงมากเนื่องจากเป็นพื้นที่ที่กำลังจะพัฒนา หากใครสนใจไม่ควรรอช้า รีบจับจองโครงการบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม ทาวน์เฮ้าส์เขตประเวศราคาถูกได้ที่ The Best Property เรามีบ้านประเวศและคอนโดทำเลดีให้เลือกมากมาย สนใจติดต่อเราได้ที่
											</p>
											<ul>
												<li><b>Line:</b> @thebestproperty</li>
												<li><b>Website:</b> <a href="https://tb.co.th/">https://tb.co.th/</a></li>
												<li><b>Tel:</b> <a href="tel:020474282">02-047-4282</a></li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'search'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyListItem from '~/components/2.0/property-list-item'
import propertyListItemSkeleton from '~/components/2.0/property-list-item-skeleton'

export default {
	// scrollToTop: true,
	name: 'LIST',
	layout: 'default_2',

	components: {
		searchForm,
		propertyListItem,
		propertyListItemSkeleton
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let params = context.params
		let content = params.area || params.category || null
		let query = {}
		let widgetQuery = {}

		const market_selected = params.category === 'singlehome' ? 'HOME' : params.category === 'townhome' ? 'TOWNHOUSE' : params.category === 'condo' ? 'CONDO' : 'COMMERCIAL_BUILDING'

		// Category
		if (content === 'singlehome') {
			data['title'] = 'รวมโครงการ บ้านเดี่ยวกรุงเทพ บ้านเดี่ยวมือสอง บ้านจัดสรร ซื้อ ขาย ราคาถูก'
			data['description'] = 'รวมประกาศขายบ้าน โครงการ ปี 2565 หมู่บ้าน บ้านเดี่ยวกรุงเทพ บ้านเดี่ยวมือสอง บ้านจัดสรร พร้อมที่ดิน ซื้อ ขาย ดูบ้าน ราคาถูก'

			query = widgetQuery = {
				province: 1,
				market_selected: 'HOME'
			}
		}
		else if (content === 'townhome') {
			data['title'] = 'รวมประกาศ ซื้อ ขาย โครงการบ้าน ทาวน์โฮมกรุงเทพ ทาวน์เฮ้าส์  มือสอง ราคาถูก'
			data['description'] = 'รวมประกาศ ซื้อ ขาย โครงการบ้าน ทาวน์โฮมกรุงเทพ ทาวน์เฮ้าส์ Townhome Townhouse 2 ชั้น 3 ชั้น  มือสอง ราคาถูก พร้อมอยู่'

			query = widgetQuery = {
				province: 1,
				market_selected: 'TOWNHOUSE'
			}
		}
		else if (content === 'condo') {
			data['title'] = 'รวมประกาศ ซื้อ ขาย โครงการ คอนโดกรุงเทพ คอนโดมิเนียม  มือสอง ราคาถูก'
			data['description'] = 'รวมประกาศ ซื้อ ขาย โครงการ คอนโดกรุงเทพ Condo คอนโดมิเนียม มือสอง ราคาถูก หาคอนโด สวยๆ ใกล้รถไฟฟ้า ทำเลดี พร้อมอยู่ มีให้ที่นี่'

			query = widgetQuery = {
				province: 1,
				market_selected: 'CONDO'
			}
		}
		else if (content === 'shophouse') {
			data['title'] = 'ประกาศ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์กรุงเทพ ตึกแถว มือสอง ทำเลค้าขาย'
			data['description'] = 'ประกาศ  ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์กรุงเทพ ตึกแถว บ้านตึก มือสอง ทำเลดี ริมถนน ทำเลค้าขาย ราคาถูก พร้อมรายละเอียด ข้อมูล'

			query = widgetQuery = {
				province: 1,
				market_selected: 'COMMERCIAL_BUILDING'
			}
		}

		// Area
		else if (content === 'ratchaphruek') {
			data['title'] = 'บ้านราชพฤกษ์ โครงการใหม่ ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม'
			data['description'] = 'รวมโครงการใหม่ทาวเฮ้าส์ บ้านเดี่ยว โซน  บ้านราชพฤกษ์ - พระราม 5 มือหนึ่ง มือสอง ราคาพิเศษที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [108, 124,125,126,127,129, 155,156,158, 199, 308,310,314,315,347,349,350,351, 356,360,361,391]
			}
		}
		else if (content === 'rama-2') {
			data['title'] = 'บ้านพระราม2 รวมโครงการ ซื้อ ขาย ทาวน์โฮม บ้านเดี่ยว บ้านมือสอง'
			data['description'] = 'โครงการบ้าน ย่านพระราม2 รวมทาวเฮ้าส์ บ้านเดี่ยว มือหนึ่ง มือสอง ที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [147,149,152,198,200,217,234,235,236,294,296,7308,7317,7280,7281,7282,7283,7284,7285,7286,7287,7288,7289,7290,7291,7292,7293,7294,7295,7296,7297,7324,7328,7329,6925]
			}
		}
		else if (content === 'ladprao') {
			data['title'] = 'บ้านลาดพร้าว ขาย บ้านเดี่ยว โครงการใหม่ ทาวน์โฮม บ้านมือสอง ย่านลาดพร้าว สภาพดี'
			data['description'] = 'รวมโครงการใหม่ ทาวเฮ้าส์ บ้านเดี่ยว โซน  ลาดพร้าว  มือหนึ่ง มือสอง ราคาพิเศษที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [223,179,181,182,13,43,50,40,178,172,209,210,225,118]
			}
		}
		else if (content === 'phaholyothin') {
			data['title'] = 'บ้านพหลโยธิน บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม โครงการใหม่ ทำเลใกล้รถไฟฟ้า'
			data['description'] = 'รวมบ้านใกล้รถไฟฟ้า ย่านพหลโยธิน บ้านเดี่ยว บ้านมือสอง ราคาดีที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [181,182,183,179,180,203,40,34,99,220,222,367,368,374,366,394,395,496,570,571,565,562,564]
			}
		}
		else if (content === 'ramintra') {
			data['title'] = 'บ้านรามอินทรา โครงการใหม่ ซื้อ บ้านเดี่ยว บ้านมือสอง ทำเลคุณภาพ'
			data['description'] = 'โครงการใหม่ ย่าน รามอินทรา ซื้อ ขาย บ้านเดี่ยว บ้านมือสอง ราคาพิเศษที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [396,226,228,227,223,43,50,34,40,172,174,73,209,210,224,220,221,222,219]
			}
		}
		else if (content === 'lat-krabang') {
			data['title'] = 'บ้านลาดกระบัง รวมโครงการบ้านเดี่ยว ทาวน์โฮม ใกล้สนามบิน'
			data['description'] = 'รวมโครงการใหม่ ทาวเฮ้าส์ บ้านเดี่ยว โซนลาดกระบัง  มือหนึ่ง มือสอง ราคาดีที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [187,74,80,83,82,81,84,26,1467,1470,1428,1427,270,269,272,276,277,298,299,300]
			}
		}
		else if (content === 'saimai') {
			data['title'] = 'บ้านสายไหม รวมโครงการ หมู่บ้านย่านสายไหม ตอบโจทย์ทุกการใช้ชีวิต'
			data['description'] = 'รวมทุกโครงการที่พักอาศัยบ้านสายไหม บ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม มือหนึ่ง และมือสอง ราคาดีที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [220,221,222,40,34,226,395]
			}
		}
		else if (content === 'onnut') {
			data['title'] = 'บ้านอ่อนนุช ซื้อ ขาย บ้านเดี่ยว ทาวน์โฮม ครบครันทุกความต้องการ'
			data['description'] = 'รวมไว้ในที่เดียว ครบ จบ ไม่ว่าจะบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม คอนโด มือหนึ่ง และมือสอง ย่านอ่อนนุช ราคาพิเศษที่ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [65,193,213,189,188,187,190,84,80,81,197,276,299,1428,1427]
			}
		}
		else if (content === 'ramkhamhaeng') {
			data['title'] = 'รวมโครงการบ้านรามคำแหง บ้านเดี่ยว บ้านมือสอง ทำเลทอง ครบครันทุกเรื่องของชีวิตคนเมือง'
			data['description'] = 'บ้านรามคำแหง ไม่ว่าจะบ้านเดี่ยว ทาวน์เฮ้าส์ ทาวน์โฮม หรือคอนโด รวบไว้ที่นี่หมด ในราคาสุดคุ้มกับ The Best Property'

			query = widgetQuery = {
				market_selected,
				sub_district: [73,74,43,50,224,173,189,81,197,228,229,230,223,225]
			}
		}
		else if (content === 'phra-ram-nine') {
			data['title'] = 'บ้านพระราม 9 ย่านคนติดเมือง เที่ยว ช้อป ทำงาน ตอบโจทย์พักอาศัย'
			data['description'] = 'บ้านพระราม 9 มีสิ่งอำนวยความสะดวก คมนาคม สถานที่ท่องเที่ยว ที่รักษา ที่ไหนบ้างในย่านพระราม 9 ดูเนื้อหาเพิ่มเติมในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [50,115,116,187,81,197,224]
			}
		}
		else if (content === 'min-buri') {
			data['title'] = 'บ้านมีนบุรี เขตชานเมืองฝั่งตะวันออก น่าอยู่ ศักยภาพการพัฒนาสูง'
			data['description'] = 'เจาะหาคอนโด บ้านเดี่ยว บ้านมือสองในเขตมีนบุรี จะมีสิ่งอำนวยความสะดวก สถานที่บริการอะไรบ้าง เจาะเนื้อหาเกี่ยวกับพื้นที่แห่งนี้ ดูเพิ่มเติมได้ในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [226,227,229,230,228,73,74,21,24,25]
			}
		}
		else if (content === 'suanluang') {
			data['title'] = 'บ้านสวนหลวง ชานเมืองตะวันออก น่าอยู่ไม่แพ้ตัวเมือง'
			data['description'] = 'เขตบ้านสวนหลวง จะมีสิ่งอำนวยความสะดวก และแหล่งคมนาคมในอนาคตบนถนนศรีนครินทร์อะไรบ้าง ลองดูเนื้อหาเพิ่มเติมได้ในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [197,189,187,188,190]
			}
		}
		else if (content === 'prakanong') {
			data['title'] = 'บ้านพระโขนง ทำเลศักยภาพ ใกล้เมือง เดินทางสะดวก'
			data['description'] = 'เขตบ้านพระโขนง จะมีสิ่งอำนวยความสะดวก และแหล่งคมนาคมในอนาคตบนถนนสุขุมวิทอะไรบ้าง ลองดูเนื้อหาเพิ่มเติมได้ในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [65,191,193]
			}
		}
		else if (content === 'ra-ma-three') {
			data['title'] = 'บ้านพระราม 3 ซื้อ ขาย บ้านทำเลใกล้เมือง เดินทางสะดวก'
			data['description'] = 'เขตบ้านพระราม 3 จะมีสิ่งอำนวยความสะดวก และแหล่งคมนาคมอะไรบ้างในอนาคต บนถนนพระราม 3 ดูเนื้อหาเพิ่มเติมได้ในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [234,235,88,89,280,284,292]
			}
		}
		else if (content === 'pinklao') {
			data['title'] = 'รวมโครงการบ้านปิ่นเกล้า บ้านเดี่ยว ทำเลดีมีรถไฟเปิดถึง 3 สาย'
			data['description'] = 'เขตบ้านปิ่นเกล้า จะมีสิ่งอำนวยความสะดวก และแหล่งคมนาคมในอนาคตบนบ้านปิ่นเกล้าอะไรบ้าง ลองดูเนื้อหาเพิ่มเติมได้ในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [168,169,170,124,125,233,139,311,319,317,312,318,315,316,313,314,320,324,7264,7265,7263,7270,7208,7214]
			}
		}
		else if (content === 'ratchadapisek') {
			data['title'] = 'บ้านรัชดา รวมโครงการบ้านเดี่ยว ทาวน์โฮม บ้านมือสอง ราคาดี'
			data['description'] = 'เขตบ้านรัชดา จะมีสิ่งอำนวยความสะดวก และแหล่งคมนาคมในอนาคตบนถนนรัชดาภิเษกอะไรบ้าง ลองดูเนื้อหาเพิ่มเติมได้ในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [179,181,182,191,223,171,235,110,109,108,178,88,225,116,115,118]
			}
		}
		else if (content === 'don-mueang') {
			data['title'] = 'บ้านดอนเมือง รวมบ้านเดี่ยว บ้านมือสอง ขนส่งสะดวก ถึงเขตกทม.'
			data['description'] = 'เขตบ้านดอนเมือง จะมีสิ่งอำนวยความสะดวก และแหล่งคมนาคมในอนาคตบนถนนดอนเมืองอะไรบ้าง ลองดูเนื้อหาเพิ่มเติมได้ในบทความนี้'

			query = widgetQuery = {
				market_selected,
				sub_district: [203,40,34,222,366,394]
			}
		}
		else if (content === 'prawet') {
			data['title'] = ' โครงการบ้านประเวศ ย่านน่าอยู่ ทำเลดี เดินทางสะดวก'
			data['description'] = 'โครงการบ้านประเวศ ย่านกำลังพัฒนาที่เหมาะกับการอยู่อาศัย ตอบโจทย์ทุกกลุ่มไลฟ์สไตล์ สนใจซื้อบ้านเดี่ยว ทาวน์โฮม ทาวน์เฮ้าส์ คอนโดมิเนียมย่านประเวศ คลิกเลย'

			query = widgetQuery = {
				market_selected,
				sub_district: [188,187,189,190]
			}
		}

		widgetQuery = { ...query }

		await context.store.dispatch('page/initial', data)

		return {
			params, content, query, widgetQuery,
			areaSelected: params.area
		}
	},

	data:() => ({
		location: 'กรุงเทพฯ',
		keepAliveActivated: false,
		loading: true,
		empty: false,
		perPage: 12,
		propertyList: [],
		queryTxt: '',
		page: 1,
		total: 0,
	}),

	computed: {
		...mapGetters({
			getProperty: 'property/getProperty',
			head: 'page/head',
		}),

		bannerImg () {
			return '/images/2.0/all-project-banner.jpg'
		},

		category () {
			if (this.content || this.content && ['singlehome','townhome','condo', 'shophouse'].includes(this.content)) {
				return [
					{ text: 'บ้านเดี่ยว', path: '/bangkok/singlehome' },
					{ text: 'ทาวน์โฮม', path: '/bangkok/townhome' },
					{ text: 'คอนโด', path: '/bangkok/condo' },
					{ text: 'อาคารพาณิชย์', path: '/bangkok/shophouse' },
				]
			}

			return null
		},

		area () {
			if (this.content && [
				'singlehome', // 'townhome','condo', 'shophouse',
				'ratchaphruek', 'rama-2', 'ladprao', 'phaholyothin', 'ramintra',
				'lat-krabang', 'saimai', 'onnut', 'ramkhamhaeng',
				'phra-ram-nine', 'min-buri', 'suanluang', 'prakanong',
				'ra-ma-three', 'pinklao', 'ratchadapisek', 'don-mueang',
				'prawet'
			].includes(this.content)) {
				return [
					{ text: 'ราชพฤกษ์', path: `/bangkok/${this.params.category}/ratchaphruek`, value: 'ratchaphruek' },
					{ text: 'พระราม2', path: `/bangkok/${this.params.category}/rama-2`, value: 'rama-2' },
					{ text: 'ลาดพร้าว', path: `/bangkok/${this.params.category}/ladprao`, value: 'ladprao' },
					{ text: 'พหลโยธิน', path: `/bangkok/${this.params.category}/phaholyothin`, value: 'phaholyothin' },
					{ text: 'รามอินทรา', path: `/bangkok/${this.params.category}/ramintra`, value: 'ramintra' },
					{ text: 'ลาดกระบัง', path: `/bangkok/${this.params.category}/lat-krabang`, value: 'lat-krabang' },
					{ text: 'สายไหม', path: `/bangkok/${this.params.category}/saimai`, value: 'saimai' },
					{ text: 'อ่อนนุช', path: `/bangkok/${this.params.category}/onnut`, value: 'onnut' },
					{ text: 'รามคำแหง', path: `/bangkok/${this.params.category}/ramkhamhaeng`, value: 'ramkhamhaeng' },
					{ text: 'พระราม 9', path: `/bangkok/${this.params.category}/phra-ram-nine`, value: 'phra-ram-nine' },
					{ text: 'มีนบุรี', path: `/bangkok/${this.params.category}/min-buri`, value: 'min-buri' },
					{ text: 'สวนหลวง', path: `/bangkok/${this.params.category}/suanluang`, value: 'suanluang' },
					{ text: 'พระโขนง', path: `/bangkok/${this.params.category}/prakanong`, value: 'prakanong' },
					{ text: 'พระราม 3', path: `/bangkok/${this.params.category}/ra-ma-three`, value: 'ra-ma-three' },
					{ text: 'ปิ่นเกล้า', path: `/bangkok/${this.params.category}/pinklao`, value: 'pinklao' },
					{ text: 'รัชดา', path: `/bangkok/${this.params.category}/ratchadapisek`, value: 'ratchadapisek' },
					{ text: 'ดอนเมือง', path: `/bangkok/${this.params.category}/don-mueang`, value: 'don-mueang' },
					{ text: 'ประเวศ', path: `/bangkok/${this.params.category}/prawet`, value: 'prawet' },
				]
			}

			return null
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},
	},

	watch: {
		page (newPage) {
			// this.$refs.top.scrollIntoView({ /*behavior: 'smooth',*/ block: 'center' })
			this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'end' })

			this.query.page = newPage
			this.search()
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			this.search()
		}
	},

	created() {
		if (process.client) {
			this.search()
		}
	},

	mounted() {

	},

	methods: {
		...mapActions({
			getPropertyList: 'property/getPropertyList',
			searchProperty: 'property/searchProperty'
		}),
		...mapMutations({
			searchToggle: 'page/searchToggle'
		}),

		search () {
			// if (this.loading) return
			this.loading = true
			this.propertyList = []
			this.total = 0
			// Call to store action for search with query (GET parameter)
			let params = {
				...this.query,
				ipp: this.perPage // item per page
			}

			this.$nextTick(() => {
				// window.scrollTo(0, 0)
				this.$refs.topPage.scrollIntoView({ behavior: 'smooth', block: 'end' })
			})

			this.searchProperty(params).then(propObj => {
				this.propertyList = propObj.propsList
				this.total = propObj.total
				this.queryTxt = propObj.queryTxt
				this.perPage = propObj.perPage

				this.empty = this.propertyList.length === 0
				this.page = parseInt(this.query.page) || 1
				this.loading = false
				this.keepAliveActivated = true
			})
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	padding: 32px 0 60px 0;

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgba(157,30,37,1);
	}

	.category-menu {
		position: relative;

		&::before {
			content: ' ';
			position: absolute;
			background: #fff;
			left: -24px;
			right: 0;
			top: -32px;
			bottom: -60px;
		}
		&::after {
			content: ' ';
			position: absolute;
			z-index: 0;
			width: 150vw;
			left: -84px;
			top: 0;
			bottom: 0;
			background: rgb(237,28,36);
		}

		& > div {
			position: relative;
			z-index: 1;
		}
	}
}
.area:hover, .area.v-btn--active {
	background-color: #3a3a3a;
	color: #fff;
}
.widget-btn .v-btn:hover {
	background-color: rgb(237,28,36);
	color: #fff;
	border-color: rgb(237,28,36);
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	p {
		text-indent: 30px;
	}

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
